var _rect, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRecipientsGrayscale(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 141,
    viewBox: "0 0 76 141",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_178_106071",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 76,
    height: 141
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 75.5722,
    height: 141,
    rx: 10,
    fill: "#F0F3F9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_178_106071)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M77.5066 109.83C77.5066 109.83 84.2649 121.834 70.3558 155.544L90.097 210.243C90.097 210.243 35.1377 225.671 1.23062 212.412C1.23062 212.412 7.81149 161.478 25.6934 105.997H41.2413L38.2297 96.0117C38.2297 96.0117 67.2335 115.193 77.5063 109.83H77.5066Z",
    fill: "#CAD4E3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.4047 110.169C77.4254 110.082 77.3581 110.082 77.0842 110.126C76.9357 110.15 76.7362 110.183 76.5239 110.233C76.3048 110.268 76.0609 110.319 75.7877 110.357C74.3429 110.555 72.8783 110.563 71.4315 110.379C67.9373 109.997 63.6585 108.603 60.191 107.128C54.4739 104.491 48.93 101.493 43.5928 98.1523C42.6968 97.5728 41.7719 97.0392 40.8217 96.5536C40.078 96.2012 39.3603 95.7965 38.6739 95.3426L38.6689 95.3394C38.5301 95.2495 38.3672 95.2043 38.2019 95.2099C38.0367 95.2156 37.8772 95.2718 37.745 95.371C37.6127 95.4702 37.514 95.6076 37.4623 95.7646C37.4106 95.9216 37.4083 96.0907 37.4557 96.2491L37.5875 96.6911C38.6058 100.312 39.4846 103.336 40.3462 106.271L41.2402 105.067C36.5264 105.032 31.9904 105.019 25.6923 104.925C25.4682 104.922 25.2487 104.99 25.0659 105.12C24.883 105.249 24.7463 105.434 24.6754 105.647L24.6676 105.672L24.1258 107.308L21.8819 114.756C21.531 115.876 21.224 116.958 20.9177 118.014L20.0055 121.12C19.4075 123.167 18.7688 125.177 18.1444 127.34L16.075 134.393C15.6201 135.993 15.2746 137.408 14.9534 138.721L14.0583 142.466L13.1678 146.211C12.8661 147.529 12.5324 148.946 12.1349 150.562L10.0921 158.306C9.46776 160.667 8.84158 162.83 8.27739 164.917C7.30536 170.393 5.91444 177.542 5.32532 182.167C4.94918 184.309 4.63895 185.747 4.3458 187.089C4.06086 188.433 3.78624 189.679 3.4646 191.435C3.14404 193.244 3.02472 194.379 2.89471 195.511C2.76471 196.644 2.63327 197.776 2.3501 199.589C2.08794 201.173 1.85537 202.343 1.62812 203.442C1.40978 204.542 1.19606 205.571 0.965248 206.871C0.69989 208.613 0.433464 210.397 0.179153 212.285C0.147888 212.518 0.195435 212.754 0.314178 212.956C0.432922 213.158 0.616013 213.315 0.834183 213.401L0.840942 213.403C5.29961 215.104 9.91093 216.375 14.6118 217.197C19.2225 218.011 23.8753 218.566 28.5482 218.859C32.1101 218.984 35.9241 219.05 39.8945 218.924C43.8649 218.811 47.9949 218.574 52.1957 218.201C60.7101 217.437 69.1737 216.185 77.5451 214.453C80.3212 213.944 83.9518 213.09 85.82 212.766C87.3291 212.356 88.8497 211.936 90.4326 211.466L90.4764 211.454C90.6321 211.407 90.7773 211.331 90.9035 211.229C91.0298 211.127 91.1346 211.001 91.2121 210.858C91.2896 210.715 91.3382 210.558 91.3552 210.397C91.3721 210.235 91.3571 210.072 91.3109 209.916C91.3017 209.885 91.2903 209.852 91.2792 209.823C86.4226 197.23 81.4385 183.03 77.8176 172.037C76.5563 168.997 75.8475 166.776 74.598 163.247C73.175 159.524 72.2589 157.619 71.2107 155.241L71.1957 155.9C71.5102 154.896 71.8618 153.813 72.3166 152.514L72.9934 150.718C73.2071 150.148 73.4076 149.609 73.5579 149.1C73.8753 148.087 74.1207 147.24 74.2614 146.636C74.5107 146.031 74.7772 145.354 75.0553 144.633L75.2651 144.083L75.4553 143.511L75.8422 142.335C76.3504 140.741 76.9324 139.099 77.3321 137.575C77.5543 136.516 77.8005 135.421 78.0523 134.297L78.697 130.812C78.8216 130.224 78.8993 129.62 78.9841 129.015L79.2444 127.191C79.2865 126.886 79.3367 126.581 79.3723 126.274L79.4564 125.348L79.6248 123.495C79.6961 122.88 79.6854 122.257 79.716 121.64C79.7299 121.023 79.7723 120.409 79.7609 119.796C79.7433 119.183 79.7259 118.575 79.7085 117.97L79.6947 117.519L79.6533 117.069L79.5689 116.179C79.539 115.883 79.5151 115.59 79.4799 115.298L79.3374 114.432L79.1949 113.58L78.9983 112.748C78.8717 112.206 78.7172 111.671 78.5353 111.145C78.4505 110.885 78.3372 110.632 78.24 110.381C78.1937 110.256 78.1296 110.132 78.0708 110.009L77.9818 109.825C77.9732 109.808 77.9736 109.805 77.9422 109.749C77.9161 109.704 77.8859 109.661 77.8521 109.621C77.7867 109.544 77.7089 109.479 77.622 109.428C77.7198 109.545 77.8014 109.674 77.8646 109.812C77.8902 109.932 77.9002 110.026 77.9394 110.17L78.2161 111.267C78.3127 111.718 78.4551 112.238 78.5477 112.822C78.599 113.113 78.6649 113.415 78.7144 113.729L78.8494 114.69C79.1635 117.236 79.1993 119.809 78.9563 122.363C78.9538 122.835 78.9139 123.289 78.8729 123.728L78.7593 125.001L78.6482 126.191C78.5976 126.574 78.5367 126.943 78.4829 127.302C78.255 128.735 78.0858 129.999 77.8062 131.156C77.5469 132.316 77.3339 133.395 77.0731 134.464C76.7925 135.528 76.5186 136.594 76.2382 137.75C76.1349 138.139 76.0427 138.492 75.9462 138.809C75.8393 139.125 75.7414 139.409 75.6477 139.666C75.46 140.182 75.2933 140.595 75.138 140.951C74.8274 141.664 74.5627 142.155 74.266 142.803C74.0659 143.522 73.808 144.275 73.5498 145.03L72.7929 147.26C72.5474 147.974 72.3131 148.646 72.1004 149.228C71.8657 149.802 71.6549 150.288 71.4835 150.641C70.6978 152.773 70.0987 154.26 69.6477 155.251C69.5775 155.405 69.5661 155.579 69.6157 155.74L69.6353 155.804C69.802 156.348 69.9113 156.76 69.9851 157.095C70.8207 159.478 70.8873 159.104 71.8418 161.916C73.1448 165.967 75.8724 173.073 76.157 174.94C76.6582 176.021 77.4977 178.319 78.3721 180.738C79.4122 183.667 80.079 185.796 80.6742 187.77L83.534 195.582C85.0161 199.528 84.3489 198.864 85.3445 201.766C86.5267 204.886 87.6508 207.899 88.7037 210.745L89.6967 208.816C86.4978 209.71 83.3003 210.465 80.1866 211.148C77.0628 211.828 73.9889 212.435 70.9257 212.982C67.8625 213.529 64.8111 214.016 61.7337 214.466C58.6541 214.896 55.5521 215.321 52.3777 215.659C48.1527 215.979 44.641 216.212 41.2188 216.329C37.7994 216.429 34.4634 216.492 30.618 216.268C27.3447 216.139 23.417 215.948 19.7327 215.479C19.2718 215.423 18.8116 215.382 18.361 215.315L17.026 215.111L15.7302 214.909C15.3053 214.845 14.8896 214.777 14.4885 214.689C12.8797 214.358 11.4211 214.073 10.2574 213.712L8.25067 213.288C7.5675 213.113 6.86725 212.915 6.14597 212.717L5.05141 212.41C4.6824 212.306 4.32123 212.166 3.94973 212.043L1.68546 211.255L2.46338 212.573C3.22633 206.674 4.38463 200.05 5.56218 193.865C5.77055 192.488 6.01134 191.081 6.26601 189.637C6.52068 188.192 6.79708 186.709 7.10304 185.188L8.04088 180.478L9.07381 175.471C9.52581 173.176 10.0412 170.726 10.5698 168.204L11.3669 164.376L12.2218 160.517C13.3352 155.367 14.5804 150.318 15.6743 146.055C16.3941 143.155 17.384 139.454 17.6109 138.012C20.5269 127.857 23.5524 117.036 26.8906 106.386L25.6963 107.256L37.5141 107.226C38.0206 107.107 39.6808 107.075 41.2445 107.035H41.2965C41.5653 107.029 41.8204 106.915 42.0057 106.72C42.191 106.526 42.2913 106.265 42.2845 105.996C42.2816 105.897 42.2645 105.799 42.2339 105.704C41.949 104.835 41.6687 103.998 41.4503 103.438C40.1681 99.4962 40.1456 98.6809 39.2562 95.708L37.6416 96.9095L37.9583 97.1157C38.4637 97.1895 39.9529 98.0005 41.8275 99.0242C43.7021 100.048 45.9593 101.289 47.96 102.283C51.186 104.07 53.7238 105.295 56.0757 106.375C58.4322 107.449 60.5992 108.389 63.1994 109.414C65.7033 110.246 66.3434 110.212 67.1954 110.303C68.705 110.757 70.2625 111.033 71.8361 111.127C72.8429 111.193 73.8538 111.158 74.8534 111.02C75.3528 110.946 75.846 110.834 76.3291 110.687C76.5644 110.617 76.7961 110.535 77.0233 110.442C77.0714 110.422 77.1544 110.395 77.1732 110.382C77.2018 110.366 77.2288 110.348 77.2541 110.327C77.3089 110.279 77.3605 110.227 77.4087 110.173L77.4047 110.169Z",
    fill: "#CAD4E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.6934 105.999H41.2413L38.2297 96.0137C38.2297 96.0137 67.2335 115.195 77.5063 109.832C77.5063 109.832 77.5558 109.921 77.6366 110.1L17.9044 132.291C20.2196 123.774 22.8083 114.947 25.6923 105.999L25.6934 105.999Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.3456 138.947C64.0674 138.37 63.6332 139.77 63.355 139.192C63.0291 140.002 64.498 139.585 64.3456 138.947Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.7857 137.117C65.8982 136.964 65.8099 136.796 65.9848 136.647C65.8316 136.534 65.6642 136.622 65.5146 136.448C65.4024 136.601 65.4904 136.768 65.3159 136.918C65.4687 137.03 65.6364 136.942 65.7857 137.117Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.4826 128.907C70.5609 128.592 70.7561 128.318 71.0287 128.141C70.8225 127.787 69.7916 128.661 70.4826 128.907Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.7365 134.364C64.461 134.186 63.5809 133.156 63.292 133.843L63.7365 134.364Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.6204 137.276C59.6304 136.804 59.0808 135.936 58.757 135.913C58.6851 136.547 59.052 136.964 59.6204 137.276Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.9678 141.201C54.1844 140.948 53.586 140.631 53.8706 140.383C53.1981 139.993 53.5172 140.974 53.9678 141.201Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.2171 140.087C54.657 139.852 54.3364 139.557 54.1199 139.27C54.0077 139.423 54.0953 139.59 53.9208 139.739L54.2171 140.087Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.2195 141.146C51.727 140.808 50.2271 140.311 51.1482 140.006C50.3023 139.695 50.6054 140.808 51.2195 141.146Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.891 137.712C55.2632 137.272 54.3268 137.03 54.0992 137.488C54.355 137.665 54.6378 137.5 54.891 137.712Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.4032 128.347C63.3191 128.755 63.1392 128.896 62.7342 128.618C62.4286 129.384 64.3926 129.216 63.4032 128.347Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.0922 138.3C52.3109 138.696 53.0994 137.879 52.4647 137.682L52.1174 137.978C52.2752 138.099 52.1887 138.2 52.0922 138.299V138.3Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.0167 126.37C64.8407 126.626 65.0042 126.909 64.7919 127.162C65.2318 127.534 65.4726 126.598 65.0167 126.37Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.4541 127.703C63.6707 127.45 63.0723 127.133 63.3569 126.886C62.7934 126.549 63.021 127.592 62.315 127.776C62.9868 128.325 62.782 127.154 63.4541 127.703Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.9991 135.378C52.2057 135.732 53.2365 134.858 52.5459 134.612C52.2157 134.856 52.3607 135.136 51.9991 135.378Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.4844 125.277C64.2231 124.915 63.2974 124.458 63.0651 124.435C62.8753 124.69 63.292 124.992 63.4844 125.277Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.1595 123.96C60.3759 124.148 61.4772 125.54 60.6131 124.726C60.5641 124.969 60.4324 125.188 60.2406 125.344C60.8671 125.733 61.4281 125.53 61.131 126.386C61.9036 126.28 61.5282 124.696 61.1609 123.96H61.1595Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.8822 124.337C64.4217 124.056 64.4471 123.734 63.9584 123.372C63.9549 123.695 63.3643 123.972 63.8822 124.337Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.2424 135.078C50.8248 135.461 50.4864 134.479 51.1105 134.337C50.8077 134.067 50.474 134.194 50.1196 134.582C50.3201 134.76 50.345 134.924 50.2424 135.078Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.0742 124.68C62.1885 123.907 61.5595 123.433 60.8892 123.291C60.6388 123.984 61.7996 123.864 62.0742 124.68Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.4076 121.788C64.7602 122.105 65.194 121.4 65.5474 121.717C65.6995 121.513 65.3693 121.271 65.5983 121.074C64.8453 121.583 65.1153 120.74 64.4083 121.789L64.4076 121.788Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.6728 137.224C46.8744 137.402 47.1141 137.1 47.3417 136.953C47.1515 136.632 46.9225 136.794 46.7237 136.58C46.572 136.784 46.9018 137.026 46.6728 137.224Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.592 131.618C53.2244 131.493 52.8629 131.29 52.4522 131.689C52.8205 131.815 53.1841 132.019 53.592 131.618Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.4381 115.142C70.3129 115.057 70.1614 115.02 70.0113 115.038C69.8613 115.056 69.7226 115.127 69.6207 115.239C69.8558 115.679 70.1511 115.358 70.4381 115.142Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.8246 139.513C41.1166 139.915 41.5077 139.067 41.8411 138.946C41.5491 138.545 41.1583 139.393 40.8246 139.513Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.9948 128.574C54.4176 128.016 53.5122 128.345 53.4021 127.879C53.25 128.083 53.5802 128.325 53.3512 128.523C53.5553 128.676 53.7968 128.346 53.9948 128.574Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.5448 138.599C41.5962 138.427 41.6006 138.245 41.5574 138.07C41.5142 137.896 41.4251 137.737 41.2994 137.608C41.0297 137.911 41.1587 138.245 41.5448 138.599Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.7229 113.951C69.8075 113.826 69.8442 113.675 69.8263 113.525C69.8085 113.375 69.7372 113.236 69.6257 113.134C69.3051 113.325 69.4668 113.553 69.2531 113.752C69.4055 113.865 69.5737 113.777 69.7229 113.951V113.951Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.6467 137.312C42.504 137.717 41.611 136.691 41.8711 136.52C41.0141 136.115 41.907 137.141 41.6467 137.312Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.8837 125.162C56.2043 124.793 55.2191 124.307 54.9438 124.764C55.2109 125.48 55.5763 124.953 55.8837 125.162Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.783 113.553C69.0526 113.251 68.9254 112.917 68.5375 112.562C68.2679 112.865 68.3969 113.199 68.783 113.553Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.0719 114.714C67.0134 114.169 66.9778 113.627 67.8434 113.156C67.8255 112.285 66.5504 114.554 66.3057 114.167C65.9192 114.792 66.9009 114.46 67.0719 114.714Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.3054 118.388C60.7845 118.857 60.3681 119.256 60.8468 119.726C61.2087 119.417 60.3677 117.699 61.2707 118.464C61.665 117.545 60.6933 117.466 60.3054 118.388Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.195 137.603C39.88 137.802 40.0103 136.601 39.4704 136.168C39.4568 136.658 39.3638 137.143 39.195 137.603Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.0148 134.344C42.8895 134.259 42.738 134.222 42.588 134.24C42.4379 134.258 42.2992 134.329 42.1973 134.441C42.4324 134.881 42.7277 134.56 43.0148 134.344Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.7764 132.54C44.952 132.284 44.7885 132.002 45.0012 131.749C44.5613 131.376 44.3191 132.313 44.7764 132.54Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.7781 111.204C69.9302 110.999 69.6001 110.758 69.8294 110.56C69.0779 110.026 69.1687 111.546 68.5165 110.78C68.4651 110.952 68.4608 111.134 68.5039 111.309C68.5471 111.483 68.6362 111.642 68.7619 111.771C69.1894 111.535 69.1203 111.259 69.3083 111.004C69.4811 110.865 69.6243 111.102 69.7781 111.204Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.9905 117.55C60.9095 117.165 62.3773 116.681 62.5878 116.14C61.9467 115.944 61.3127 117.105 61.0252 117.473C61.3486 117.477 61.6257 118.068 61.9905 117.55Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.2895 114.734C65.7012 114.531 65.179 113.339 64.6968 114.039C65.2802 114.138 64.8695 114.274 65.2895 114.734Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.0426 130.861C46.3632 130.671 46.2012 130.442 46.4152 130.243C46.1969 129.846 45.4079 130.663 46.0426 130.861Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.7625 129.945C47.232 130.274 47.7182 129.288 47.1608 129.005C46.4167 129.27 47.5073 129.68 46.7625 129.945Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.4067 116.043C63.8024 115.824 62.9853 115.036 62.7884 115.67L63.0847 116.018C63.2047 115.859 63.3063 115.946 63.4053 116.043L63.4067 116.043Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.3605 124.315C53.4239 124.076 53.4919 123.84 53.7077 124.018C53.8826 123.924 53.8146 123.811 53.733 123.698L53.4367 123.351L52.9159 123.795L53.3605 124.315Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.5525 124.657C51.8524 123.952 50.7607 123.988 50.439 124.408C50.7471 125.285 51.2437 123.779 51.5525 124.657Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.2173 117.816C59.436 118.211 60.2246 117.394 59.5898 117.197L59.2426 117.494C59.4004 117.614 59.3138 117.715 59.2169 117.814L59.2173 117.816Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.8396 120.305C52.8743 120.345 53.9465 121.926 52.6962 122.481C53.082 122.38 53.4257 122.811 53.836 122.41C53.6572 121.693 53.8296 121.005 53.8396 120.305Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.201 118.383C57.946 118.193 57.6433 118.61 57.3583 118.802C57.7501 119.163 58.1626 118.805 58.201 118.383Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.0208 115.123C61.6112 114.988 61.2165 115.119 61.178 115.542C61.5702 115.903 61.982 115.545 62.0208 115.123Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.6971 136.435C36.8987 136.613 37.1388 136.311 37.366 136.164L36.7733 135.469C36.5952 135.671 36.8969 135.911 37.044 136.138L36.6971 136.435Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.9111 121.444C54.1637 121.66 54.481 121.062 54.7282 121.347C54.88 121.143 54.5501 120.901 54.7792 120.703C54.1979 120.32 54.3086 121.284 53.9111 121.444V121.444Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.6566 120.207C55.1553 119.801 54.2167 119.042 53.7423 119.488C54.33 119.516 53.9678 120.171 54.6566 120.207Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.667 134.406C37.8187 134.202 37.4889 133.96 37.7179 133.763C37.6235 133.588 37.5106 133.656 37.3973 133.738L37.05 134.034C37.2403 134.355 37.4689 134.193 37.668 134.407L37.667 134.406Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.535 133.666C38.8556 133.476 38.6939 133.247 38.9076 133.048C38.6875 132.652 37.9006 133.469 38.535 133.666Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.5285 130.258C42.9242 130.039 42.1072 129.251 41.9105 129.885L42.2069 130.233C42.3273 130.075 42.4284 130.161 42.5275 130.258H42.5285Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.884 112.033C64.3531 111.276 63.1142 111.389 63.3422 110.695C62.2957 110.768 63.3287 111.363 63.884 112.033Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.5399 127.341C44.2637 127.302 43.9822 127.335 43.7228 127.438C43.5223 127.26 43.4974 127.096 43.5999 126.942C43.1237 126.66 42.3811 127.69 43.0301 128.031C43.1248 127.055 43.9494 128.413 44.5399 127.341Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.0162 135.168C35.6296 134.893 35.2574 134.54 35.7365 134.254C35.5249 133.944 34.301 134.872 35.0162 135.168Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.1282 125.685C45.8208 125.476 45.4557 126.003 45.1882 125.287C45.1036 125.412 45.0669 125.564 45.0848 125.714C45.1026 125.864 45.1738 126.003 45.2854 126.105C45.6093 126.077 45.9106 125.927 46.1282 125.685Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.9234 126.968C44.3629 127.34 44.6051 126.404 44.1478 126.176C43.9708 126.432 44.1343 126.715 43.9234 126.968Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.1538 125.364C46.3914 124.826 46.6503 125.004 46.7237 124.275C46.157 123.705 46.2225 125.245 45.8813 124.694C45.7064 124.789 45.7745 124.902 45.8557 125.015L46.1538 125.364Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.4878 118.252C54.7656 117.846 54.6246 117.667 54.2168 117.583L53.8695 117.879C54.0597 118.201 54.2884 118.038 54.4878 118.252Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.0442 131.684L38.3915 131.388C38.1564 130.948 37.8615 131.269 37.5744 131.485C37.7275 131.597 37.895 131.509 38.0442 131.684V131.684Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.5555 135.215C33.5594 134.891 34.15 134.614 33.6317 134.25C33.6296 134.573 33.0373 134.851 33.5555 135.215Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.8798 132.077C35.7162 132.023 36.4029 133.302 36.8798 132.077V132.077Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.8026 137.264C31.0722 136.961 30.945 136.627 30.5575 136.273C30.5283 136.861 29.8743 136.499 29.8373 137.187C30.1365 137.499 30.514 136.818 30.8026 137.264Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.5228 136.349C31.8434 136.159 31.6817 135.93 31.8954 135.731C31.6916 135.579 31.4494 135.909 31.2521 135.68C31.0726 135.884 31.3757 136.122 31.5228 136.349Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.5245 115.012C57.4776 114.48 56.1405 113.942 56.5245 115.012V115.012Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.622 138.225C29.4013 138.481 28.6013 137.267 29.3675 136.989C29.1645 136.577 27.9727 137.099 28.6729 137.581C28.4948 137.782 28.3313 137.807 28.1775 137.704C27.9791 138.068 28.4097 138.196 28.6476 137.903C28.8054 138.023 28.7189 138.124 28.622 138.224V138.225Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.0988 137.377C26.0186 137.641 26.2601 137.93 25.8744 138.169C26.3681 138.193 26.7292 138.779 26.1198 139.16C26.4047 139.635 26.8283 138.389 27.0854 139.236C27.4719 138.928 25.6781 137.633 26.8653 137.924C27.2521 137.299 26.2701 137.631 26.0988 137.377V137.377Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.2358 136.247C29.8679 136.122 29.5064 135.919 29.096 136.318C29.4643 136.444 29.8262 136.647 30.2358 136.247Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.5038 113.229C57.6675 113.284 56.9808 112.004 56.5038 113.229V113.229Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.9392 135.9C30.3381 135.662 30.4521 135.401 30.1639 135.108L29.6432 135.553L29.9392 135.9Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.0278 127.798C38.4663 128.17 38.9361 127.252 38.2522 127.006C38.1724 127.268 38.4136 127.558 38.0278 127.798Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.7194 134.587C29.5474 134.536 29.3647 134.531 29.1904 134.574C29.0161 134.618 28.8566 134.707 28.7285 134.833C29.0309 135.102 29.365 134.973 29.7194 134.587Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.3217 126.852C36.1567 127.001 36.368 127.18 36.4442 127.348C35.984 127.767 35.8479 127.357 35.7496 127.94C36.3473 128.223 37.2168 127.505 36.3217 126.852Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.4318 134.485C28.622 134.23 28.2052 133.928 28.0129 133.643C27.6521 134.035 28.0101 134.447 28.4318 134.485Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.3839 131.965C31.9131 131.342 30.7919 130.865 30.2704 131.716C30.5938 132.404 31.0294 131.692 31.3839 131.965Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.5249 132.953C29.1577 132.82 28.7513 133.178 28.3602 133.344C29.0615 133.771 28.918 133.584 29.5249 132.953Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.2442 113.864C52.9245 113.097 51.1963 113.145 51.8763 112.378C51.6394 112.3 51.1689 112.527 51.4065 112.179C51.0207 112.279 50.6766 111.849 50.2667 112.25C50.4672 112.428 50.4921 112.592 50.3895 112.745C51.0631 112.391 51.7577 112.902 51.1304 113.613C51.8745 113.494 51.717 113.485 52.2442 113.864Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.9072 128.36C34.686 126.836 33.8173 127.972 34.9072 128.36V128.36Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.4576 120.211C44.2407 119.882 43.7777 120.013 44.0131 119.69C43.9191 119.515 43.8058 119.583 43.6925 119.664L43.3452 119.961C43.684 120.456 44.0462 120.653 44.459 120.21L44.4576 120.211Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.1419 141.767C18.3175 141.511 18.1544 141.228 18.3667 140.975C17.9268 140.603 17.6846 141.539 18.1419 141.767Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.775 131.839C28.8674 131.581 29.7931 130.86 28.6868 131.268C28.4047 131.744 29.4352 132.487 29.775 131.839Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.6712 123.394C39.8493 123.192 39.5477 122.952 39.4006 122.725C39.0016 122.963 38.8876 123.223 39.1758 123.516C39.3507 123.422 39.2826 123.308 39.2014 123.196C39.3742 123.055 39.5177 123.292 39.6712 123.394Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.1407 127.813C33.8173 127.809 33.5402 127.219 33.1755 127.737C33.4989 127.741 33.7764 128.332 34.1407 127.813Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.7926 114.156C50.3742 113.877 49.8478 113.512 50.1908 113.215C49.7213 112.886 49.2348 113.873 49.7926 114.156Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.5458 130.281C30.8158 129.979 30.6882 129.645 30.3004 129.29C30.2489 129.462 30.2446 129.645 30.2877 129.819C30.3309 129.994 30.42 130.153 30.5458 130.281Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.436 118.427C44.4716 118.187 44.6807 117.75 44.9567 117.983C45.5081 117.085 43.5316 117.964 44.436 118.427Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.3873 115.908C47.4503 115.669 47.5187 115.433 47.7345 115.612C47.8991 115.463 47.6875 115.284 47.6117 115.116C47.4913 115.275 47.3901 115.188 47.2911 115.091C47.1789 115.244 47.2665 115.411 47.092 115.561L47.3873 115.908Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.0208 124.155C37.6185 124.447 37.9555 123.384 37.2702 123.042C36.9963 123.398 37.7079 123.832 37.0208 124.155Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.9922 131.859C28.3224 131.615 28.1771 131.334 28.5383 131.092C28.3324 130.74 27.3016 131.614 27.9922 131.859Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.5763 123.634C35.9413 124.204 36.2476 124.251 35.5345 124.525C35.7479 125.278 37.2876 123.963 36.5763 123.634Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.2231 134.476C24.2725 134.233 24.4042 134.015 24.596 133.858C23.9549 134.018 23.775 133.573 23.5335 132.964L22.8389 133.557C24.0461 133.472 23.2364 134.145 22.4411 134.497C23.2835 135.57 23.3967 133.209 24.222 134.476H24.2231Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.5221 131.661C26.8646 131.378 26.1472 131.866 25.837 132.499C26.3716 132.563 26.9394 132.208 27.5221 131.661Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.5247 128.499C30.731 128.853 31.7621 127.979 31.0711 127.732C30.6455 127.969 30.7128 128.243 30.5247 128.499Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.0614 131.708C26.0849 131.224 26.8197 130.796 27.3024 130.348C27.1018 130.17 27.0769 130.007 27.1795 129.853C26.9266 129.637 26.6096 130.234 26.3624 129.95C26.6676 130.568 25.4762 131.067 26.0614 131.708Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.9502 124.074C33.6008 123.718 33.1947 124.074 32.7858 124.468C33.1536 124.6 33.5418 124.469 33.9502 124.074Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.8121 124.146L33.1594 123.85C32.9165 123.8 32.6981 123.669 32.5411 123.477C32.2633 123.882 32.4043 124.062 32.8121 124.146Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.8409 134.615C19.7341 134.229 20.7246 133.93 20.0903 133.502C20.1989 133.889 19.2076 134.188 19.8409 134.615Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.9458 125.946C29.0303 125.82 29.067 125.669 29.0492 125.519C29.0313 125.369 28.9601 125.23 28.8485 125.128C28.528 125.319 28.6897 125.548 28.4756 125.746C28.6288 125.859 28.7962 125.771 28.9454 125.946H28.9458Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.67 127.147C23.4064 127.066 23.1175 127.308 22.8782 126.922C22.7001 127.124 23.0021 127.364 23.1492 127.591L23.67 127.147Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.6048 129.416C18.8893 129.683 19.4154 130.048 19.2066 130.355C19.6761 130.683 20.1623 129.699 19.6048 129.416Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.4087 122.502C28.7371 122.285 28.606 121.823 28.9294 122.058C29.4812 121.16 27.5033 122.039 28.4087 122.502Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.7985 139.712C63.1634 140.282 63.4697 140.329 62.7566 140.602C63.1128 140.877 63.547 140.165 63.8704 140.852C63.77 140.465 64.2006 140.122 63.7985 139.712Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.3111 134.568C66.1095 134.39 65.8697 134.691 65.6421 134.839C65.9171 136.062 65.7618 135.292 66.3111 134.568Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.5976 138.89C61.6503 138.282 62.0176 138.498 62.4656 138.149C62.1899 137.346 60.9045 139.043 61.1784 138.047C60.508 137.999 61.1299 138.493 61.5973 138.89H61.5976Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.4703 136.045C61.8551 136.358 63.5235 137.885 62.4703 136.045V136.045Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.4005 140.418C57.9489 139.089 57.2251 140.053 58.4005 140.418V140.418Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.1068 136.909C62.4357 136.457 61.4719 135.733 61.1068 136.909V136.909Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.0258 135.524C62.129 135.569 62.2413 135.59 62.3539 135.584C62.4665 135.579 62.5763 135.547 62.6747 135.493C62.7731 135.438 62.8575 135.361 62.9212 135.268C62.9849 135.175 63.0262 135.068 63.042 134.957C62.8265 135.141 62.1686 134.956 62.0258 135.524Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.7969 133.966C62.6381 134.663 63.1018 133.738 63.3177 133.521C62.7399 133.09 62.9113 133.291 62.5768 132.653C62.5412 133.028 62.1305 133.374 61.6831 133.716C62.2566 134.278 62.8158 132.683 62.7969 133.965V133.966Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.7759 132.183C63.0316 132.359 63.3148 132.196 63.5677 132.408C63.7842 132.155 63.1862 131.838 63.4704 131.591C63.0469 131.179 63.375 132.084 62.7759 132.183Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.1391 135.54C57.545 134.406 57.0516 136.521 58.1391 135.54V135.54Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.7039 131.045C63.6428 131.365 62.7933 130.206 63.5972 129.982C63.4483 129.817 63.2699 130.029 63.1021 130.105C63.0919 129.857 62.9962 129.621 62.8314 129.436C62.7192 129.588 62.8072 129.756 62.6323 129.905C62.4592 130.044 62.3164 129.808 62.1622 129.706C62.1107 129.878 62.1064 130.061 62.1495 130.235C62.1927 130.41 62.2818 130.569 62.4076 130.697C62.71 129.698 63.3974 130.503 62.7039 131.045Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.7254 124.152C68.4371 124.726 69.7853 125.314 69.7254 124.152V124.152Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.2633 141.315L49.6106 141.018C49.4528 140.898 49.5393 140.797 49.6359 140.698C48.5235 140.826 49.0898 140.84 48.8697 140.151L48.349 140.596L48.7935 141.117L48.4462 141.413C48.6756 141.595 48.941 141.294 48.7935 141.117C48.9662 140.977 49.1094 141.213 49.2633 141.315Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.9083 124.249L69.4291 123.805C69.1406 123.359 68.763 124.04 68.4638 123.729C68.2708 124.022 68.7217 123.892 68.9083 124.249Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.1097 120.617C71.9391 120.357 70.9307 121.023 71.3179 120.392C71.169 120.227 70.9906 120.439 70.8225 120.515C70.9802 120.635 70.8937 120.737 70.7972 120.835C71.2303 120.816 71.6495 120.975 72.1097 120.616V120.617Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.2384 128.741C61.6753 127.315 61.0687 128.894 62.2384 128.741V128.741Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.4658 124.787C67.3571 124.735 67.812 122.972 65.4658 124.787V124.787Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.6405 138.591C49.9496 138.159 49.1988 138.5 49.3698 137.922C49.7673 137.673 50.111 138.1 50.5096 137.851C50.646 137.307 49.3074 138.174 48.9263 137.402C48.7443 137.631 49.0456 137.896 49.2227 137.749C49.2017 138.168 48.9919 138.535 49.6415 138.592L49.6405 138.591Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.9233 136.344C52.3689 136.717 52.277 135.754 51.8257 135.527C51.2127 135.802 51.5846 136.155 51.1058 136.441C51.6878 136.817 51.5333 136.415 51.9486 136.022C52.1064 136.142 52.0198 136.244 51.9233 136.343V136.344Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.8581 138.613C47.5654 138.901 47.3107 138.713 47.0154 139.032C47.7071 139.095 48.2129 139.125 48.2054 138.317C47.9757 138.135 47.7107 138.436 47.8581 138.613Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.6283 141.276C42.5272 141.388 42.3885 141.46 42.2381 141.478C42.0877 141.496 41.936 141.459 41.8112 141.373C41.3977 140.884 42.6379 141.382 41.8621 140.729C41.5323 140.973 41.6773 141.255 41.3161 141.496C42.2568 141.543 42.1079 143.371 43.1704 142.614C42.1108 142.374 42.384 140.884 43.0992 141.474C43.2317 141.106 42.8734 140.7 42.7056 140.31C42.6234 140.455 42.5739 140.617 42.5605 140.784C42.5472 140.951 42.5703 141.119 42.6283 141.276Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.3167 133.054C53.4859 132.853 53.2647 132.797 53.1685 132.88C52.968 132.702 52.9434 132.539 53.0456 132.385C52.8447 132.216 52.7892 132.437 52.8718 132.533C52.7514 132.691 52.6506 132.604 52.5512 132.508C52.3824 132.709 52.6036 132.764 52.6994 132.681C52.839 132.854 52.6022 132.998 52.5007 133.151C52.7532 133.368 53.0706 132.769 53.3178 133.054L53.3167 133.054Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.1258 119.816C69.0718 120.052 68.8235 118.288 68.0791 118.355C67.9227 118.601 68.9322 119.222 68.1258 119.816Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.5661 136.161C47.767 136.329 47.8225 136.109 47.7395 136.013C48.5944 136.618 49.6725 134.569 48.536 134.133C48.5003 134.373 48.2909 134.81 48.0152 134.577C47.6426 135.023 48.6054 134.931 48.8323 134.48C48.9502 134.706 48.5876 134.893 48.7814 135.124C48.2806 135.801 47.606 135.449 47.5661 136.161Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.0927 120.95C66.887 121.158 65.7365 119.856 66.69 119.54C65.7771 119.323 66.1679 120.567 66.0927 120.95Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.8341 122.876C64.5696 122.556 63.6432 122.106 63.4423 121.712C63.2083 121.937 62.9746 122.16 62.773 121.983C62.6441 122.592 63.8608 121.86 63.8341 122.876Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.344 133.79C50.3917 132.842 49.658 134.299 49.3531 134.035C49.1839 134.974 50.2966 133.547 50.344 133.79Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.9322 132.135C51.6847 132.145 51.4484 132.241 51.2633 132.406C51.9204 132.898 52.0419 132.088 52.1313 131.665C51.8624 131.474 51.8128 131.911 51.9322 132.135Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.9792 120.7C65.199 120.406 64.5664 120.524 64.8567 120.204C64.4621 119.795 64.2252 120.655 64.1621 120.797C64.4147 121.014 64.732 120.416 64.9792 120.7Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.1044 118.033C68.3456 117.455 67.153 117.972 66.8428 117.609C66.6124 118.065 67.7739 117.927 68.1044 118.033Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.1463 117.144C69.4761 116.325 68.0474 116.301 69.1003 115.683C69.4921 115.004 68.4663 115.885 68.2572 116.103C68.3217 115.073 67.6784 116.606 67.8127 115.582C67.189 115.195 67.2937 116.159 67.2667 116.348C67.5007 116.551 68.264 116.056 67.563 116.695C68.3822 116.553 68.7527 115.958 69.1466 117.145L69.1463 117.144Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.401 140.775C40.2229 140.976 40.0594 141.001 39.9052 140.898C39.533 141.809 41.029 140.893 40.4263 140.453C40.1058 140.265 40.2358 140.596 40.401 140.774V140.775Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.4186 123.092C60.2434 123.48 61.5111 122.767 61.905 122.723C61.2076 122.541 61.4925 122.132 62.1294 121.932L61.2389 120.89C60.9896 122.525 61.0744 121.828 60.4172 123.091L60.4186 123.092Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.0846 130.204C51.8438 130.52 51.6415 130.348 51.4413 130.153C51.3922 130.396 51.2604 130.615 51.0684 130.771C51.332 130.852 51.6208 130.61 51.8605 130.996L52.5551 130.403C52.4611 130.228 52.3478 130.296 52.2345 130.378C52.1887 130.275 52.1694 130.162 52.1783 130.049C52.1872 129.937 52.224 129.829 52.2855 129.734C52.0846 129.565 52.0294 129.786 52.112 129.882C51.9916 130.04 51.8905 129.953 51.7914 129.857C51.6045 130.149 51.9389 129.994 52.0878 130.204L52.0846 130.204Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.5243 124.154C60.2634 124.135 58.8561 123.775 58.61 123.435C58.3934 123.687 58.9914 124.004 58.7069 124.252C58.9085 124.421 58.9633 124.2 58.8803 124.104C58.9834 124.058 59.0963 124.038 59.2088 124.047C59.3212 124.056 59.4297 124.093 59.5243 124.154Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.0451 132.151C47.1362 132.02 46.8822 132.911 46.1862 133.138C46.9342 133.73 46.8238 132.437 47.524 132.596C47.6715 132.877 47.2124 133.111 46.9776 133.362C48.2774 134.342 47.9789 133.812 48.0462 132.151L48.0451 132.151Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.3029 126.004C56.5416 126.068 56.7777 126.136 56.5993 126.352C57.4317 126.613 56.4924 125.387 56.7011 125.064C56.2434 124.736 56.7521 125.801 56.3029 126.004Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.5259 142.329C37.5672 142.093 36.7858 141.006 37.6025 141.363C38.0228 140.837 37.1038 141.32 36.9845 140.991C36.8142 141.409 37.1861 141.87 37.2046 142.303C37.0676 142.367 36.9123 142.379 36.7669 142.338C36.6216 142.297 36.4959 142.205 36.4128 142.079C36.2607 142.283 36.5909 142.524 36.3619 142.722C36.7295 142.855 37.1352 142.497 37.5263 142.329H37.5259Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.0458 127.931L54.5665 127.486C54.0629 127.713 53.6404 126.914 53.1311 127.211C52.973 126.874 53.5507 126.596 52.8853 126.22C52.6068 127.394 53.2251 127.004 54.0458 127.931Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.8822 115.429C66.2383 115.703 66.6725 114.991 66.9959 115.678C67.1705 114.494 68.2362 115.15 68.8039 115.335C69.0048 114.623 67.7535 115.131 67.4447 114.094C67.516 114.937 66.6291 114.962 65.8822 115.428V115.429Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.2612 118.218C62.9451 117.862 61.3928 118.551 61.4188 118.637C61.021 119.427 62.3449 119.347 61.4651 120.098L62.0578 120.792C61.9228 119.747 62.5921 119.764 62.7061 118.739C62.0813 118.352 62.4129 119.333 62.16 119.505C62.0745 119.418 62.0088 119.313 61.9671 119.198C61.9254 119.083 61.9088 118.96 61.9185 118.838C61.9281 118.716 61.9637 118.598 62.0228 118.491C62.082 118.384 62.1634 118.291 62.2616 118.217L62.2612 118.218Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.183 118.126C65.3518 117.925 65.131 117.869 65.0348 117.952C64.8891 117.725 65.2264 117.536 65.4074 117.334C64.8193 117.305 65.1816 116.651 64.4931 116.614C64.3538 116.442 64.5906 116.298 64.6922 116.144C64.2975 115.735 64.061 116.595 63.9976 116.737C64.1907 116.789 64.3712 116.88 64.5283 117.004C64.6855 117.128 64.8161 117.282 64.9123 117.457C64.6195 117.745 64.3648 117.557 64.0696 117.876C64.393 118.564 64.845 117.627 65.183 118.125V118.126Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.7811 130.669C50.0454 131.738 50.1801 129.729 49.4848 130.322C49.1977 130.568 49.737 130.489 49.7811 130.669Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.0507 121.606C60.19 121.778 59.9531 121.922 59.8516 122.075C60.1437 122.477 60.5344 121.629 60.8678 121.508C60.5793 121.063 60.2014 121.744 59.9025 121.432C59.7334 121.633 59.9545 121.689 60.0507 121.606Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.7064 114.519C68.6707 113.91 68.248 113.792 67.6435 113.625C67.381 113.855 68.4289 114.369 68.7064 114.519Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.1895 125.754C55.5435 125.54 54.6256 125.071 54.3973 125.529C54.6303 125.996 54.9401 125.494 55.1895 125.754Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.7709 120.691C61.3957 121.078 61.0641 120.096 61.3173 119.925C60.9184 119.556 61.0231 120.52 60.7709 120.691Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.7968 138.543C38.6319 138.692 38.8434 138.871 38.9197 139.039C38.1464 138.797 37.8155 139.508 37.5558 139.902C37.9569 139.511 39.9163 139.076 38.7968 138.543Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.0394 115.847C64.5354 115.719 65.3785 116.471 65.6325 116.542C65.9605 116.325 65.8295 115.862 66.1532 116.098C66.1112 115.252 65.5082 116.211 65.0394 115.847Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.3623 129.828C49.6662 130.145 49.7698 129.128 50.4042 128.938C49.7983 128.422 49.6469 129.411 49.3623 129.828Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.5016 125.301C52.1936 124.484 52.309 125.758 52.615 125.55C53.295 125.177 52.5886 124.952 52.3443 124.881C52.9249 124.364 53.4267 124.84 53.9532 125.009C53.5179 125.406 54.4048 125.908 53.5293 126.27C52.8306 125.997 52.1529 125.673 51.5016 125.301ZM53.3815 126.097L53.7288 125.801C53.571 125.68 53.6576 125.579 53.7541 125.48C53.4517 125.211 53.1179 125.339 52.7635 125.726C53.0063 125.775 53.2245 125.907 53.3815 126.098V126.097Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.1526 120.318C61.1973 120.441 59.7964 119.205 59.4117 119.449C58.8956 118.951 60.2901 119.463 59.7843 118.831C60.2748 118.177 58.7396 119.825 58.9925 118.607C58.0265 118.335 59.2903 119.587 58.8906 119.894C59.3291 119.789 60.1604 119.642 59.6568 120.44C60.0486 120.641 59.9937 120.196 60.1775 119.996C60.3357 120.116 60.2487 120.217 60.1522 120.316L60.1526 120.318Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.5234 141.036C36.2501 140.467 35.3218 138.837 34.5119 139.499C34.7003 139.85 34.9268 139.711 35.1555 139.55C35.4707 140.049 35.7856 140.898 35.0536 140.838C34.8499 141.27 35.329 140.781 35.5234 141.037V141.036Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.3847 136.888C40.5496 136.739 40.3384 136.561 40.2621 136.393C40.4313 136.306 40.5827 136.419 40.7576 136.27C40.9467 135.95 40.6151 136.08 40.437 136.244C40.2365 136.066 40.2119 135.903 40.3145 135.749C39.5391 135.443 40.2144 136.586 40.3857 136.889L40.3847 136.888Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.6892 123.527C55.3797 123.349 55.0588 123.309 54.7492 123.129C54.7435 122.174 55.8345 123.036 55.9645 122.092C55.7248 122.056 55.2878 121.847 55.52 121.571C54.746 121.646 53.4591 123.901 55.6892 123.527V123.527Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.6962 127.993C48.8273 128.188 49.7448 127.705 49.3142 128.366C50.4262 128.699 48.8829 127.487 49.243 127.226C48.2934 127.234 47.9486 127.522 47.2615 127.717C46.7418 126.866 47.3028 126.101 46.9698 125.265C46.863 125.742 46.5933 126.207 47.0161 126.726C46.6214 126.939 46.3037 126.17 45.8763 126.797C46.0922 127.149 46.344 127.013 46.1969 126.822C47.2209 126.667 46.5531 127.402 47.2341 128.038C47.4617 127.58 48.3981 127.824 48.0255 128.262C48.5224 128.547 48.0451 127.419 48.9192 127.2C48.9141 127.479 48.8367 127.751 48.6948 127.991L48.6962 127.993Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.0106 127.773C50.5687 128.11 50.0601 127.044 50.4088 126.834C50.3148 126.659 50.2011 126.727 50.0882 126.808L49.741 127.104C49.965 127.338 50.188 127.571 50.0106 127.773Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.0268 127.206C51.5764 126.819 51.0781 125.959 51.8948 126.465C52.1851 125.264 50.9331 126.528 50.6075 126.363C50.4747 126.738 50.8775 126.582 51.0268 127.206Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.1575 113.993C66.3267 113.792 66.1055 113.737 66.0094 113.82C65.6888 112.556 65.4672 111.413 65.2432 113.273C65.3394 113.449 65.4699 113.603 65.627 113.727C65.7841 113.85 65.9646 113.941 66.1575 113.993Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.7039 113.227C66.5304 114.11 67.0394 112.611 67.199 113.104C67.5441 112.542 66.1931 112.745 67.2756 112.139C66.8628 111.898 66.4172 112.071 65.963 112.359C66.3021 112.62 66.7402 112.711 66.7039 113.227Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.2221 120.166C58.0632 120.863 58.5266 119.938 58.7428 119.721C57.6166 119.075 58.5298 119.588 58.2221 120.166Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.5602 142.019C31.5166 141.156 31.5851 140.29 31.7639 139.444C31.0423 140.368 31.0273 141.43 31.5602 142.019Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.0726 128.433C45.9853 128.858 46.0762 129.297 45.6491 129.695C45.8528 129.847 46.0947 129.517 46.2924 129.746C46.567 129.39 45.8553 128.956 46.5417 128.632C46.5009 128.542 46.4367 128.465 46.3558 128.408C46.2748 128.351 46.1801 128.317 46.0814 128.309C45.9828 128.301 45.8838 128.32 45.7949 128.363C45.706 128.407 45.6305 128.473 45.5761 128.556C45.726 128.72 45.9048 128.51 46.0726 128.433Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.7546 116.804C60.6515 116.85 60.5387 116.869 60.4263 116.861C60.3139 116.852 60.2055 116.815 60.1109 116.753C59.7013 117.148 60.5619 117.385 60.7036 117.448C61.0466 117.151 60.5202 116.786 61.1018 116.508C60.8725 116.326 60.6067 116.627 60.7546 116.804Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.2458 110.111C68.2319 110.517 68.4111 110.441 68.6904 110.632C68.8425 110.428 68.5123 110.186 68.7413 109.988C68.5376 109.836 68.2954 110.166 68.0977 109.937C67.9288 110.138 68.1497 110.193 68.2458 110.111Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.0625 110.014C69.4576 110.423 69.6937 109.562 69.7571 109.421C69.5555 109.243 69.3154 109.544 69.0882 109.692C68.9301 109.571 69.017 109.47 69.1135 109.371C68.3537 109.207 69.3005 109.898 69.0622 110.015L69.0625 110.014Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.3825 135.597C38.749 135.917 38.8299 134.9 38.4588 134.631C37.6114 134.886 38.857 135.31 38.3825 135.597Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.3372 125.695C50.5153 125.493 50.2132 125.253 50.0661 125.025C49.6426 125.605 49.3 125.162 48.8761 125.741C49.0834 126.078 49.0898 126.738 49.6423 126.287C48.4202 126.058 49.8439 125.244 50.3372 125.695Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.6576 111.766C68.0389 110.448 66.3602 110.324 67.6275 109.738C67.3946 109.271 67.085 109.774 66.8357 109.513C67.0939 110.642 66.0713 110.663 66.6576 111.766Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.8187 122.976C53.5051 123.276 52.6079 122.46 52.3233 123.099C52.1655 122.978 52.2521 122.877 52.3489 122.778C52.2 122.613 52.0212 122.824 51.8535 122.901C52.0113 123.021 51.9247 123.122 51.8278 123.221C52.1302 123.491 52.4643 123.363 52.8187 122.976Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.3185 120.749C53.0748 120.419 52.7934 120.564 52.5523 120.203C52.5065 120.1 52.4872 119.987 52.4961 119.874C52.505 119.762 52.5418 119.654 52.6032 119.559C52.8989 119.413 52.8793 119.852 52.7258 120.055C53.4328 120.355 52.9153 119.225 52.9751 118.941C53.2957 118.988 53.6618 118.448 53.9404 119.017C54.0782 118.596 53.4998 118.119 53.3986 117.679C53.3142 117.804 53.2776 117.956 53.2954 118.106C53.3133 118.256 53.3844 118.394 53.4958 118.496C53.3274 118.583 53.1753 118.47 53.0007 118.619C52.9719 118.077 52.7318 117.518 53.4495 117.035C52.8722 116.605 53.0435 116.805 52.7087 116.167C54.0978 116.413 52.9801 114.766 54.4451 114.686C54.584 114.858 54.3475 115.002 54.2456 115.155C54.34 115.331 54.4533 115.262 54.5662 115.181L54.9135 114.884C54.5512 114.006 54.0394 115.018 53.6771 114.139C53.597 114.402 53.8385 114.692 53.4527 114.931C53.0093 114.518 53.4331 114.174 53.7021 113.817C52.7952 113.265 52.8796 114.431 52.8084 114.88C52.4027 115.143 52.6659 114.203 52.0423 114.334C51.6861 114.683 52.0422 115.089 52.4358 115.498L53.1304 114.905C53.2432 115.007 53.3153 115.145 53.3332 115.296C53.351 115.446 53.3135 115.598 53.2276 115.723C52.9487 115.718 52.6759 115.64 52.4358 115.498C52.1307 115.873 51.8798 116.289 51.6907 116.734C52.0854 117.144 52.3219 116.283 52.3853 116.142C52.3336 116.569 52.9787 117.052 52.9267 117.48C51.9863 116.623 52.1509 118.869 52.7995 119.089C52.4451 119.475 52.1114 119.604 51.809 119.335C52.2179 119.54 52.3703 120.219 52.7952 121.194L53.3185 120.749Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.2408 138.831C33.9174 138.827 33.64 138.236 33.2756 138.754C33.4284 138.867 33.5962 138.779 33.7454 138.953C33.5766 139.04 33.4248 138.927 33.2499 139.076C32.9219 139.529 33.9719 139.204 34.2408 138.831Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.5457 112.339C57.3972 112.918 58.3068 111.779 58.3118 112.885C57.7117 113.011 58.0084 113.184 57.2956 113.453C57.5384 113.502 57.7567 113.634 57.9136 113.825C58.3767 112.886 58.6616 111.933 59.8235 112.195C60.0105 112.925 58.9512 112.544 58.6082 113.233C58.8468 113.296 59.083 113.364 58.9045 113.58C59.431 114 58.948 113.081 59.2771 112.962C59.618 112.697 59.8694 113.741 59.2009 113.928C59.7035 113.967 60.6057 114.341 60.6869 113.559C60.4233 113.479 60.1348 113.721 59.8951 113.335C60.0422 113.402 60.4771 111.589 61.1104 112.298C60.3699 111.497 58.6171 111.711 57.545 112.339L57.5457 112.339Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.7082 115.343C59.983 115.623 60.4525 114.705 60.9326 114.551C60.4942 114.638 60.0863 114.331 59.671 114.128C59.9 114.818 60.5365 115.19 59.5182 116.059C59.6671 116.223 59.8455 116.013 60.0137 115.936C60.0241 116.184 60.1197 116.42 60.2844 116.605C60.5213 116.152 60.721 115.681 60.8817 115.195C60.6804 115.026 60.6252 115.247 60.7082 115.343Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.5185 111.837C65.7201 112.016 65.9602 111.714 66.1878 111.566C65.9623 111.333 65.7394 111.099 65.9171 110.897C65.1688 110.546 66.2078 111.653 65.5185 111.837Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.8469 141.887C28.3264 141.963 28.8257 141.79 29.2567 142.484C29.3349 142.169 29.5303 141.895 29.8031 141.718C29.3978 141.44 29.2182 141.581 29.1338 141.989C29.0211 141.888 28.949 141.749 28.9311 141.598C28.9132 141.448 28.9507 141.296 29.0366 141.172C28.6448 140.971 28.6996 141.416 28.5158 141.616C27.8074 141.131 29.3023 140.692 28.2704 140.625C28.6946 140.039 28.9928 141.043 29.4348 140.232C29.9527 140.596 29.3636 140.873 29.3586 141.197C29.9833 141.584 29.6517 140.602 29.905 140.431C29.4743 139.735 28.9258 140.528 28.4948 139.833C27.5096 140.457 28.5629 141.242 27.8469 141.887Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.2127 137.861C31.4202 138.024 30.9158 138.349 31.2938 139.245C31.053 139.561 30.8503 139.388 30.6501 139.194C30.498 139.398 30.8282 139.64 30.5992 139.838C31.0754 140.12 31.8181 139.09 31.1709 138.749C32.0008 138.97 32.6049 138.874 33.8216 137.988C33.4013 137.528 33.8127 137.391 33.2289 137.294C33.89 136.766 33.8815 137.174 34.1685 137.692C34.2013 137.155 34.5269 136.641 33.9741 136.057C33.5235 136.428 33.8725 136.367 34.0969 136.553C33.8042 136.84 33.5491 136.652 33.2542 136.972C33.0049 136.505 33.7814 135.865 32.8624 135.807C32.6077 136.543 33.5673 137.374 32.3637 138.034C32.7947 137.334 32.1789 137.443 32.6131 136.921C31.8195 136.391 32.0236 137.406 32.2149 137.861H32.2127Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.1459 134.851C37.0429 134.896 36.9301 134.916 36.8178 134.907C36.7055 134.898 36.5971 134.861 36.5026 134.8C36.3096 135.095 36.7601 134.963 36.9471 135.32C37.2677 135.13 37.106 134.901 37.3197 134.702C37.1185 134.533 37.0632 134.755 37.1462 134.851H37.1459Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.0666 116.351C57.8951 116.707 57.3159 116.876 57.7818 117.541C58.6847 116.35 56.6035 116.252 58.4301 115.487C57.796 115.415 57.3786 115.782 57.0666 116.351Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.4734 124.331C49.6825 124.023 49.1557 123.658 49.8716 123.391L49.5753 123.044C49.4549 123.202 49.3538 123.115 49.2547 123.019C49.2743 123.452 49.1155 123.871 49.4749 124.331L49.4734 124.331Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.7956 142.531C27.5645 142.142 27.2988 140.911 27.8256 140.105C27.4216 139.752 27.0188 139.387 26.5383 140.003C27.9502 139.99 26.2445 140.875 27.3511 142.01C26.9415 142.41 26.58 142.207 26.2113 142.081C26.0539 142.89 27.3803 142.171 27.7946 142.53L27.7956 142.531Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.5514 128.644C40.3786 128.784 40.2351 128.547 40.0812 128.445C39.7378 129.39 39.1352 129.64 38.7633 130.77C39.8436 130.553 39.8166 131.984 40.8424 131.096C40.3483 131.198 39.9163 130.503 39.4322 130.498C39.1719 130.154 39.9035 129.888 39.5088 129.533C40.5125 129.578 40.5791 128.817 40.9232 128.026C40.7045 127.63 39.9159 128.447 40.5507 128.644L40.5514 128.644Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.5633 130.182C41.2107 129.859 40.7597 130.785 40.3986 130.574C40.2903 130.925 41.4561 130.837 41.5633 130.182Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.9735 122.103C49.7837 122.358 50.2004 122.661 50.3924 122.946C51.0282 122.457 50.4636 121.872 50.8416 121.363C50.3408 120.881 50.6328 122.597 49.9735 122.103Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.8555 123.958C48.469 123.602 48.3401 123.269 48.6101 122.967C48.1078 122.918 47.1807 122.855 47.0981 123.657C47.5721 123.804 48.1221 122.991 48.5335 123.932C47.5864 124.423 48.0377 124.742 48.854 123.958H48.8555Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.4725 132.772C37.6118 132.945 37.3749 133.088 37.2734 133.242C37.6759 133.566 38.3106 132.592 38.3152 132.351C38.0723 132.302 37.8539 132.17 37.6969 131.979C37.6355 132.073 37.5987 132.182 37.5898 132.294C37.581 132.407 37.6004 132.519 37.6463 132.623C37.2688 132.585 37.148 132.931 37.4725 132.772Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.0068 139.143C29.6599 139.435 29.3817 138.858 29.0156 139.388L29.4601 139.91C29.4889 139.322 30.1433 139.684 30.1803 138.995C29.9791 138.826 29.9253 139.048 30.0068 139.143Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.3217 135.761C34.6319 135.408 34.2615 135.001 34.571 134.648C34.3573 134.293 33.8885 135.212 34.3469 135.44C34.1901 135.498 34.0224 135.521 33.8557 135.507C33.689 135.494 33.5271 135.445 33.3813 135.363C33.0301 136.11 34.0955 135.601 34.3217 135.761Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.8834 120.474C51.628 120.616 51.4136 120.278 51.5867 120.126C51.2932 119.906 51.4111 120.539 51.0913 120.249C50.9014 120.504 51.3181 120.807 51.5101 121.092C51.9358 120.855 51.8681 120.58 52.0565 120.325C51.8553 120.157 51.8001 120.378 51.8831 120.474H51.8834Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.9184 116.177C56.6655 115.96 56.3485 116.558 56.101 116.274C55.7861 116.674 57.0844 116.759 56.9184 116.177Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.1055 122.845C49.0734 122.331 48.9487 121.828 48.7372 121.358L48.0427 121.951C48.7675 122.063 48.6065 122.11 49.1055 122.845Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.7955 115.681C57.223 115.73 57.1941 115.421 57.6639 114.94C57.4349 114.676 56.7022 114.774 57.3166 115.237C57.0363 115.37 56.7823 115.165 56.4995 115.334C56.3108 115.655 56.642 115.525 56.8201 115.359C56.9779 115.48 56.8913 115.581 56.7945 115.68L56.7955 115.681Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.326 111.262C62.9077 110.984 62.3812 110.619 62.7242 110.322C62.1974 109.941 62.2256 111.582 61.5844 110.393C61.4091 110.489 61.255 110.62 61.1313 110.777C61.0076 110.934 60.9169 111.115 60.8646 111.308C61.0929 111.495 61.577 111.094 61.3853 110.863C61.5633 110.839 61.7444 110.864 61.9097 110.934C62.0751 111.004 62.2186 111.117 62.3253 111.261L62.326 111.262Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.2471 142.005C25.6653 142.077 25.9011 141.568 26.1408 140.943C25.8972 140.613 25.6158 140.758 25.3747 140.396C25.7066 141.32 25.5235 141.197 25.2471 142.005Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.7375 117.137C54.1779 115.696 53.296 116.908 54.7375 117.137V117.137Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.9009 125.185C43.6459 125.328 43.4311 124.99 43.6046 124.838C43.0243 124.547 43.4397 126.531 44.1973 125.533C43.9967 125.355 43.9718 125.191 44.0744 125.037C43.8731 124.868 43.8179 125.09 43.9009 125.185Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.67 122.569L47.2255 122.048C46.8754 122.236 47.0118 122.463 47.1746 122.692C47.0015 122.831 46.8587 122.594 46.7048 122.493C46.3682 123.048 47.3865 123.129 47.67 122.569Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.5799 120.939C49.8428 120.709 48.7938 120.194 48.5171 120.045C48.0768 120.259 48.7269 121.036 48.4918 120.366C48.8904 120.104 49.1899 121.089 49.5799 120.939Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.3988 117.445C47.9248 118.055 48.1256 118.719 48.568 119.402C48.1894 120.096 47.9557 118.953 47.5771 119.647C48.1025 119.829 48.6353 119.914 49.1607 120.096C48.6674 119.511 48.6674 118.447 48.3988 117.445Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.4182 113.949C55.9475 113.304 55.8556 114.471 57.4182 113.949V113.949Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.9749 127.382C41.2039 127.646 41.9366 127.549 41.3222 127.086C41.8023 126.432 42.3316 126.784 42.364 126.195C41.6873 125.661 41.5092 126.948 40.9749 127.381V127.382Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.4807 141.459C25.0979 141.31 24.6043 139.678 25.4506 139.431C24.5704 138.865 24.2887 138.815 24.117 137.868C23.3184 138.252 24.4664 139.044 23.5453 138.956C23.2939 139.669 24.5505 138.338 24.8073 139.38C24.3332 140.044 24.7628 140.78 24.4807 141.459Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.7822 131.26C36.5585 131.109 35.3931 131.299 36.0877 131.853C36.1863 131.269 36.3224 131.68 36.7822 131.26Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.8656 129.482C38.9546 128.464 39.7592 127.502 39.2684 126.438C39.2606 127.82 38.3719 128.137 38.8656 129.482Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.5152 136.928C24.8763 136.536 24.5184 136.124 24.0963 136.086C24.4083 136.235 24.7866 135.541 25.0868 135.84C25.499 135.416 24.5935 135.745 24.4942 135.146C25.0423 134.863 25.5176 134.457 25.8833 133.96C26.1992 134.201 26.0257 134.403 25.8323 134.604C26.0874 134.794 26.3898 134.377 26.6747 134.185C25.6895 133.981 26.4924 133.391 27.0733 133.245C27.2158 133.567 26.7926 133.366 26.5522 133.689C26.593 133.779 26.6572 133.857 26.7381 133.914C26.819 133.97 26.9137 134.004 27.0123 134.012C27.1109 134.02 27.2098 134.001 27.2986 133.958C27.3875 133.914 27.463 133.848 27.5175 133.765C27.4897 133.441 27.3398 133.14 27.0982 132.923C26.3082 132.987 26.1205 133.22 25.5613 133.934C24.9786 133.468 25.9834 133.163 25.1421 133.092C25.6051 134.328 23.5748 134.578 24.6167 135.641C23.8064 135.975 23.9353 136.557 23.3757 137C24.0475 137.549 23.843 136.379 24.5155 136.929L24.5152 136.928Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.1726 135.12C23.6953 135.013 23.2308 134.744 22.7122 135.166C22.8374 135.251 22.9888 135.288 23.1388 135.27C23.2889 135.252 23.4275 135.181 23.5293 135.069C23.5399 135.317 23.6356 135.553 23.8003 135.738L24.1476 135.442C23.9898 135.322 24.0764 135.22 24.1729 135.121L24.1726 135.12Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.8858 135.252C28.4617 135.014 28.2017 136.298 28.9486 136.145C29.5499 135.622 27.1321 134.319 27.6151 134.583C27.36 134.725 27.1453 134.387 27.3187 134.235C26.2698 134.342 27.2998 134.968 27.8858 135.252C27.3615 135.743 26.9095 135.315 26.4503 134.977C26.1212 135.808 25.1755 136.801 24.5152 136.929C24.435 137.192 24.6762 137.481 24.2904 137.72C25.6642 138.58 25.3729 136.512 26.7421 137.428C26.7531 137.333 26.7383 137.236 26.6993 137.148C26.6603 137.061 26.5984 136.985 26.5202 136.929C26.442 136.873 26.3502 136.839 26.2545 136.831C26.1588 136.823 26.0626 136.84 25.9759 136.882C25.3422 136.348 27.0088 135.991 26.2516 135.447C26.7121 135.083 27.0779 135.913 27.5385 135.549C27.8947 135.827 26.9643 136.477 26.8696 135.819C26.7446 136.187 26.5412 136.549 26.9408 136.959C27.5228 136.255 27.541 136.104 28.2537 136.739C28.4435 136.484 28.0268 136.182 27.8345 135.897C27.7166 135.672 28.0792 135.485 27.8854 135.253L27.8858 135.252Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.4302 133.426C31.1221 134.06 32.4225 133.915 32.3207 134.468C33.349 134.325 32.0856 133.306 31.4302 133.426Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.2668 125.38C42.2773 125.627 42.373 125.864 42.5378 126.049C42.587 125.806 42.7186 125.588 42.9104 125.431C42.6775 124.964 42.3683 125.466 42.119 125.206C41.9498 125.407 42.1706 125.463 42.2668 125.38Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.2927 120.837C46.7141 121.476 47.7599 122.103 48.2927 120.837V120.837Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5659 140.739C23.2365 140.121 24.0788 140.588 24.2605 140.146C24.0175 140.097 23.799 139.965 23.6422 139.773C22.9472 140.675 23.5157 140.712 23.9848 141.581C24.195 141.349 24.1234 140.038 23.5659 140.739Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.1061 132.344C34.5183 131.92 33.6125 132.248 33.5135 131.649C33.6143 132.035 33.1843 132.379 33.5847 132.789C33.9145 132.571 33.7824 132.108 34.1061 132.344Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.642 121.6C45.4415 121.992 45.8863 121.937 46.0865 122.121L46.4338 121.824C45.9943 121.369 46.1919 121.001 46.6585 121.033C46.8455 120.499 45.5779 121.211 45.1722 121.401C44.7847 122.038 45.8101 121.152 45.9914 121.304C46.1339 121.559 45.7955 121.773 45.6441 121.6H45.642Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.2119 141.848C21.5147 142.172 21.6429 140.847 22.1775 141.924C22.9846 141.556 22.3043 141.069 22.9227 140.688C22.6377 140.209 22.2837 140.581 22.0083 139.968C22.5006 139.398 23.1125 140.517 23.1731 139.576C22.4846 139.639 22.4963 139.491 23.224 138.932C22.7211 138.465 22.1145 139.314 21.666 138.162C20.8824 138.69 22.1747 138.482 21.9115 139.153C21.6717 138.801 21.2468 139.27 20.6499 138.729C20.2762 140.088 19.5788 139.866 20.1512 140.956C20.3293 140.756 20.4928 140.731 20.6466 140.833C20.8365 140.579 20.4198 140.276 20.2278 139.991C20.4753 139.98 20.7116 139.885 20.8967 139.72C20.6962 139.542 20.6712 139.378 20.7738 139.225C20.9989 139.107 21.1863 139.47 21.4171 139.275C21.6105 139.722 20.5818 140.073 21.3156 140.562C21.8972 140.285 21.3708 139.919 21.7138 139.623C22.0066 140.078 21.9955 140.508 22.5772 140.986C21.7525 141.005 20.9316 141.103 20.1255 141.278C19.8491 141.681 20.933 141.75 21.2653 141.206C21.3111 141.309 21.3305 141.422 21.3216 141.535C21.3127 141.647 21.2758 141.755 21.2144 141.85L21.2119 141.848Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.3377 134.96C31.7949 133.69 29.9598 134.067 30.6387 133.203C29.9823 132.755 30.2423 133.392 29.6222 133.77C29.9011 134.34 30.2676 133.8 30.5874 133.846C31.0359 134.26 29.4761 134.514 30.3381 134.96H30.3377Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.3079 128.711C37.402 128.886 37.5152 128.818 37.6285 128.737L37.9758 128.44C37.1704 128.43 38.0399 127.582 37.2349 127.572C36.6857 128.244 37.8557 128.04 37.3061 128.712L37.3079 128.711Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.1494 114.339C55.1468 113.499 53.9204 113.476 53.9803 112.383C53.6597 112.194 53.7901 112.525 53.955 112.703C53.6565 113.458 52.6944 112.663 52.9388 113.27C52.6741 113.638 53.5087 113.018 54.0786 113.199C54.5188 113.612 53.5208 113.911 54.1494 114.339Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.1715 125.621C39.408 126.048 39.6826 125.979 39.9376 126.167C39.8019 125.692 40.9588 124.833 41.0304 124.635C41.6548 124.96 40.9923 124.184 40.7341 124.288C40.6016 125.238 39.9982 125.285 39.1715 125.621Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.6372 119.249C46.8819 119.882 45.9604 119.392 46.0912 120.016C46.334 120.065 46.5523 120.197 46.7091 120.389C46.6229 119.951 46.93 119.543 47.133 119.128C46.8944 119.064 46.6578 118.996 46.8366 118.78C46.115 119.145 46.4057 117.023 45.0796 118.479C45.663 118.578 45.2523 118.714 45.6723 119.174C45.6335 119.916 45.8707 118.63 45.575 118.356C46.3081 118.131 45.9102 119.405 46.6375 119.25L46.6372 119.249Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.393 132.212C30.0771 132.512 31.0833 132.741 31.3073 132.932C31.1869 133.09 31.0858 133.003 30.9867 132.907C31.4338 133.779 31.5495 132.098 30.3941 132.212H30.393Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.3653 131.476C33.953 131.066 32.4962 131.351 33.0946 130.807C32.8934 130.638 32.8385 130.859 32.9211 130.955C32.8008 131.113 32.6996 131.026 32.6006 130.929C32.2141 131.554 33.1954 131.222 33.3667 131.476H33.3653Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.2752 129.846C33.9897 129.681 34.1133 130.957 35.2752 129.846V129.846Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.5998 126.708C38.8954 126.901 38.7633 126.451 39.1205 126.264C38.0545 125.081 38.3825 126.017 38.5998 126.708Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.2201 123.919C42.2818 123.825 42.3188 123.716 42.3278 123.604C42.3367 123.491 42.3173 123.378 42.2714 123.275C42.4494 123.075 42.6129 123.05 42.7664 123.153C42.7789 122.037 41.6046 123.272 42.2201 123.919Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.7182 120.633C45.0126 119.052 44.5317 120.607 45.7182 120.633V120.633Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.2627 127.251C37.4319 127.049 37.2104 126.995 37.1145 127.077C37.5441 126.179 36.805 126.645 37.0682 125.617C36.8132 125.427 36.5108 125.844 36.2255 126.036C36.2373 125.657 36.0724 125.55 35.7557 125.837C36.9382 126.004 36.5429 126.9 37.2627 127.251V127.251Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.8145 129.892C33.9651 129.364 33.5437 128.791 33.2983 128.232C32.7206 128.713 32.1304 129.351 31.6385 128.748C31.5603 129.064 31.3649 129.338 31.0921 129.514C31.2905 129.696 31.9427 129.277 32.5276 129.79C32.4446 129.351 32.6269 128.935 33.2731 128.553C33.4828 129.002 33.2656 129.416 33.8148 129.891L33.8145 129.892Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.7717 116.827C48.0533 115.984 47.81 116.93 47.3114 116.873C47.1365 117.252 48.334 117.423 48.7717 116.827Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.2925 116.383C49.6619 115.979 48.6988 116.078 48.5007 116.158C48.1584 115.704 49.0453 115.606 49.1953 115.566C49.4218 115.33 48.1218 115.372 48.9499 114.575C47.7873 114.338 49.2348 115.664 48.0306 115.959C48.4195 116.503 48.8687 116.28 49.2922 116.383H49.2925Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.3002 137.965C23.5959 138.158 23.4641 137.707 23.821 137.52C22.8493 136.98 23.073 137.048 23.3002 137.965Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.7688 124.21C39.1455 123.781 38.5727 124.173 38.3843 123.291C37.6962 123.614 38.6336 124.066 38.135 124.404C38.66 123.927 38.9528 124.332 39.7688 124.21Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.2665 120.925C42.6835 120.459 43.6883 120.154 42.8477 120.083C43.0094 120.677 42.7529 121.444 41.954 121.145C41.6359 121.505 42.6126 121.394 42.0512 121.963C42.8484 122.258 42.7871 120.703 43.5885 120.951C43.7773 120.63 43.4461 120.76 43.268 120.925H43.2665Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.9046 114.405C50.6503 114.46 49.3691 114.16 50.0619 114.824C50.3561 114.537 50.6111 114.725 50.9046 114.405Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.2406 125.468C37.5363 125.661 37.4045 125.21 37.7614 125.023L37.3168 124.502C36.9379 125.196 36.7046 124.054 36.3259 124.748C36.6109 125.247 37.2627 124.837 37.2403 125.468H37.2406Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.1243 132.601C27.7077 132.699 27.297 132.835 27.717 133.296C28.0927 133.321 28.4984 132.969 28.907 132.58C28.7065 132.402 28.6815 132.239 28.7844 132.085C28.3809 132.586 28.0874 132.877 27.1246 132.601H27.1243Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.321 131.073C29.7629 132.443 31.3678 128.911 30.1985 130.577C30.0289 130.819 30.3954 130.891 30.321 131.073Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.4427 117.615C46.7857 117.318 46.2589 116.952 46.8409 116.675C46.6119 116.493 46.3461 116.794 46.4936 116.971",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.4339 139.764C19.7854 138.831 18.4547 137.588 19.0656 138.278C19.1037 138.551 18.8198 138.798 19.1628 139.095C18.7393 139.675 18.3966 139.232 17.9728 139.81C18.5968 140.012 19.0478 139.218 19.2348 140.234C19.2982 139.996 19.3662 139.759 19.582 139.938C19.7509 139.737 19.5297 139.681 19.4339 139.764Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.8029 128.355C32.7089 128.18 32.5956 128.248 32.4824 128.329C31.8209 128.37 32.1664 127.127 31.6443 126.644L30.7762 127.385C30.9778 127.563 31.2175 127.261 31.4451 127.114C31.926 127.655 31.9014 129.166 32.8029 128.355Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.9631 121.391C41.3905 121.155 41.3211 120.88 41.5092 120.625L40.9631 121.391Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.3814 130.675C29.9253 131.273 29.6407 129.816 30.0503 130.404C30.2412 130.135 29.8045 130.086 29.5801 130.205C29.5697 129.957 29.4741 129.721 29.3094 129.536C29.562 129.504 30.295 129.393 29.682 128.918C29.9609 128.923 30.2337 129 30.4738 129.142C30.8756 128.851 30.0271 128.46 29.9068 128.126C29.7155 128.867 28.9344 129.561 29.0847 130.328C29.3187 130.531 30.082 130.036 29.381 130.675L29.3814 130.675Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.2355 127.339C32.6793 127.87 33.2139 127.252 33.7219 126.971C33.5498 126.919 33.3672 126.915 33.1929 126.958C33.0186 127.001 32.8591 127.09 32.731 127.216C32.5732 127.096 32.6597 126.995 32.7566 126.896C32.461 126.703 32.5927 127.154 32.2358 127.34L32.2355 127.339Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.766 122.918C37.6082 122.798 37.6948 122.697 37.7916 122.598C37.2217 122.448 37.5808 123.093 38.0627 123.267C38.2711 123.057 38.3983 122.78 38.4214 122.485C38.4445 122.19 38.362 121.897 38.1888 121.657C37.8419 121.95 37.5637 121.372 37.1982 121.903C37.4771 122.473 37.8436 121.932 38.1635 121.979C38.3833 122.32 38.2034 122.63 37.766 122.918Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.184 136.424C20.4023 137.136 19.7106 137.374 19.1421 137.314C18.9904 138.051 20.3564 136.832 20.7254 137.763C20.8436 136.965 20.7222 136.612 21.6447 136.379C21.8374 135.769 20.5505 136.726 20.184 136.424Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.4517 140.255C17.5011 140.012 17.6328 139.794 17.8246 139.637L17.4517 140.255Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.6956 135.733C21.945 135.749 22.408 135.342 22.5637 134.993C21.4096 135.04 21.9656 134.198 21.5521 133.456C20.953 133.555 21.2814 134.46 20.8575 134.048C20.9705 134.459 21.9004 134.697 21.6956 135.733Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.1036 130.818C28.0742 131.124 28.05 129.199 29.0388 128.867C28.4332 129.015 27.8188 129.281 27.2578 128.887C26.928 129.329 27.8527 129.799 27.7276 129.086C27.9164 129.695 27.7828 130.278 27.1036 130.818Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.4764 125.979C33.7671 125.399 32.6031 126.342 32.3121 126.373C31.5961 126.334 33.1181 126.683 33.4764 125.979Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.6016 123.312C36.7708 123.111 36.5493 123.056 36.4534 123.139C36.3145 122.747 36.7598 122.689 36.9489 123.016C37.101 122.812 36.7708 122.57 37.0002 122.372C35.7236 122.914 35.5516 121.738 34.9468 121.724C34.7687 121.926 35.0704 122.165 35.2178 122.393C35.1998 122.716 35.1743 123.037 35.1413 123.359C35.5359 123.768 35.7724 122.908 35.8358 122.766C36.0364 122.944 36.0609 123.108 35.9587 123.261C36.1624 123.413 36.4043 123.083 36.602 123.312H36.6016Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.8549 137.211C17.4171 137.149 17.3918 138.467 16.5167 137.752L17.8549 137.211Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.8296 137.533L18.2741 138.053C18.7197 137.765 18.0386 137.387 18.3503 137.088C18.0547 136.895 18.1865 137.346 17.8296 137.533Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.1988 135.856L21.5461 135.56C21.3879 135.439 21.4748 135.338 21.5714 135.239C21.2711 134.94 20.8925 135.634 20.5804 135.485C20.4718 135.233 20.5092 134.784 20.7795 135.015C20.9491 134.072 19.8656 135.131 19.8139 134.938C19.5272 135.473 20.6221 135.401 20.8511 136.154C21.0161 136.005 20.8045 135.827 20.7283 135.659C20.9014 135.519 21.0442 135.756 21.1984 135.858L21.1988 135.856Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.9898 130.569C25.8014 130.218 25.5745 130.355 25.3462 130.518C25.3355 130.27 25.2397 130.034 25.0751 129.849C25.1724 131.309 23.6572 130.335 23.3387 131.33C23.6961 131.838 24.1598 132.261 24.6976 132.571C24.8493 132.367 24.5195 132.126 24.7481 131.928C24.4408 131.719 24.0757 132.245 23.8082 131.53C24.0896 130.932 24.9683 131.982 24.3289 131.085C24.8963 130.736 25.3975 131.236 25.9891 130.569L25.9898 130.569Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.1568 127.012C30.8784 127.531 31.0473 125.497 31.4946 126.47C31.6887 125.773 30.3192 125.876 31.5965 125.184C30.326 124.837 31.2154 126.691 30.1568 127.012Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.0926 120.84C37.3182 120.793 38.0762 120.296 37.5255 119.824C37.2919 120.078 37.4258 121.525 38.0926 120.84Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.6513 135.331C18.3083 135.628 18.8348 135.993 18.2531 136.27C17.852 135.861 18.282 135.517 18.1819 135.131C17.5763 134.938 18.3055 136.207 17.2633 136.515C17.8854 136.719 18.5473 136.772 19.1938 136.668C18.4843 136.75 18.9548 135.82 19.3672 136.52L19.7145 136.223C19.5567 136.103 19.6433 136.002 19.7402 135.903C19.1389 135.57 18.8675 136.274 18.652 135.331L18.6513 135.331Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.4366 127.927C29.6624 127.784 29.7126 127.625 29.6357 127.457C29.8708 126.673 29.2991 128.268 28.8186 127.554C28.388 128.214 29.3055 127.731 29.4366 127.927Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.7382 121.949C36.4449 122.213 36.5657 121.605 36.7801 121.058C36.3705 120.88 35.6186 121.007 36.509 120.389C36.2654 120.059 35.984 120.204 35.7429 119.843C35.5612 120.072 35.8622 120.338 36.0392 120.19C36.025 120.784 35.6845 121.351 35.7382 121.949Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.3258 124.514C31.5135 124.864 31.7407 124.726 31.9694 124.565C32.1699 124.743 32.1949 124.907 32.0923 125.061C32.1863 125.236 32.2999 125.168 32.4128 125.086L32.7601 124.79C32.3726 124.374 31.9765 124.53 32.0193 123.922C31.5434 123.779 32.2091 124.448 31.3247 124.514H31.3258Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.8583 121.153C34.031 121.013 34.1742 121.25 34.3281 121.352C34.321 121.719 33.9046 121.922 33.2862 122.242C33.529 122.292 33.7473 122.423 33.9042 122.615C33.6114 122.903 33.3568 122.715 33.0618 123.034L33.5064 123.555C33.6709 123.406 33.4593 123.227 33.3835 123.059C33.4685 123.069 33.5547 123.061 33.6366 123.036C33.7185 123.011 33.7943 122.969 33.8595 122.914C33.9246 122.858 33.9776 122.79 34.0152 122.713C34.0528 122.636 34.0742 122.552 34.078 122.467C34.2786 122.645 34.3031 122.808 34.2009 122.962C34.7893 123.346 34.1169 122.337 34.7469 122.196C33.8273 122.334 34.4645 121.953 34.6497 121.378",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.9203 121.813C28.975 122.277 29.6119 121.9 29.6956 122.605C29.102 122.763 28.4977 122.877 27.8876 122.948C28.9529 122.844 28.9889 123.675 30.0129 124.735C30.2801 123.318 31.1018 124.793 30.7584 123.499C30.3727 123.6 30.0289 123.17 29.6186 123.57C29.6322 123.164 29.4534 123.239 29.1741 123.049C29.7184 122.995 30.3075 122.368 30.8596 122.211C31.0683 122.605 30.6316 122.948 31.2532 123.375C31.8499 122.654 32.3863 122.696 32.8624 123.503C33.038 123.247 32.8745 122.964 33.0872 122.711",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.1244 128.147C27.8238 127.68 26.1123 128.439 26.7609 129.01C27.09 128.223 27.4476 128.615 28.1244 128.147Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.2112 137.16C17.5656 136.946 16.647 136.477 16.4198 136.935C16.6527 137.402 16.9601 136.899 17.2112 137.16Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.5113 126.728C24.3592 127.363 24.1248 127.992 24.6805 128.684C24.4579 128.018 25.5186 127.455 24.5113 126.728Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.4801 132.317C21.7815 131.92 22.0226 132.281 22.2719 132.541C22.424 132.337 22.0938 132.095 22.3229 131.898C22.1977 131.813 22.0462 131.776 21.896 131.794C21.7459 131.812 21.6073 131.883 21.5054 131.995C21.4677 131.722 21.7512 131.475 21.4078 131.176C21.2828 131.544 21.0798 131.906 21.4791 132.316L21.4801 132.317Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.5492 132.164C20.0051 132.756 20.1056 133.629 20.9337 133.083C20.5587 133.048 20.2131 132.637 19.8709 132.19C20.3225 131.897 20.8782 131.917 20.9127 131.299C20.548 131.317 19.7455 132.166 20.1209 131.074C19.551 130.936 19.026 132.164 18.7065 132.582C19.3498 132.226 19.0865 132.66 19.1257 133.425C19.5175 133.651 19.2173 132.475 19.5492 132.162V132.164Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.0221 129.2C22.5412 129.82 22.1484 129.329 21.7092 129.421C21.4926 129.673 22.091 129.99 21.8064 130.238C22.9273 130.634 23.3052 129.587 23.2208 128.731C23.1268 128.556 23.0132 128.624 22.9003 128.705L22.553 129.001C22.7061 129.114 22.8735 129.026 23.0231 129.2H23.0221Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.4561 133.696C18.5366 133.433 18.2951 133.144 18.6808 132.905C18.1822 132.624 17.239 133.247 17.639 133.795C17.8143 133.701 17.7459 133.588 17.6647 133.475C17.8012 133.411 17.9563 133.398 18.1015 133.438C18.2468 133.479 18.3726 133.571 18.4561 133.696Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.1631 130.187C21.6875 130.52 21.0306 129.444 20.9177 129.196C21.2404 129.214 21.5622 129.239 21.883 129.272",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.4897 123.887C28.2548 125.023 28.575 123.661 27.4897 123.887V123.887Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.7183 129.666C20.4814 129.588 20.0113 129.815 20.2481 129.467C19.5386 129.561 21.0018 131.418 20.7183 129.666Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.596 124.948C26.4891 125.871 26.9084 124.161 27.2649 124.678C27.3981 124.303 26.9953 124.458 26.846 123.835C26.159 124.159 26.8703 124.592 26.596 124.948Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.1327 128.158C22.0319 127.773 22.4621 127.429 22.0614 127.019C21.5578 127.357 21.9225 127.762 22.1327 128.158Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.0033 124.255C26.4019 124.624 26.2975 123.66 26.5497 123.489C26.3965 123.376 26.2291 123.464 26.0795 123.29L25.7322 123.586C25.9574 123.82 26.1807 124.053 26.0029 124.255H26.0033Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.2699 122.574C27.0683 122.396 26.8286 122.698 26.6006 122.845C26.3823 121.72 28.4015 121.681 29.1541 121.266",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.1493 128.554C47.1593 128.212 46.6086 128.768 46.6186 128.427C46.2646 128.731 47.0642 128.895 47.1493 128.554Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.2827 128.04C48.3739 127.995 48.3735 127.893 48.4929 127.866C48.448 127.775 48.3461 127.775 48.3187 127.656C48.2279 127.701 48.2279 127.803 48.1085 127.83C48.1534 127.921 48.2553 127.92 48.2827 128.04Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.8958 129.13C41.3588 129.138 40.967 128.453 40.8491 128.389C40.5624 128.673 40.8085 128.726 40.8958 129.13Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.7927 129.814C36.0485 129.736 35.9783 129.455 35.8925 129.165C35.739 129.306 35.8091 129.587 35.7927 129.814Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.5313 125.299C52.6461 125.169 52.8061 125.087 52.979 125.07C52.9683 124.852 52.2638 125.013 52.5313 125.299Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.9875 126.231C48.3746 126.325 48.2108 125.619 47.9045 125.874L47.9875 126.231Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.3174 126.599C45.4382 126.378 45.3912 125.831 45.243 125.74C45.1611 125.872 45.124 126.027 45.1375 126.182C45.1509 126.337 45.214 126.483 45.3174 126.599Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.9594 130.612C26.9871 130.653 27.2596 130.763 27.3433 130.647C27.531 130.39 26.6872 130.204 26.9594 130.612Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.2213 127.299C41.538 127.085 40.9802 126.948 40.7818 127.025C40.8092 127.309 41.1562 127.079 41.2213 127.299Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.6691 127.071C41.834 127.005 41.6281 126.707 41.824 126.659C41.6011 126.309 41.5113 126.852 41.6691 127.071Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.7445 129.108C30.7509 129.349 31.3262 129.156 31.0733 128.906L30.8357 128.961C30.8799 129.057 30.8158 129.084 30.7445 129.108Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.9932 127.424C38.1945 127.761 38.2782 127.214 38.441 127.194C38.2397 126.857 38.1557 127.406 37.9932 127.424Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.0616 126.604C42.328 126.601 42.2486 126.382 42.2166 126.192C42.1257 126.238 42.1257 126.339 42.0064 126.367L42.0616 126.604Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.2259 127.923C34.3908 127.856 34.1849 127.559 34.3808 127.511C34.1578 127.161 34.0684 127.705 34.2259 127.923Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.3786 126.369C40.7024 126.333 40.1129 125.728 40.6247 125.811C40.3002 125.455 40.1702 126.058 40.3786 126.369Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.3964 129.258C27.6457 128.981 26.9572 128.525 27.7062 128.435C27.6111 128.164 27.168 128.487 27.1118 128.573C27.1641 128.87 27.2268 129.151 27.3964 129.258Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.9656 125.642C43.2505 125.525 42.8658 125.179 42.645 125.341C42.7234 125.488 42.8979 125.479 42.9656 125.642Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.2761 127.624C32.5254 127.609 32.6423 127.514 32.5775 127.304L32.2213 127.386L32.2761 127.624Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.3092 123.292C49.1689 123.465 49.0492 123.488 48.9249 123.257C48.5915 123.545 49.565 123.948 49.3092 123.292Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.4928 125.233C41.4992 125.475 42.0744 125.281 41.8219 125.032L41.5843 125.087C41.6295 125.183 41.564 125.21 41.4931 125.233H41.4928Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.5612 122.751C50.4148 122.829 50.4227 123.004 50.2599 123.072C50.3771 123.356 50.7222 122.971 50.5612 122.751Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.4916 122.999C49.6565 122.933 49.4506 122.635 49.6465 122.588C49.462 122.289 49.3135 122.84 48.9342 122.753C49.118 123.181 49.3085 122.575 49.4923 122.999H49.4916Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.0423 127.16C31.2072 127.093 31.0013 126.795 31.1972 126.748C30.9742 126.397 30.8845 126.941 31.0423 127.16Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.3414 125.696C37.6328 125.61 37.2827 125.286 37.231 125.221C36.893 125.382 37.4052 125.447 37.3414 125.696Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.1888 125.589C36.1143 125.219 35.7475 125.319 35.3927 125.398C35.4738 125.528 35.6028 125.621 35.7517 125.657C35.9006 125.693 36.0576 125.668 36.1888 125.589Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.3387 127.393C27.5524 127.245 27.6692 126.878 27.4384 126.744C27.2852 126.885 27.3554 127.166 27.3387 127.393Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.1674 123.824C42.1784 124.042 42.8826 123.881 42.6155 123.595C42.3985 123.63 42.3982 123.798 42.1674 123.824Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.1028 121.855C50.5423 121.865 50.2157 121.421 50.1113 121.353C49.9582 121.427 50.0818 121.671 50.1028 121.855Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.3238 120.658C48.906 120.555 49.0859 121.487 48.8761 120.888C48.793 120.991 48.6769 121.062 48.5473 121.089C48.7489 121.428 49.0652 121.47 48.7129 121.802C49.1058 121.941 49.3167 121.098 49.3238 120.658Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.5231 121.507C50.8484 121.507 50.9396 121.361 50.7967 121.068C50.7155 121.22 50.3667 121.208 50.5231 121.507Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.4076 123.249C41.5896 123.574 41.6708 123.025 42.0017 123.111C41.9244 122.908 41.7342 122.887 41.471 122.984C41.5226 123.117 41.4941 123.201 41.4076 123.249Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.5807 121.225C49.6772 121.069 49.7082 120.882 49.6668 120.704C49.6254 120.525 49.515 120.371 49.3598 120.274C49.0706 120.541 49.6508 120.77 49.5807 121.225Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.3993 120.427C51.4887 120.664 51.8681 120.436 51.9575 120.673C52.0796 120.613 51.9831 120.418 52.1398 120.38C51.6576 120.436 51.9931 120.104 51.3993 120.427Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.1861 123.389C39.2377 123.523 39.4262 123.439 39.5701 123.424C39.559 123.224 39.4101 123.246 39.3685 123.095C39.2456 123.155 39.3421 123.351 39.1861 123.389Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.8482 122.431C43.7057 122.281 43.5828 122.096 43.2901 122.185C43.4336 122.335 43.5554 122.52 43.8482 122.431Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.8965 118.756C55.8579 118.685 55.7951 118.63 55.7195 118.602C55.6439 118.573 55.5606 118.573 55.4848 118.601C55.488 118.867 55.7071 118.786 55.8965 118.756Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.1768 125.069L28.4144 125.014C28.4112 124.747 28.1921 124.827 28.0026 124.859C28.0479 124.948 28.1497 124.948 28.1768 125.069Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.1206 124.26C31.2375 124.545 31.6859 124.224 31.422 123.939C31.319 124.045 31.3625 124.241 31.1206 124.26Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.8468 123.037C35.8867 123.299 36.281 122.993 36.4688 123.018C36.4289 122.756 36.0346 123.06 35.8468 123.037Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.7882 121.085C45.1262 120.925 44.6154 120.858 44.6778 120.61C44.5552 120.669 44.6521 120.865 44.4954 120.903C44.5549 121.025 44.7504 120.929 44.7882 121.085Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.1503 125.521C25.3918 125.515 25.198 124.94 24.9487 125.193L25.0039 125.431C25.1001 125.385 25.1268 125.451 25.1503 125.522V125.521Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.5841 124.116L29.3465 124.171C29.4495 124.254 29.5207 124.37 29.5481 124.5C29.7974 124.485 29.9143 124.389 29.8494 124.179C29.4907 124.514 29.8473 124.124 29.5841 124.115V124.116Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.4136 122.78C36.4803 122.711 36.5273 122.626 36.5496 122.532C36.572 122.439 36.5689 122.341 36.5407 122.25C36.3384 122.327 36.3174 122.517 36.4136 122.78Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.8499 118.015C55.9208 117.976 55.9755 117.913 56.0039 117.838C56.0324 117.762 56.0327 117.679 56.0048 117.603C55.805 117.614 55.8267 117.763 55.6757 117.805C55.7206 117.895 55.8225 117.895 55.8499 118.015Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.6761 124.541C26.7506 124.693 26.9967 124.57 27.1791 124.549C27.0822 124.281 26.7983 124.35 26.6761 124.541Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.7786 122.195C37.0857 122.598 36.9143 121.891 37.08 121.874C36.7729 121.471 36.9442 122.178 36.7786 122.195Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.5235 119.931C46.7668 119.835 46.4167 119.361 46.1755 119.51C46.1267 119.916 46.4298 119.756 46.5235 119.931Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.62 123.732C30.0564 123.397 28.9273 123.298 29.7472 123.201C29.6001 122.741 29.3999 123.375 29.2165 123.074C29.1498 123.143 29.1029 123.229 29.0805 123.322C29.0582 123.415 29.0612 123.513 29.0893 123.605C29.3525 123.509 29.5427 123.529 29.62 123.732Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.5015 117.595C55.7039 117.518 55.7249 117.327 55.6287 117.064C55.4282 117.142 55.4057 117.332 55.5015 117.595Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.286 124.488C25.3929 124.486 25.4982 124.462 25.5956 124.417C25.6929 124.373 25.7804 124.31 25.8527 124.231C25.8415 124.204 25.821 124.182 25.795 124.168C25.7689 124.155 25.739 124.151 25.7105 124.158C25.6819 124.165 25.6567 124.181 25.6392 124.205C25.6217 124.228 25.6132 124.257 25.6151 124.286C25.4986 124.31 25.489 124.162 25.4409 124.076C25.3501 124.121 25.3501 124.223 25.2308 124.25L25.286 124.488Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.8877 123.274C28.8045 123.377 28.6883 123.448 28.5586 123.476C28.6715 123.796 29.0298 123.63 28.8877 123.274Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.1315 123.239C30.1379 123.481 30.7132 123.287 30.4603 123.037L30.2227 123.092C30.2679 123.188 30.2024 123.215 30.1315 123.239Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.4041 117.724C54.4406 117.557 54.5366 117.41 54.6743 117.308C54.812 117.207 54.9819 117.16 55.1521 117.175C55.3576 116.757 54.1947 117.52 54.1737 117.277C53.8378 117.478 54.3852 117.562 54.4041 117.724Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.0903 124.176L26.3282 124.121C26.325 123.854 26.1059 123.934 25.9164 123.966C25.9613 124.058 26.0628 124.058 26.0903 124.176Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.2788 123.9C27.8053 123.694 27.0163 123.203 27.2788 123.9V123.9Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.2891 117.803C50.4009 118.144 50.1053 118.231 50.2179 118.572C50.4672 118.514 50.4893 117.492 50.7293 118.077C51.1418 117.738 50.6994 117.463 50.2891 117.803Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.5434 121.73C35.8194 121.992 36.177 121.455 36.0271 121.116C35.9001 121.345 35.7367 121.553 35.5434 121.73Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.1581 121.122C38.1195 121.051 38.0567 120.997 37.9811 120.968C37.9055 120.94 37.8222 120.94 37.7464 120.967C37.7496 121.234 37.9687 121.154 38.1581 121.122Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.2949 123.987C25.5442 123.972 25.661 123.876 25.5962 123.666L25.24 123.749L25.2949 123.987Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.5519 116.724C56.6741 116.665 56.5775 116.469 56.7346 116.432C56.5095 115.993 56.1783 116.737 56.0579 116.213C55.9912 116.282 55.9442 116.368 55.9218 116.461C55.8994 116.554 55.9025 116.652 55.9307 116.744C56.1907 116.736 56.2263 116.589 56.3784 116.515C56.4949 116.491 56.5045 116.639 56.5526 116.725L56.5519 116.724Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.2177 123.645L26.4553 123.59C26.3522 123.507 26.281 123.39 26.2537 123.261C26.0222 123.385 26.045 123.505 26.2181 123.645H26.2177Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.8119 123.507C26.7072 123.43 26.5512 123.224 26.7289 123.151C26.439 122.668 26.3692 123.823 26.8119 123.507Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.2964 117.82C50.8779 117.372 51.6936 117.503 51.9269 117.298C51.6704 117.049 51.0841 117.443 50.8583 117.547C51.0083 117.628 50.9947 117.977 51.2964 117.82Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.5532 117.296C53.7986 117.3 53.8438 116.606 53.4428 116.82C53.6957 117.01 53.4673 116.974 53.5532 117.296Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.3372 117.453C52.5787 117.447 52.3849 116.872 52.1356 117.124L52.1908 117.362C52.2866 117.316 52.3137 117.382 52.3372 117.453Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.5351 118.907C45.6238 118.81 45.7132 118.714 45.7727 118.852C45.8796 118.852 45.8739 118.781 45.8639 118.706L45.8087 118.468L45.4525 118.551L45.5351 118.907Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.5926 118.626C44.9082 118.365 44.3814 118.113 44.1256 118.234C44.0558 118.726 44.6624 118.133 44.5926 118.626Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.9133 117.264C49.9198 117.506 50.495 117.312 50.2425 117.062L50.0049 117.118C50.0501 117.214 49.9846 117.241 49.9137 117.264L49.9133 117.264Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.749 117.123C46.2809 116.904 46.401 117.918 45.6708 117.874C45.8788 117.921 45.9358 118.21 46.2289 118.12C46.3569 117.766 46.5317 117.431 46.7486 117.123L46.749 117.123Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.2914 117.283C49.217 117.131 48.9709 117.254 48.7885 117.275C48.8858 117.543 49.1693 117.474 49.2914 117.283Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.9062 116.676C51.7448 116.512 51.5254 116.477 51.4033 116.668C51.5005 116.936 51.784 116.867 51.9062 116.676Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.6455 120.56C34.6971 120.695 34.8855 120.61 35.0294 120.596L34.919 120.12C34.7844 120.172 34.8691 120.36 34.8834 120.504L34.6455 120.56Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.5029 117.682C46.5695 117.847 46.8672 117.641 46.9146 117.837C47.0368 117.777 46.9403 117.582 47.097 117.544C46.9153 117.219 46.7308 117.702 46.5029 117.682Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.1607 117.278C47.498 117.206 47.2387 116.616 46.9039 116.711C47.1757 116.869 46.8441 117.091 47.1607 117.278Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.6047 119.836C35.7269 119.777 35.6303 119.581 35.787 119.544C35.787 119.437 35.7158 119.442 35.6407 119.452L35.4031 119.508C35.4141 119.707 35.5627 119.686 35.6047 119.836Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.1988 119.698C36.3986 119.687 36.3769 119.539 36.5279 119.497C36.5215 119.255 35.9448 119.449 36.1988 119.698Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.5507 115.668C53.9596 115.424 53.3438 115.173 53.622 114.9C53.1083 114.677 53.4521 115.213 53.5507 115.668Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.1874 115.162C55.6974 115.107 55.7259 114.752 56.0554 114.585C55.831 114.312 55.7231 114.269 55.4061 114.485C56.1562 114.888 55.0613 114.583 55.1874 115.162Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.9701 114.748C57.2361 114.609 57.0448 114.185 57.6005 114.226C57.9923 113.935 57.1261 114.365 57.2799 113.925C57.1261 113.986 57.1731 114.47 57.0424 113.98C56.9864 114.025 56.94 114.081 56.906 114.145C56.8721 114.208 56.8511 114.278 56.8445 114.349C56.8379 114.421 56.8456 114.493 56.8674 114.562C56.8891 114.63 56.9244 114.694 56.9711 114.748H56.9701Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.5618 116.308C47.7933 116.184 47.7705 116.064 47.5974 115.923L47.3598 115.979C47.3709 116.178 47.5208 116.157 47.5618 116.308Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.5822 114.175C54.5886 114.417 55.1638 114.223 54.9109 113.974L54.6734 114.029C54.719 114.125 54.6531 114.152 54.5822 114.175Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.3253 115.272C49.9073 115.253 49.4068 114.669 49.3253 115.272V115.272Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.7538 114.42C50.2927 114.732 50.2816 113.956 49.7538 114.42V114.42Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.9295 112.968C55.1525 113.171 55.3117 112.756 55.67 112.921L55.5596 112.446C55.3381 112.602 55.0496 112.671 55.2943 112.382C55.1831 111.964 54.9602 112.726 54.9103 112.346C54.6392 112.448 54.9705 112.926 54.5452 112.932C54.7732 113.258 55.005 112.759 54.9655 112.584C55.2594 112.53 55.082 112.971 54.9299 112.968L54.9295 112.968Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.5931 113.153C54.0134 113.334 54.1452 113.123 53.7755 112.859C53.6533 112.919 53.7498 113.114 53.5931 113.153Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.1863 112.443C57.0139 112.176 56.9202 111.783 56.5452 111.841C56.4411 112.27 56.7571 112.446 57.1863 112.443Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.2787 112.868C54.362 112.765 54.4782 112.694 54.6078 112.667C54.4909 112.604 54.3628 112.566 54.2309 112.554C54.099 112.541 53.9659 112.556 53.8396 112.595C53.9044 112.816 54.2527 112.586 54.2787 112.868Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.3686 112.151C57.5036 112.099 57.4185 111.911 57.4043 111.767L57.0481 111.849C57.1264 111.996 57.3006 111.987 57.3686 112.151Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.9435 111.39C57.5382 111.341 57.6981 111.644 57.5232 111.738C57.619 111.982 58.0931 111.632 57.9435 111.39Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.6161 112.163C55.0025 112.167 54.7685 111.784 55.155 111.787C55.0072 111.542 54.464 111.887 54.6161 112.163Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.3506 112.1C54.3211 111.712 53.785 112.137 53.6739 111.881C53.3622 112.182 54.096 112.167 54.3506 112.1Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.0804 112.591C50.3482 112.941 50.3689 112.311 50.5007 112.243C50.1733 111.979 50.0697 112.542 50.0804 112.591Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.1021 111.03C54.3436 111.024 54.1498 110.449 53.9005 110.701L53.9557 110.939C54.0518 110.894 54.0786 110.96 54.1021 111.03Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.7016 128.783C46.26 128.897 46.3939 128.997 45.9893 128.949C46.0908 129.167 46.4719 128.936 46.4562 129.341C46.5033 129.133 46.7921 129.075 46.7024 128.782L46.7016 128.783Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.2871 130.327C36.5738 130.437 36.7754 130.232 37.1191 130.134C37.0451 129.981 36.7986 130.104 36.6162 130.125C36.571 130.029 36.6365 130.002 36.7074 129.979C36.525 129.682 36.5047 130.312 36.2871 130.327Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.1593 126.96C49.1077 126.825 48.9192 126.91 48.775 126.924C48.6047 127.571 48.7201 127.169 49.1593 126.96Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.8588 127.852C46.0334 127.576 46.1545 127.769 46.4529 127.713C46.5195 127.265 45.4912 127.754 45.867 127.348C45.5611 127.16 45.7342 127.548 45.8585 127.851L45.8588 127.852Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.973 126.716C46.6037 126.713 47.0201 127.849 46.973 126.716V126.716Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.7434 129.593C36.9614 129.506 36.4196 128.929 36.3039 129.319C36.3694 129.541 36.716 129.31 36.7434 129.593Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.9657 127.79C44.0783 127.05 43.4959 127.328 43.9657 127.79V127.79Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.1135 126.791C46.8551 126.903 46.5759 126.322 46.1135 126.791V126.791Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.8901 126.359C46.9281 126.406 46.9764 126.443 47.0311 126.468C47.0859 126.493 47.1456 126.505 47.2058 126.503C47.2659 126.501 47.3248 126.486 47.3779 126.457C47.431 126.429 47.4769 126.389 47.512 126.34C47.3641 126.373 47.0977 126.124 46.8901 126.359Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.6391 125.81C47.3922 126.102 47.8396 125.776 47.9952 125.727C47.9323 125.643 47.8876 125.547 47.8638 125.444C47.84 125.342 47.8377 125.236 47.857 125.133C47.7484 125.302 47.4681 125.365 47.1714 125.418C47.3071 125.825 47.9639 125.205 47.6391 125.81Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.0679 124.958C48.1463 125.105 48.3205 125.097 48.3885 125.26C48.5534 125.193 48.3476 124.895 48.5435 124.848C48.4434 124.548 48.3757 125.059 48.0679 124.958Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.0414 125.411C45.0382 124.727 44.2842 125.609 45.0414 125.411V125.411Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.3141 124.401C48.6813 124.783 48.5634 124.025 48.9994 124.116C48.9695 124.001 48.8327 124.057 48.734 124.052C48.7899 123.932 48.8025 123.796 48.7696 123.668C48.6788 123.713 48.6788 123.815 48.5595 123.842C48.4402 123.869 48.4334 123.718 48.3853 123.632C48.3186 123.701 48.2716 123.786 48.2493 123.88C48.2269 123.973 48.23 124.071 48.2582 124.163C48.6475 123.763 48.7757 124.314 48.3134 124.401H48.3141Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.3416 122.856C52.589 122.811 53.0841 123.423 53.3416 122.856V122.856Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.4087 125.968L39.6463 125.913C39.6011 125.817 39.6666 125.79 39.7375 125.766C39.1783 125.552 39.4436 125.699 39.5081 125.318L39.1519 125.401L39.2346 125.757L38.9966 125.812C39.0076 125.84 39.028 125.862 39.0542 125.876C39.0803 125.89 39.1105 125.893 39.1392 125.887C39.168 125.88 39.1933 125.863 39.2108 125.84C39.2283 125.816 39.2367 125.787 39.2346 125.757C39.351 125.734 39.3606 125.882 39.4087 125.968Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.9298 122.702L53.286 122.619C53.2586 122.337 52.912 122.567 52.8465 122.346C52.6823 122.438 52.9288 122.488 52.9295 122.702H52.9298Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.3427 121.766C55.3256 121.601 54.6834 121.669 55.0221 121.465C54.9918 121.35 54.8554 121.406 54.7567 121.401C54.802 121.497 54.7364 121.524 54.6655 121.547C54.876 121.644 55.036 121.823 55.3423 121.766H55.3427Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.6606 123.192C48.7432 122.377 48.0668 122.977 48.6606 123.192V123.192Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.4978 127.518C29.771 127.42 29.2877 127.233 29.2685 127.07C28.9308 127.272 29.4783 127.356 29.4978 127.518Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.1642 122.11C52.0746 122.55 52.724 121.825 51.1642 122.11V122.11Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.2575 124.768C40.5104 124.639 40.0702 124.616 40.2931 124.384C40.5425 124.363 40.6009 124.652 40.8513 124.631C41.0497 124.406 40.2012 124.488 40.2101 124.028C40.1831 124.039 40.1608 124.059 40.1474 124.086C40.134 124.112 40.1303 124.142 40.1369 124.17C40.1436 124.199 40.1601 124.224 40.1836 124.241C40.2071 124.259 40.2361 124.267 40.2653 124.265C40.1528 124.459 39.9629 124.582 40.2575 124.768Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.8931 124.263C42.0131 124.548 42.2062 124.07 42.048 123.852C41.6893 123.831 41.7791 124.091 41.4813 124.109C41.6651 124.429 41.6904 124.201 41.9843 124.117C42.0295 124.213 41.964 124.24 41.8931 124.263Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.1002 126.877C29.9955 126.715 29.9492 126.765 29.7522 126.457C29.4897 126.497 29.7964 126.891 29.7715 127.079C29.9574 127.025 30.2381 127.031 30.2192 126.85C30.3524 126.668 30.2192 126.801 30.1002 126.877Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.4062 124.34C39.1964 124.404 39.1213 124.252 38.9033 124.331C39.216 124.531 39.4486 124.67 39.6442 124.284C39.633 124.257 39.6125 124.235 39.5865 124.222C39.5605 124.208 39.5305 124.205 39.5019 124.211C39.4734 124.218 39.4482 124.234 39.4307 124.258C39.4132 124.281 39.4047 124.31 39.4066 124.34H39.4062Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.2693 124.317C36.1936 124.345 36.11 124.345 36.0342 124.317C35.9584 124.288 35.8956 124.233 35.8576 124.162C35.7817 123.828 36.2494 124.369 36.0399 123.869C35.8234 123.904 35.823 124.072 35.5922 124.098C36.0271 124.352 35.5067 125.183 36.1977 125.085C35.7539 124.711 36.2501 124.071 36.4438 124.527C36.597 124.384 36.5268 124.104 36.5436 123.878C36.4688 123.927 36.4056 123.991 36.3583 124.067C36.311 124.143 36.2808 124.228 36.2697 124.317H36.2693Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.3872 125.38C34.8057 125.438 34.3872 124.975 34.8075 125.032C34.7113 124.789 34.238 125.138 34.3872 125.38Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.3645 123.045C43.4942 122.991 43.403 122.91 43.3367 122.926C43.2854 122.792 43.3139 122.708 43.4005 122.66C43.3467 122.531 43.2658 122.622 43.2815 122.688C43.1857 122.734 43.1586 122.668 43.1351 122.597C43.0055 122.651 43.097 122.732 43.1629 122.716C43.1864 122.832 43.039 122.842 42.9528 122.89C43.0194 123.055 43.3171 122.849 43.3645 123.045V123.045Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.649 120.405C54.0408 120.75 54.356 119.852 53.9863 119.7C53.8517 119.779 54.1779 120.322 53.649 120.405Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.633 124.822C34.68 124.614 34.9689 124.557 34.8791 124.264C34.7292 124.408 34.5439 124.53 34.633 124.822Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.8711 123.105C39.9248 123.234 40.0057 123.143 39.99 123.077C40.2479 123.575 41.2627 122.867 40.8303 122.38C40.7537 122.485 40.5474 122.641 40.4741 122.463C40.1891 122.583 40.6671 122.776 40.8858 122.618C40.8858 122.754 40.6682 122.754 40.7035 122.911C40.2995 123.108 40.0662 122.777 39.8714 123.105H39.8711Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.4056 120.443C52.7315 120.737 52.5064 119.838 53.036 119.921C52.6556 119.593 52.5356 120.279 52.4056 120.443Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.8604 120.802C51.2879 120.831 50.9595 120.389 50.9602 120.153C50.7938 120.202 50.6282 120.25 50.5759 120.117C50.3646 120.374 51.1222 120.326 50.8604 120.802Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.4327 125.065C31.7771 125.076 31.6172 124.773 31.853 124.716C31.7579 124.644 31.3055 124.613 31.4327 125.065Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.7724 122.663C42.0281 122.225 41.3218 122.734 41.242 122.535C40.9314 122.939 41.8098 122.536 41.7724 122.663Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.9335 122.268C42.8134 122.212 42.6778 122.2 42.5496 122.232C42.7401 122.628 42.9973 122.273 43.1437 122.094C43.0628 121.937 42.9321 122.132 42.9335 122.268Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.6047 124.738C28.5668 125.002 30.3644 125.438 29.6047 124.738V124.738Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.9375 120.051C52.1156 119.966 51.7851 119.866 52.0013 119.785C51.9147 119.494 51.5906 119.844 51.5258 119.896C51.5924 120.061 51.8902 119.855 51.9375 120.051Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.0779 119.554C54.3347 119.34 53.6415 119.291 53.5831 119.042C53.3623 119.202 53.9468 119.422 54.0779 119.554Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.7906 119.388C55.1493 119.08 54.4764 118.718 55.1282 118.684C55.4809 118.457 54.7778 118.623 54.625 118.675C54.9099 118.202 54.2264 118.772 54.5423 118.319C54.3414 117.982 54.1541 118.465 54.0946 118.548C54.1559 118.702 54.6396 118.655 54.1498 118.786C54.5733 118.918 54.8939 118.728 54.7906 119.388Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.8754 125.39C27.6535 125.202 27.3447 125.154 27.2343 124.787C27.027 125.026 27.531 125.497 27.8754 125.39Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.3354 123.531C35.2018 123.583 35.1178 123.554 35.07 123.468C34.6693 123.809 35.6043 123.742 35.4262 123.385C35.3194 123.217 35.3005 123.406 35.335 123.531L35.3354 123.531Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.1857 120.064C49.0076 120.206 49.7841 120.178 49.9818 120.255C49.6968 119.997 49.9315 119.873 50.2831 119.934L50.1175 119.222C49.5967 119.937 49.8086 119.627 49.1857 120.064V120.064Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.481 121.389C43.289 121.48 43.2352 121.349 43.1882 121.207C43.1051 121.31 42.9888 121.381 42.8591 121.409C42.9659 121.511 43.1607 121.468 43.1796 121.71L43.6551 121.6C43.6551 121.493 43.5839 121.498 43.5087 121.509C43.5369 121.391 43.5639 121.272 43.6911 121.215C43.6373 121.086 43.5565 121.177 43.5721 121.243C43.4763 121.289 43.4493 121.223 43.4257 121.152C43.2651 121.245 43.4614 121.254 43.481 121.39V121.389Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.5003 120.348C48.8565 120.521 48.2766 120.004 48.2435 119.782C48.0786 119.848 48.2845 120.146 48.0886 120.194C48.1427 120.323 48.2232 120.232 48.2075 120.166C48.3258 120.194 48.4444 120.221 48.5007 120.348H48.5003Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.7418 124.241C31.8249 124.138 31.941 124.067 32.0706 124.039C31.9245 123.576 31.6887 124.268 31.6314 123.766C31.2941 123.926 31.8045 123.993 31.7418 124.241Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.5157 120.433C46.6133 120.522 46.7088 120.612 46.5709 120.671C46.9018 121 46.7579 120.187 46.936 120.085C46.7996 119.817 46.7789 120.447 46.5157 120.433Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.5886 123.561C33.6663 123.46 33.5626 122.752 33.8626 123.122C34.1913 122.976 33.6371 122.98 33.6609 122.793C33.4772 122.95 33.5402 123.26 33.4426 123.47C33.3619 123.467 33.2851 123.435 33.2263 123.379C33.1674 123.324 33.1304 123.249 33.122 123.169C32.9999 123.228 33.0964 123.424 32.9397 123.462C33.0811 123.615 33.3617 123.545 33.5886 123.561Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.9709 120.792L45.3271 120.71C45.0322 120.693 45.0283 120.211 44.7137 120.226C44.7216 120.028 45.0639 120.038 44.8409 119.695C44.4199 120.184 44.8088 120.152 44.9706 120.793L44.9709 120.792Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.6636 117.771C53.7651 117.989 54.1462 117.758 54.1305 118.163C54.5045 117.644 54.849 118.218 55.073 118.445C55.3441 118.156 54.6249 118.089 54.7332 117.522C54.5601 117.941 54.1327 117.734 53.6636 117.771Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.2608 118.204C51.6733 118.204 50.7668 118.148 50.7579 118.196C50.375 118.473 51.0236 118.761 50.4206 118.901L50.531 119.376C50.724 118.847 51.0378 119.02 51.3438 118.561C51.1422 118.223 51.0589 118.771 50.8961 118.79C50.877 118.728 50.8716 118.662 50.8802 118.597C50.8887 118.532 50.911 118.47 50.9456 118.414C50.9802 118.359 51.0262 118.311 51.0806 118.275C51.1351 118.239 51.1966 118.215 51.2612 118.204H51.2608Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.6684 118.879C52.7981 118.825 52.7069 118.745 52.6407 118.76C52.6275 118.618 52.8341 118.61 52.9694 118.559C52.6973 118.4 53.0303 118.179 52.7126 117.992C52.6891 117.876 52.8366 117.866 52.9228 117.818C52.8362 117.526 52.5124 117.876 52.4473 117.928C52.526 118 52.5893 118.088 52.6334 118.185C52.6775 118.283 52.7016 118.388 52.7041 118.495C52.4943 118.56 52.4191 118.408 52.2011 118.486C52.1855 118.892 52.6307 118.558 52.6681 118.878L52.6684 118.879Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.2732 121.043C42.136 121.613 42.6938 120.695 42.218 120.806C42.0213 120.852 42.2963 120.947 42.2732 121.043Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.3766 119.268C49.4001 119.384 49.2526 119.394 49.1664 119.442C49.2063 119.704 49.6003 119.398 49.7883 119.422C49.7609 119.14 49.4143 119.37 49.3492 119.149C49.2195 119.203 49.3107 119.284 49.3769 119.268H49.3766Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.7976 122.331C30.6665 122.26 30.5561 122.156 30.477 122.03C30.5564 122.416 30.0987 122.287 30.0496 122.881C29.9716 122.697 30.6907 122.72 30.6437 122.743C30.778 122.679 30.9952 122.003 31.3293 122.458C31.0693 122.864 31.6382 123.313 31.0473 123.4C31.266 123.96 31.6065 122.817 31.9345 123.445C32.2718 123.244 31.7244 123.16 31.7051 122.997C31.9801 122.882 32.0139 123.154 32.327 122.978C32.2127 122.738 32.4442 122.712 32.6284 122.657",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.228 118.034C55.3615 117.737 55.1891 117.577 54.943 117.349C54.7621 117.394 55.1332 117.896 55.228 118.034Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.4314 124.008C28.544 124.257 28.9041 123.661 28.5864 123.596C28.4215 123.663 28.6273 123.961 28.4314 124.008Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.0488 120.041C46.2692 120.027 45.949 119.578 45.7282 119.739C45.7243 120.018 45.9946 119.854 46.0488 120.041Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.9429 119.011C50.1441 119.348 50.2278 118.801 50.3906 118.782C50.2927 118.508 50.1053 118.992 49.9429 119.011Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.1231 122.078C35.0084 122.108 35.0647 122.245 35.0593 122.343C34.752 122.038 34.4207 122.295 34.1999 122.417C34.4866 122.33 35.5235 122.606 35.1231 122.078Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.1607 117.763C52.953 117.578 53.1682 118.142 53.2711 118.238C53.4802 118.216 53.5318 117.964 53.6273 118.155C53.8157 117.744 53.2939 118.05 53.1607 117.763Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.2817 120.54C42.348 120.765 42.6475 120.308 42.9941 120.374C42.8342 119.981 42.5193 120.412 42.2817 120.54Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.4103 118.918C44.9396 118.701 44.681 119.334 44.8773 119.31C45.2919 119.3 45.0115 119.02 44.9129 118.926C45.3157 118.823 45.4368 119.172 45.6452 119.382C45.341 119.463 45.6384 119.92 45.1337 119.876C44.8693 119.575 44.6274 119.254 44.41 118.917L44.4103 118.918ZM45.1067 119.758L45.3442 119.703C45.299 119.607 45.3645 119.58 45.4354 119.557C45.3581 119.354 45.1679 119.333 44.9047 119.43C45.0078 119.513 45.079 119.629 45.1063 119.759L45.1067 119.758Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.7416 118.682C50.2068 118.998 49.8485 118.067 49.6038 118.088C49.4812 117.725 50.0173 118.31 49.9325 117.886C50.3261 117.696 49.1924 118.1 49.612 117.585C49.2202 117.218 49.5122 118.123 49.2469 118.171C49.4809 118.229 49.9115 118.364 49.4763 118.618C49.6127 118.81 49.6964 118.585 49.8324 118.536C49.8777 118.632 49.8121 118.659 49.7413 118.682L49.7416 118.682Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.6991 123.552C27.6692 123.945 28.149 123.085 28.5312 123.358C28.2986 123.216 28.3499 122.73 28.4567 122.499C28.7417 122.503 28.3556 122.717 28.6583 122.828C28.939 122.766 28.9607 122.543 29.3436 122.543C28.7435 122.51 28.7641 122.179 28.0724 122.462C28.6573 122.972 27.9552 123.288 27.645 123.313C27.7048 123.468 28.1889 123.421 27.6991 123.552Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.7823 122.246C32.5792 122.401 32.9269 122.287 32.9564 122.456L32.7823 122.246Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.2839 121.682C36.3986 121.653 36.3423 121.516 36.3477 121.417C36.4492 121.417 36.4937 121.509 36.613 121.481C36.7815 121.374 36.5917 121.355 36.4666 121.39C36.4154 121.256 36.4438 121.172 36.5304 121.124C36.2373 120.788 36.2768 121.497 36.2839 121.682Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.8341 119.106C46.7315 118.945 46.5887 118.848 46.4861 118.686C46.7184 118.232 47.024 118.909 47.3182 118.493C47.2135 118.417 47.0574 118.21 47.2352 118.137C46.8491 117.982 45.6836 118.736 46.8341 119.106Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.8599 123.157C29.0213 123.054 29.1185 122.911 29.2802 122.809C29.3027 122.639 28.6786 122.893 28.8599 123.157Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.619 119.835C43.0649 120.267 42.6307 119.312 42.8651 119.277L42.619 119.835Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.0945 119.725C43.2765 120.022 43.2972 119.391 43.5148 119.377C43.5148 119.27 43.4436 119.276 43.3684 119.286L43.1309 119.341C43.1804 119.507 43.2288 119.673 43.0952 119.725L43.0945 119.725Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.7164 119.706C44.0726 119.657 44.0473 119.127 44.3105 119.568C44.7437 119.069 43.8389 119.361 43.7246 119.203C43.5693 119.348 43.7987 119.373 43.7164 119.706Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.6368 122.726C30.1963 122.77 29.7333 121.916 30.2116 121.966C30.2116 121.859 30.1404 121.865 30.0652 121.875C30.0417 121.759 30.1892 121.749 30.2754 121.701C30.2009 121.548 29.9548 121.671 29.7725 121.692C29.8355 122.254 29.9075 122.295 29.6368 122.725V122.726Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.1459 117.157C54.2756 117.104 54.1844 117.023 54.1185 117.039C54.277 116.362 54.4533 115.763 53.8894 116.591C53.8919 116.698 53.9159 116.803 53.96 116.9C54.004 116.998 54.0673 117.085 54.1459 117.157Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.5954 116.928C54.2958 117.305 54.9063 116.718 54.8607 116.992C55.1631 116.809 54.4718 116.573 55.1346 116.552C54.9979 116.337 54.7428 116.309 54.4579 116.334C54.5548 116.541 54.74 116.692 54.5957 116.928L54.5954 116.928Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.4975 123.223C27.4975 123.116 27.4263 123.122 27.3511 123.132C27.1933 123.14 27.1128 122.813 27.2681 122.776C26.8603 122.367 27.0462 123.578 27.4975 123.223Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.8629 118.134C48.6157 118.426 49.0635 118.101 49.2191 118.052C48.8437 117.468 49.1511 117.936 48.8629 118.134Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.3871 122.747C27.4801 122.911 27.5296 122.665 27.7433 122.665C27.463 122.605 27.1584 122.155 26.9476 122.474C26.9914 122.644 27.7369 122.48 27.3871 122.747Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.8918 117.163C50.7735 117.135 50.6549 117.107 50.599 116.98C50.3076 117.067 50.6578 117.391 50.7094 117.455C50.9452 117.399 50.7853 117.096 51.1297 117.107C51.1185 117.08 51.0981 117.058 51.072 117.045C51.046 117.031 51.016 117.028 50.9875 117.034C50.9589 117.041 50.9337 117.057 50.9162 117.081C50.8988 117.105 50.8902 117.133 50.8921 117.163H50.8918Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.0935 115.83C55.9866 116.019 56.0906 116.027 56.1761 116.186C56.2983 116.126 56.2018 115.931 56.3585 115.893C56.2994 115.771 56.1035 115.867 56.0657 115.71C55.9364 115.764 56.0276 115.845 56.0935 115.83Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.5053 115.984C56.5918 116.275 56.9156 115.925 56.9808 115.874C56.9291 115.739 56.7407 115.823 56.5968 115.838C56.5516 115.742 56.6171 115.715 56.688 115.692C56.3678 115.426 56.647 115.987 56.5053 115.984Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.0234 122.241C29.1531 122.187 29.0616 122.107 28.996 122.122C29.3636 121.517 29.2364 122.068 29.6179 122.103C29.5887 121.66 29.3461 121.56 29.1869 121.326C28.7983 121.518 28.6338 121.219 28.4746 121.492C28.5262 121.953 28.8386 121.995 29.0245 122.24L29.0234 122.241Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.6513 120.577C35.7464 120.82 36.0349 120.357 35.9249 120.138C35.4597 120.051 35.9469 120.558 35.6513 120.577Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.761 118.819C43.8956 118.767 43.8108 118.579 43.7966 118.435L43.761 118.819Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.9327 116.224C55.9129 115.939 55.1464 115.466 55.8919 115.5C55.8962 115.221 55.6258 115.384 55.5714 115.199C55.4164 115.797 54.9259 115.555 54.9327 116.224Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.607 118.139C45.8589 118.451 45.6341 117.842 45.3417 118.075C45.2965 117.98 45.362 117.953 45.4329 117.929C45.4026 117.814 45.2658 117.871 45.1675 117.865C45.2127 117.961 45.1472 117.988 45.0763 118.012C45.1536 118.214 45.3438 118.235 45.607 118.139V118.139Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.0119 115.558C46.7765 114.92 46.3024 116.026 46.5556 116.29C46.2924 116.387 46.1022 116.365 46.0249 116.163C46.1674 116.361 46.0737 116.721 46.0356 117.288L46.3918 117.205C46.3562 116.989 46.188 116.988 46.1624 116.758C46.1905 116.64 46.2176 116.521 46.3448 116.465C46.5211 116.468 46.4035 116.672 46.281 116.73C46.5428 117.047 46.5752 116.383 46.6728 116.263C46.8131 116.364 47.1198 116.198 47.112 116.537C47.2808 116.371 47.1241 116.003 47.1832 115.769C47.1123 115.808 47.0577 115.87 47.0293 115.946C47.0008 116.022 47.0005 116.105 47.0283 116.181C46.9268 116.181 46.8822 116.089 46.7629 116.117C46.8826 115.853 46.9054 115.529 47.3656 115.476C47.3027 115.392 47.258 115.296 47.2343 115.193C47.2106 115.091 47.2083 114.985 47.2277 114.882C47.8261 115.34 47.7011 114.284 48.4163 114.606C48.4398 114.722 48.2924 114.732 48.2062 114.78C48.2062 114.887 48.2774 114.881 48.3526 114.871L48.5901 114.816C48.6343 114.31 48.1424 114.664 48.1869 114.158C48.084 114.265 48.1275 114.46 47.8856 114.479C47.7766 114.173 48.0637 114.115 48.2774 114.012",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.7416 114.387C47.7703 114.462 47.7704 114.546 47.7418 114.622C47.7133 114.698 47.6582 114.76 47.5867 114.798",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.3764 121.622C27.4416 121.844 27.7885 121.613 27.816 121.896C28.0443 121.832 27.4473 121.445 28.0895 121.457C27.9545 121.807 28.3777 121.875 27.962 121.987C28.0931 122.393 28.2826 121.903 28.3738 122.142C28.4128 121.851 28.3442 121.555 28.1807 121.311",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.4669 114.254C50.2532 114.492 50.9655 114.176 50.6962 114.702C50.3807 114.614 50.4786 114.769 50.0743 114.721C50.1774 114.804 50.2486 114.921 50.2759 115.05C50.7276 114.718 51.097 114.338 51.5831 114.746C51.4923 115.138 51.0845 114.697 50.7511 114.94C50.8487 115.028 50.9442 115.118 50.8063 115.177C50.9527 115.506 50.9488 114.952 51.1354 114.976C51.3627 114.934 51.2248 115.491 50.8619 115.415C51.0905 115.558 51.4268 115.957 51.6576 115.606C51.5507 115.503 51.3559 115.547 51.337 115.305C51.3904 115.372 52.0423 114.62 52.1691 115.111C52.0145 114.549 51.1294 114.219 50.4669 114.254V114.254Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.0013 112.771C52.0248 112.887 51.8774 112.897 51.7912 112.945C51.6487 112.958 51.6405 112.752 51.5896 112.616C51.4984 112.661 51.4988 112.763 51.3794 112.79",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.8055 112.458C52.6531 112.377 52.6666 112.029 52.366 112.185C52.3578 112.027 52.6844 111.947 52.7222 112.102",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.9484 112.013C51.0174 112.08 51.103 112.127 51.1964 112.149C51.2897 112.172 51.3874 112.169 51.4791 112.14C51.4791 112.242 51.3876 112.287 51.4153 112.406C50.9203 111.877 51.3064 112.884 51.3708 113.293C51.493 113.234 51.3965 113.038 51.5532 113C52.0543 113.321 50.9053 113.664 51.8381 113.686C51.8381 113.787 51.7462 113.832 51.7744 113.951C51.6004 113.844 51.443 113.712 51.3074 113.559C51.289 113.78 51.3526 114 51.4861 114.177C51.6196 114.354 51.8137 114.476 52.0312 114.519C51.7281 114.297 52.0194 114.229 52.1502 114.491C52.3589 114.496 52.0365 114.05 51.9208 114.043C51.9318 113.855 52.0839 114.055 52.277 113.961C52.1794 113.871 52.0839 113.782 52.2218 113.723C52.1291 113.562 52.1202 113.759 51.9842 113.778C52.0365 113.269 52.9078 112.479 52.1559 112.36",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.2291 116.458C50.8159 116.412 51.2647 116.092 51.5304 116.137C51.301 116.07 51.1831 115.824 51.036 115.625C50.9751 116.009 51.1856 116.343 50.4886 116.504C50.5188 116.619 50.6553 116.563 50.7539 116.568C50.6981 116.688 50.6855 116.824 50.7183 116.952C50.9422 116.795 51.1531 116.621 51.3487 116.43C51.2946 116.3 51.2141 116.391 51.2298 116.458H51.2291Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.3745 115.978C54.4262 116.112 54.6146 116.027 54.7589 116.013C54.7094 115.847 54.6609 115.681 54.7945 115.629C54.5259 115.278 54.7468 116.059 54.3742 115.977L54.3745 115.978Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.6261 121.6C29.7408 121.47 29.9008 121.387 30.0738 121.371C29.9498 121.139 29.8298 121.162 29.6895 121.335C29.6608 121.259 29.6608 121.176 29.6893 121.1C29.7178 121.024 29.7729 120.961 29.8444 120.923C29.708 120.732 29.6243 120.956 29.4882 121.006",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.0379 120.093C35.2378 120.082 35.216 119.933 35.3667 119.892C35.3126 119.762 35.2321 119.854 35.2477 119.92",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.2533 116.04C49.5593 116.412 49.2419 116.35 49.3 116.781C50.0216 116.437 49.0578 115.879 50.1128 115.966C49.9806 115.884 49.8256 115.847 49.6707 115.86C49.5158 115.874 49.3694 115.937 49.2533 116.04V116.04Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.4034 115.006C56.455 115.14 56.6435 115.055 56.7873 115.041C56.8468 114.708 56.2392 114.524 56.7681 114.419C56.746 114.21 56.4938 114.159 56.6855 114.063C56.1537 113.878 56.823 114.977 56.4034 115.005V115.006Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.9446 114.11C55.8424 114.323 56.9277 113.617 57.1332 113.834C57.3861 113.722 57.0798 113.181 56.9676 113.121C56.6249 113.111 57.1813 113.662 56.8404 113.652C56.5743 113.698 56.6727 113.16 56.5555 112.966C56.1548 113.166 56.6093 113.262 56.6021 113.707C56.2702 113.73 55.8898 113.403 55.6237 113.809C55.7149 114.051 55.9012 113.563 56.1266 113.818C56.1277 113.953 55.9097 113.952 55.9446 114.11Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.5342 112.863C57.1937 112.975 57.1068 112.679 56.7659 112.792C57.0822 113.504 57.4552 113.155 57.8908 112.781C57.8299 112.627 57.3458 112.674 57.8356 112.543C57.7666 112.477 57.6809 112.43 57.5876 112.407C57.4942 112.385 57.3966 112.388 57.3049 112.416C57.3348 112.531 57.4719 112.475 57.5702 112.48C57.5145 112.6 57.5019 112.736 57.5346 112.864L57.5342 112.863Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.7401 122.128C25.9602 122.112 25.9581 121.959 25.8313 121.981L25.7401 122.128Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.6566 115.035C54.9676 115.249 55.1998 114.445 54.7564 114.386C54.5786 114.457 54.9295 114.811 54.6566 115.035Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.9432 115.201C54.4326 115.269 54.0957 114.821 54.4825 114.825C53.9995 114.216 54.5786 114.118 54.7094 113.645C54.9886 113.577 55.1069 113.768 55.4499 113.598C55.2137 113.248 55.8135 113.418 55.577 113.067C55.1582 113.077 55.2444 113.402 55.0656 113.562C54.7806 113.529 54.6716 113.216 54.4522 113.078C54.2029 113.373 54.6584 113.47 54.4989 113.819C54.4278 113.95 54.324 114.06 54.1975 114.14C54.0056 114.23 53.9518 114.099 53.9047 113.957C53.7112 114.143 53.5914 114.394 53.5674 114.661C53.9731 114.711 53.8128 114.408 53.9877 114.313C53.9877 114.42 54.059 114.415 54.1341 114.405C54.063 114.536 53.9592 114.646 53.8328 114.725C53.8827 115.105 54.106 114.343 54.2171 114.761C54.3304 115.035 53.6604 114.821 53.9432 115.2V115.201Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.9142 119.013C35.9377 119.129 35.7902 119.139 35.704 119.187C35.8155 119.44 36.3562 119.133 36.4164 119.021C36.3133 118.938 36.2421 118.822 36.2148 118.692C36.1215 118.769 36.0264 118.846 36.0324 118.985C35.8629 118.874 35.7204 119.009 35.9135 119.013H35.9142Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.45 116.923C45.71 116.916 45.7456 116.768 45.8977 116.694C45.8436 116.564 45.7631 116.656 45.7787 116.722C45.7493 116.724 45.7201 116.716 45.6964 116.698C45.6726 116.681 45.6559 116.655 45.6493 116.627C45.6426 116.598 45.6464 116.568 45.66 116.541C45.6736 116.515 45.6962 116.495 45.7235 116.484",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.2256 115.921C49.159 115.756 48.8612 115.962 48.8138 115.766C48.5659 115.878 49.1593 116.238 49.2256 115.921Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.2889 115.656C49.4799 115.784 49.5422 115.63 49.8834 115.517C49.8396 115.336 49.4685 115.202 49.6458 115.573C49.4799 115.567 49.4104 115.407 49.2341 115.418C49.0656 115.525 49.2555 115.544 49.3805 115.509C49.4257 115.605 49.3602 115.632 49.2893 115.656H49.2889Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.0011 114.919C53.3455 114.93 53.1856 114.627 53.4214 114.57C53.265 114.26 52.8746 115.046 52.8632 114.324C52.7564 114.327 52.6511 114.351 52.5537 114.395C52.4564 114.439 52.3689 114.502 52.2966 114.581C52.3585 114.726 52.6884 114.654 52.6527 114.498C52.8308 114.539 52.9331 114.701 53.0007 114.918L53.0011 114.919Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.9543 115.84C48.043 115.019 47.3264 115.377 47.9543 115.84V115.84Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.0106 114.987C49.4717 114.319 49.1408 114.85 50.0106 114.987V114.987Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.5487 112.377C58.8486 112.278 58.3378 112.211 58.4383 111.902C58.0639 112.102 58.3962 112.192 58.5487 112.377Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.1463 113.953C50.0298 113.976 50.0202 113.829 49.9721 113.743C49.6473 113.969 50.1107 114.258 50.4116 114.017C50.3846 113.729 50.4957 113.527 50.3372 113.157C50.2649 113.236 50.1774 113.299 50.0801 113.343C49.9827 113.388 49.8774 113.412 49.7705 113.414C49.8599 113.652 50.3048 113.32 50.3287 113.66C50.3005 113.778 50.2738 113.897 50.1463 113.953V113.953Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.6097 113.809C48.7166 114.113 48.1702 114.01 48.3636 114.367C49.0443 114.215 48.4672 113.901 48.7646 113.397",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.7897 114.036C49.7595 113.921 49.6227 113.978 49.5244 113.972C49.4709 113.736 49.8136 113.746 49.6515 113.442C49.5867 113.759 48.9919 113.399 49.2398 113.287C49.2398 113.18 49.1685 113.185 49.0934 113.195L48.8555 113.251C49.207 113.448 49.2868 114.081 49.7894 114.034L49.7897 114.036Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.9046 112.9C50.9822 112.486 50.2635 112.965 49.7798 112.911C49.8717 113.329 50.6663 112.714 50.9046 112.9Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.7095 111.497C53.8485 111.546 53.8958 111.742 54.1213 111.652C54.1786 111.233 53.7156 111.652 53.7733 111.232C53.4777 111.294 53.758 112.119 53.7095 111.497Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.87 141.202C60.8846 140.704 60.0838 141.516 60.0984 141.018C59.5838 141.46 60.7464 141.698 60.87 141.202Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.5162 140.456C62.6483 140.391 62.648 140.242 62.8218 140.203C62.7563 140.071 62.6081 140.071 62.5689 139.897C62.4368 139.963 62.4371 140.111 62.2637 140.151C62.3296 140.283 62.4777 140.283 62.5162 140.456Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.7769 142.04C52.45 142.051 51.8794 141.056 51.7088 140.963C51.2939 141.375 51.6525 141.453 51.7769 142.04Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.6943 136.472C68.8611 136.282 69.0937 136.163 69.345 136.138C69.3294 135.82 68.3057 136.054 68.6943 136.472Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.0888 137.824C62.652 137.961 62.4133 136.933 61.9684 137.305L62.0888 137.824Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.2064 138.361C58.382 138.04 58.3132 137.243 58.0995 137.111C57.8221 137.522 57.9261 137.942 58.2064 138.361Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.2517 139.381C52.7118 139.07 51.9012 138.87 51.613 138.982C51.6526 139.393 52.1569 139.059 52.2517 139.381Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.9028 139.047C53.1425 138.95 52.8433 138.517 53.1279 138.448C52.8041 137.938 52.6734 138.729 52.9028 139.047Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.5586 139.56C47.8514 140.05 47.9736 139.255 48.2097 139.227C47.9169 138.736 47.7948 139.532 47.5586 139.56Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.4734 138.368C53.8609 138.363 53.7452 138.045 53.6985 137.769C53.5664 137.835 53.5667 137.983 53.3933 138.022L53.4734 138.368Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.0819 140.285C42.3216 140.188 42.0224 139.756 42.307 139.686C41.9832 139.177 41.8529 139.967 42.0819 140.285Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.0267 138.026C51.4976 137.974 50.6403 137.095 51.3829 137.214C50.9124 136.697 50.7236 137.574 51.0267 138.026Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.1529 142.228C32.5148 141.825 31.5142 141.161 32.6035 141.03C32.4653 140.636 31.8198 141.107 31.7394 141.231C31.8156 141.662 31.9068 142.07 32.1529 142.228Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.787 136.97C55.2009 136.8 54.6417 136.298 54.3211 136.532C54.4354 136.744 54.689 136.733 54.787 136.97Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.2495 139.851C39.61 139.829 39.7816 139.69 39.6876 139.385L39.1694 139.505L39.2495 139.851Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.0098 133.553C63.806 133.804 63.6315 133.838 63.4512 133.5C62.9668 133.92 64.3816 134.506 64.0098 133.553Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.6463 136.375C52.6556 136.726 53.4919 136.446 53.1247 136.082L52.7792 136.162C52.8451 136.301 52.7496 136.34 52.6467 136.375L52.6463 136.375Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.8287 132.766C65.615 132.88 65.6275 133.133 65.3906 133.232C65.5623 133.646 66.0645 133.087 65.8287 132.766Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.2751 133.127C64.5148 133.03 64.2156 132.597 64.5002 132.529C64.232 132.095 64.0161 132.895 63.4637 132.769C63.7308 133.388 64.0079 132.508 64.2751 133.127Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.4536 139.175C37.6933 139.078 37.3941 138.646 37.6787 138.577C37.3546 138.067 37.2242 138.857 37.4536 139.175Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.6112 137.048C47.035 136.922 46.5257 136.451 46.4505 136.357C45.9593 136.591 46.7016 136.688 46.6112 137.048Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.9357 136.891C44.8288 136.353 44.2945 136.497 43.7784 136.613C44.0114 136.952 44.3462 137.126 44.9357 136.891Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.0692 139.517C32.3784 139.301 32.55 138.769 32.2142 138.572C31.9912 138.777 32.0934 139.185 32.0692 139.517Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.6273 134.326C53.6433 134.644 54.667 134.409 54.2784 133.993C53.9632 134.042 53.9628 134.288 53.6273 134.326Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.1638 131.464C65.8028 131.478 65.328 130.832 65.1759 130.733C64.9536 130.841 65.1331 131.198 65.1638 131.464Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.0311 129.724C63.4256 129.573 63.6852 130.928 63.38 130.057C63.2593 130.207 63.0904 130.311 62.902 130.351C63.1951 130.843 63.6546 130.903 63.1427 131.387C63.7126 131.589 64.0211 130.363 64.0311 129.724Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.7746 130.958C66.2476 130.958 66.3802 130.745 66.1725 130.319C66.0542 130.541 65.5477 130.521 65.7746 130.958Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.5227 133.49C52.7874 133.963 52.9053 133.164 53.3865 133.29C53.2743 132.995 52.9979 132.965 52.6153 133.104C52.6901 133.299 52.6485 133.421 52.5227 133.49V133.49Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.404 130.548C64.7602 130.056 64.4952 129.502 64.0834 129.166C63.6631 129.554 64.5069 129.887 64.404 130.548Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.0487 129.387C67.1787 129.732 67.7301 129.4 67.8601 129.744C68.0382 129.657 67.8975 129.373 68.1255 129.316C67.4241 129.401 67.9117 128.916 67.0487 129.387Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.2922 133.694C49.3669 133.889 49.6409 133.765 49.8506 133.746C49.8346 133.456 49.6181 133.487 49.5575 133.268C49.3794 133.354 49.5201 133.638 49.2922 133.695V133.694Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.0693 132.301C55.8606 132.084 55.6836 131.814 55.2579 131.945C55.4681 132.161 55.6451 132.431 56.0693 132.301Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.5865 126.958C73.5303 126.855 73.4389 126.775 73.329 126.734C73.2191 126.693 73.098 126.692 72.9877 126.733C72.9927 127.121 73.3111 127.005 73.5865 126.958Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.2877 136.136L33.6332 136.056C33.6285 135.669 33.3101 135.785 33.0348 135.831C33.1003 135.963 33.2485 135.963 33.2877 136.136Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.5672 134.96C37.7368 135.374 38.3889 134.908 38.0053 134.494C37.8557 134.647 37.9188 134.933 37.5672 134.96Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.4384 133.182C44.4965 133.564 45.0696 133.118 45.3424 133.154C45.2847 132.773 44.7116 133.218 44.4384 133.182Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.4374 130.345C57.9286 130.111 57.1881 130.014 57.2768 129.654C57.0987 129.74 57.2394 130.025 57.0114 130.081C57.0976 130.259 57.3822 130.117 57.4388 130.346L57.4374 130.345Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.8877 136.794C29.2389 136.785 28.9589 135.948 28.5946 136.316L28.6747 136.662C28.8147 136.596 28.8535 136.691 28.8877 136.794Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.3332 134.75L34.9877 134.831C35.1376 134.951 35.2411 135.12 35.2809 135.309C35.6413 135.287 35.813 135.148 35.719 134.843C35.1975 135.33 35.7158 134.763 35.3332 134.75V134.75Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.2623 132.809C45.3593 132.708 45.4277 132.584 45.4602 132.448C45.4928 132.312 45.4884 132.171 45.4475 132.037C45.1529 132.15 45.1227 132.426 45.2623 132.809Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.5188 125.881C73.6219 125.825 73.7013 125.733 73.7427 125.623C73.784 125.513 73.7844 125.392 73.7439 125.282C73.4536 125.298 73.4842 125.514 73.2655 125.575C73.3307 125.708 73.4789 125.707 73.5188 125.881Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.106 135.369C31.2129 135.591 31.5719 135.411 31.8373 135.381C31.6962 134.992 31.2838 135.091 31.106 135.369Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.7926 131.957C46.2393 132.543 45.9899 131.516 46.2307 131.491C45.7844 130.905 46.0337 131.932 45.7926 131.957Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.9613 128.666C60.315 128.526 59.8085 127.838 59.4552 128.055C59.3818 128.644 59.8238 128.412 59.9613 128.666Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.3856 134.192C36.0197 133.705 34.3787 133.561 35.5705 133.421C35.3568 132.751 35.0654 133.673 34.799 133.236C34.702 133.336 34.6337 133.46 34.6011 133.596C34.5686 133.732 34.5729 133.873 34.6138 134.007C34.997 133.868 35.2734 133.898 35.3856 134.192Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.0127 125.269C73.3069 125.157 73.3375 124.88 73.1979 124.498C72.9033 124.611 72.8727 124.887 73.0127 125.269Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.085 135.291C29.2404 135.288 29.3935 135.253 29.5351 135.189C29.6767 135.125 29.8038 135.033 29.9089 134.918C29.8949 134.876 29.8657 134.84 29.827 134.819C29.7883 134.797 29.7428 134.791 29.6996 134.801C29.6563 134.811 29.6184 134.836 29.5932 134.873C29.568 134.91 29.5574 134.954 29.5634 134.998C29.3942 135.034 29.3803 134.818 29.3105 134.693C29.1783 134.758 29.1783 134.907 29.0049 134.946L29.085 135.291Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.321 133.529C34.2001 133.679 34.0311 133.783 33.8426 133.822C34.0065 134.285 34.5276 134.048 34.321 133.529Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.1293 133.473C36.1389 133.825 36.9749 133.545 36.6073 133.18L36.2618 133.26C36.3277 133.4 36.2323 133.439 36.1293 133.473Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.4169 125.458C71.4699 125.215 71.6099 125 71.8106 124.853C72.0112 124.705 72.2587 124.637 72.5065 124.659C72.8054 124.054 71.1142 125.162 71.0839 124.807C70.5938 125.1 71.3895 125.222 71.4169 125.458Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.2544 134.838L30.6003 134.758C30.5957 134.37 30.2772 134.486 30.0015 134.533C30.0678 134.665 30.2145 134.664 30.2544 134.838Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.9823 134.436C32.7477 134.138 31.5994 133.423 31.9823 134.436V134.436Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.4344 125.573C65.5969 126.069 65.1669 126.195 65.3294 126.691C65.6895 126.607 65.7237 125.121 66.0731 125.971C66.674 125.478 66.0307 125.078 65.4344 125.573Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.9971 131.282C44.3985 131.664 44.9182 130.882 44.7006 130.391C44.5158 130.724 44.2782 131.025 43.9971 131.282Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.7983 130.398C47.7421 130.295 47.6508 130.215 47.5408 130.174C47.4309 130.133 47.3098 130.132 47.1995 130.173C47.2042 130.561 47.5229 130.445 47.7983 130.398Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.4062 134.721C28.7239 134.705 28.4895 133.681 28.0728 134.069C28.123 134.385 28.3691 134.385 28.4062 134.721Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.0975 134.56C29.458 134.538 29.63 134.4 29.5356 134.094L29.0174 134.215L29.0975 134.56Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.658 129.784C49.8717 129.67 49.8588 129.417 50.0961 129.318C49.9265 128.904 49.4247 129.464 49.658 129.784Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.5396 124.005C74.7177 123.918 74.577 123.634 74.805 123.577C74.4776 122.94 73.9964 124.022 73.8205 123.26C73.7235 123.36 73.6552 123.485 73.6227 123.62C73.5902 123.756 73.5946 123.898 73.6356 124.031C74.0135 124.021 74.0655 123.807 74.2864 123.698C74.4555 123.663 74.4694 123.878 74.5392 124.003L74.5396 124.005Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.4396 134.067L30.7851 133.987C30.6351 133.866 30.5316 133.697 30.492 133.508C30.1554 133.688 30.1885 133.862 30.4396 134.067Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.3034 133.865C31.1513 133.754 30.9244 133.454 31.183 133.347C30.7609 132.646 30.6598 134.325 31.3034 133.865Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.8973 125.598C66.289 124.946 67.4747 125.137 67.8138 124.839C67.4409 124.474 66.5885 125.049 66.2587 125.2C66.4806 125.318 66.4607 125.825 66.8973 125.598Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.1799 124.835C70.5361 124.843 70.6027 123.834 70.0193 124.144C70.3879 124.421 70.0549 124.367 70.1799 124.835Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.1336 129.077C51.4239 129.061 51.3929 128.844 51.612 128.784C51.6024 128.433 50.7661 128.714 51.1336 129.077Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.9571 128.704C52.1634 129.099 52.8515 128.592 52.568 128.198C51.9596 128.114 52.5658 128.787 51.9571 128.704Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.4118 125.064C68.763 125.055 68.483 124.219 68.1187 124.586L68.1988 124.932C68.3384 124.865 68.3769 124.961 68.4125 125.064H68.4118Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.5231 127.179C58.652 127.036 58.7834 126.898 58.8686 127.099C59.0228 127.096 59.016 126.992 59.0011 126.885L58.9209 126.54L58.4027 126.66L58.5231 127.179Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.7641 131.505C37.21 131.217 36.5457 130.782 36.5233 130.468C36.0481 130.803 36.8492 131.018 36.7641 131.505Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.1531 126.769C57.6123 126.39 56.8461 126.024 56.4743 126.199C56.3727 126.914 57.2543 126.052 57.1531 126.769Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.8881 124.79C64.8977 125.141 65.7337 124.859 65.3664 124.496L65.0209 124.576C65.0868 124.716 64.9914 124.755 64.8881 124.79Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.2876 124.583C59.6073 124.266 59.7818 125.74 58.7204 125.676C59.0224 125.745 59.1057 126.165 59.5317 126.032C59.6667 125.476 60.03 125.063 60.2876 124.583Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.9841 124.817C63.8772 124.596 63.5182 124.775 63.2528 124.805C63.3942 125.195 63.8067 125.095 63.9841 124.817Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.7853 123.935C67.5509 123.695 67.2318 123.644 67.054 123.922C67.1954 124.312 67.6097 124.212 67.7853 123.935Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.6917 129.582C42.7665 129.777 43.0407 129.653 43.2502 129.634L43.0895 128.943C42.8936 129.018 43.0183 129.292 43.0372 129.501L42.6917 129.582Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.93 125.395C60.0265 125.635 60.4596 125.336 60.5287 125.621C60.7068 125.534 60.5644 125.25 60.7941 125.193C60.5298 124.722 60.2616 125.427 59.93 125.395Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.3103 132.74C28.2747 132.245 27.6286 132.727 27.4989 132.382C27.0106 132.807 28.0403 132.749 28.3103 132.74Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.8586 131.551C31.6599 131.238 31.2887 131.197 30.8745 131.234C31.1007 131.5 31.3351 131.759 31.8586 131.551Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.8863 124.809C61.3764 124.707 60.9996 123.847 60.513 123.985C60.908 124.215 60.4243 124.537 60.8863 124.809Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.0861 128.529C44.2642 128.443 44.1235 128.158 44.3515 128.101C44.349 127.947 44.2446 127.954 44.1378 127.969L43.7923 128.049C43.8083 128.339 44.0245 128.308 44.0854 128.527L44.0861 128.529Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.9499 128.328C45.2402 128.312 45.2096 128.096 45.4283 128.035C45.4194 127.684 44.5827 127.965 44.9499 128.328Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.9242 127.406C49.2754 127.397 48.9954 126.56 48.631 126.928L48.7112 127.273C48.8508 127.207 48.8893 127.303 48.9249 127.406H48.9242Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.1764 122.469C70.7708 122.115 69.8754 121.75 70.2811 121.352C69.5331 121.028 70.0318 121.808 70.1764 122.469Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.5553 121.734C73.2969 121.654 73.339 121.138 73.817 120.895C73.491 120.498 73.3336 120.435 72.8731 120.75C73.9641 121.336 72.3723 120.892 72.5553 121.734Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.1472 121.132C75.5341 120.93 75.2562 120.313 76.0637 120.373C76.6354 119.95 75.3738 120.574 75.5978 119.935C75.3738 120.024 75.4425 120.727 75.2523 120.015C74.8972 120.226 74.8662 120.959 75.1472 121.132Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.3552 126.112C51.1785 125.987 50.9724 125.909 50.7568 125.887C50.682 125.693 50.7237 125.571 50.8494 125.501C50.6218 125.136 49.7406 125.581 50.0658 126.047C50.4811 125.408 50.5644 126.64 51.3552 126.112V126.112Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.9847 128.107C42.5065 128.136 42.3765 127.759 42.8085 127.733C42.7733 127.444 41.5972 127.647 41.9847 128.107Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.0417 125.538C52.9043 125.283 52.464 125.516 52.5356 124.927C52.4325 124.983 52.353 125.074 52.3117 125.184C52.2704 125.294 52.2699 125.415 52.3105 125.526C52.5439 125.622 52.8053 125.626 53.0417 125.538Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.062 125.634C51.2323 126.048 51.7342 125.488 51.4998 125.168C51.2875 125.282 51.2993 125.535 51.062 125.634Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.1756 125.325C53.5318 125.04 53.6469 125.254 53.9592 124.779C53.7715 124.184 53.2668 125.269 53.228 124.767C53.0737 124.769 53.0805 124.874 53.0955 124.981L53.1756 125.325Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.4694 123.399C61.806 123.219 61.7729 123.043 61.5218 122.84L61.1763 122.92C61.1923 123.211 61.4085 123.18 61.4694 123.399Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.32 126.785L45.6655 126.705C45.6605 126.318 45.3424 126.434 45.0667 126.48C45.1323 126.613 45.2804 126.612 45.32 126.785Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.9603 127.616C41.0785 127.395 41.585 127.414 41.3581 126.977C41.2399 127.199 40.7334 127.179 40.9603 127.616Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.3757 126.641C43.5925 126.187 43.6085 127.315 44.3757 126.641V126.641Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.6759 120.299C71.6851 120.65 72.5215 120.37 72.1542 120.006L71.8087 120.086C71.8743 120.226 71.7792 120.265 71.6759 120.299Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.513 129.678C30.9134 129.966 32.2049 129.559 31.7746 128.839C31.6211 129.582 30.9362 129.323 30.513 129.678Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.3284 128.045C38.6226 127.933 38.6532 127.656 38.5136 127.274C38.2835 127.669 37.9615 127.186 37.6897 127.647C37.7845 127.968 38.2885 127.634 38.3284 128.045Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.1523 127.672C39.4425 127.656 39.4119 127.44 39.6306 127.379C39.5444 127.201 39.2598 127.341 39.2032 127.114C39.008 127.189 39.1319 127.462 39.1523 127.672Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.0332 121.893C64.881 121.866 64.1518 121.016 64.0332 121.893V121.893Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.4791 127.928C36.9247 128.384 36.8071 127.26 37.4354 127.342C37.4426 126.986 36.4335 126.919 36.7444 127.502C36.5503 127.577 36.4282 127.536 36.3587 127.41C36.0916 127.59 36.343 127.832 36.6119 127.715C36.6786 127.855 36.5835 127.894 36.4791 127.928Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.0423 126.441C34.8927 126.594 34.9557 126.88 34.6042 126.907C34.9358 127.1 34.976 127.634 34.4189 127.678C34.4467 128.109 35.1837 127.4 35.0576 128.077C35.4344 128.002 34.6594 126.468 35.3753 127.092C35.8658 126.799 35.0697 126.677 35.0419 126.441H35.0423Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.3006 127.141C38.0915 126.923 37.9149 126.653 37.4892 126.785C37.6979 127.001 37.875 127.271 38.3006 127.141Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.6562 120.655C65.4394 121.109 65.4234 119.98 64.6562 120.655V120.655Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.4084 128.842C29.3081 128.745 29.1836 128.677 29.0479 128.645C28.9122 128.612 28.7703 128.616 28.637 128.657C28.7499 128.952 29.0255 128.982 29.4084 128.842Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.2205 126.796C38.581 126.774 38.753 126.634 38.6586 126.33L38.1404 126.45L38.2205 126.796Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.1785 118.544C72.5026 118.84 72.7345 118.235 73.2552 118.476L73.0946 117.784C72.774 118.011 72.353 118.112 72.7092 117.692C72.5478 117.084 72.2233 118.19 72.1507 117.639C71.7567 117.788 72.2383 118.482 71.62 118.491C71.9516 118.964 72.2885 118.239 72.2308 117.985C72.6582 117.906 72.4 118.548 72.1785 118.543V118.544Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.238 118.812C70.8492 119.077 71.0405 118.77 70.5033 118.385C70.3253 118.473 70.4656 118.757 70.238 118.812Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.4614 117.781C75.2121 117.392 75.0746 116.819 74.5293 116.905C74.3772 117.529 74.8377 117.786 75.4614 117.781Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.6991 124.098C46.8687 124.511 47.5212 124.046 47.1372 123.632C46.9866 123.785 47.0507 124.071 46.6991 124.098Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.2346 118.398C71.3555 118.248 71.5245 118.145 71.7129 118.105C71.543 118.014 71.3567 117.958 71.165 117.94C70.9732 117.922 70.7797 117.943 70.5959 118C70.6907 118.323 71.1947 117.988 71.2346 118.398Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.7268 117.355C75.9231 117.28 75.798 117.006 75.7792 116.796L75.2609 116.917C75.3745 117.13 75.6281 117.118 75.7268 117.355Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.5382 125.811C38.4379 125.714 38.3134 125.646 38.1777 125.613C38.042 125.581 37.9001 125.585 37.7667 125.626C37.8789 125.92 38.1553 125.951 38.5382 125.811Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.9439 128.837C24.2342 128.82 24.2035 128.604 24.4222 128.544C24.4126 128.192 23.5767 128.475 23.9439 128.837Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.8596 122.835C45.6925 122.879 45.7744 123.078 45.7669 123.221C45.2993 123.346 45.3523 123.014 45.0759 123.382C45.3873 123.791 46.2439 123.606 45.8596 122.836V122.835Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.6862 125.281C37.9085 125.174 37.7293 124.815 37.6987 124.549C37.3094 124.691 37.4087 125.103 37.6862 125.281Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.6236 124.598C41.2117 124.357 40.609 123.627 39.9448 124.028C39.922 124.617 40.4762 124.282 40.6236 124.598Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.725 117.374C72.2867 117.379 71.9469 116.823 72.5086 116.828C72.2935 116.471 71.5038 116.973 71.725 117.374Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.9884 124.614C38.7822 124.392 38.374 124.493 38.0442 124.469C38.3758 125.013 38.3437 124.832 38.9884 124.614Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.4904 119.57C62.2341 119.285 61.0245 118.699 61.7679 118.413C61.6325 118.274 61.2265 118.263 61.515 118.107C61.2126 118.039 61.1292 117.619 60.7032 117.751C60.778 117.946 60.7367 118.068 60.6106 118.137C61.2019 118.134 61.4986 118.735 60.8112 119.001C61.3672 119.184 61.2617 119.122 61.4901 119.571L61.4904 119.57Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.3393 117.282C71.2962 116.718 70.5172 117.336 70.3548 116.964C69.9042 117.402 70.9689 117.379 71.3393 117.282Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.3447 123.37C44.7369 122.241 43.7313 122.713 44.3447 123.37V123.37Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.8477 121.162C53.8153 120.858 53.4491 120.783 53.7273 120.644C53.7252 120.49 53.6205 120.496 53.5136 120.511L53.1681 120.591C53.2251 121.055 53.4046 121.32 53.8477 121.162Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.2619 127.853C24.5725 127.507 24.04 127.459 24.2341 126.949C24.0917 127.254 23.5634 127.319 23.7034 127.8C23.9072 127.549 24.0817 127.515 24.2619 127.853Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.9127 127.519L25.4309 127.399L25.2703 126.708C25.2019 127.01 24.7819 127.093 24.9141 127.519H24.9127Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.131 117.995C65.5206 118.505 65.5505 117.588 65.7418 117.489C65.2663 117.106 65.1164 117.925 65.131 117.995Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.9823 126.622C28.196 126.509 28.1835 126.255 28.4204 126.157C28.2512 125.744 27.7486 126.302 27.9823 126.622Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.559 123.935C39.0247 123.432 39.9216 123.266 39.0126 123.151C38.6479 123.379 39.0935 124.26 39.559 123.935Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.4086 121.647C49.6045 121.572 49.4798 121.299 49.461 121.089C49.1005 121.111 48.9285 121.25 49.0228 121.555C49.1771 121.552 49.1703 121.448 49.1553 121.341C49.3245 121.305 49.3384 121.521 49.4082 121.646L49.4086 121.647Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.0114 122.719C43.7894 122.601 43.8094 122.094 43.3727 122.321C43.5943 122.439 43.5743 122.946 44.0114 122.719Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.5566 126.359C27.9509 126.22 27.4801 125.575 27.3558 125.495C26.9248 125.571 26.5173 125.662 26.3584 125.908C26.5084 126.029 26.612 126.198 26.6516 126.387C26.8913 126.29 26.5921 125.857 26.8767 125.788C26.9543 126.415 27.4174 125.462 27.5566 126.359Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.6945 118.893C60.1953 118.909 59.9627 118.469 60.3054 118.387C60.0992 117.993 59.411 118.499 59.6945 118.893Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.4957 118.011C64.0172 118.041 63.8876 117.663 64.3196 117.638C64.2843 117.348 63.1082 117.551 63.4957 118.011Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.6464 123.136C40.9406 123.024 40.9713 122.747 40.8317 122.364C40.7346 122.465 40.6662 122.589 40.6336 122.725C40.6011 122.861 40.6055 123.003 40.6464 123.136Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.471 119.926C54.5825 119.774 54.8817 119.547 54.9893 119.806C55.6906 119.382 54.0116 119.281 54.471 119.926Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.4082 119.243C57.5371 119.1 57.6685 118.962 57.7537 119.163C57.9207 119.119 57.8384 118.92 57.8463 118.777C57.7067 118.843 57.6682 118.747 57.6326 118.644C57.5004 118.71 57.5008 118.858 57.3273 118.897L57.4082 119.243Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.3072 121.225C47.6153 121.64 48.2276 121.027 47.8771 120.546C47.5608 120.693 47.8963 121.247 47.3072 121.225Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.3217 123.312C38.6365 123.262 38.6369 123.016 38.9728 122.979C38.9567 122.661 37.9331 122.895 38.3217 123.312Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.9781 115.726C71.3293 115.717 71.0493 114.881 70.685 115.248L70.7651 115.593C70.9047 115.528 70.9439 115.623 70.9781 115.726Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.186 120.706C46.5449 120.872 46.7386 121.014 46.1495 120.947C46.0266 121.544 47.5593 121.188 47.186 120.706Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.7858 123.769C34.9067 123.619 35.0757 123.516 35.2642 123.476C34.7655 123.358 34.8011 122.985 34.8506 122.479L34.1596 122.639C35.023 123.012 34.2234 123.187 33.5488 123.145C33.7461 124.187 34.6686 122.599 34.7862 123.768L34.7858 123.769Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.0687 123.006C37.7161 122.576 37.0465 122.657 36.6062 122.982C36.9521 123.218 37.4707 123.176 38.0687 123.006Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.2712 121.898C41.2869 122.216 42.3109 121.982 41.9223 121.565C41.544 121.576 41.4924 121.789 41.2712 121.898Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.2958 119.984C49.7726 119.64 50.4002 119.181 50.7863 118.959C50.6604 118.846 50.5038 118.771 50.3359 118.745C50.168 118.72 49.9963 118.744 49.8421 118.815C50.412 119.929 49.1343 119.127 49.2191 120.052C49.8114 120.171 49.5981 119.622 50.2958 119.984V119.984Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.7627 118.017C59.2258 117.961 59.4911 117.782 59.3326 117.339C59.2696 117.644 58.4785 117.496 58.7627 118.017Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.0088 117.496C61.5616 117.021 61.2706 116.939 61.2464 116.166C60.6103 116.589 61.1342 116.816 61.0088 117.496Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.1403 114.446C74.551 114.406 74.2162 113.902 74.5382 113.807C74.2753 113.376 73.8557 114.049 74.1403 114.446Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.3097 113.992C75.6627 114.299 76.566 113.949 75.9206 113.486C75.6666 113.623 75.8992 114.063 75.3097 113.992Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.5606 116.72C63.6637 116.664 63.7432 116.573 63.7846 116.463C63.8259 116.353 63.8263 116.232 63.7857 116.122C63.3982 116.127 63.5136 116.446 63.5606 116.72Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.1129 118.784C53.2234 119.16 53.8627 118.686 54.1897 118.716C54.0796 118.339 53.4399 118.812 53.1129 118.784Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.044 122.516C37.2335 122.19 37.8935 122.158 38.3865 122.022C38.3117 121.828 38.353 121.706 38.4791 121.636C38.3818 121.397 37.9494 121.696 37.8803 121.411C37.8696 121.945 36.8691 121.865 37.044 122.515V122.516Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.7275 118.691C51.8887 118.361 51.6476 119.484 52.7275 118.691V118.691Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.9253 116.737L62.2708 116.657C62.2659 116.269 61.9474 116.385 61.6721 116.431C61.7373 116.563 61.8858 116.563 61.9253 116.737Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.0758 124.285C27.2895 124.171 27.2771 123.918 27.5139 123.819C27.3429 123.405 26.8411 123.964 27.0758 124.285Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.2174 120.071C45.1041 119.699 44.696 119.801 44.2732 119.926C44.3991 120.04 44.5557 120.115 44.7236 120.14C44.8914 120.166 45.0631 120.142 45.2174 120.071Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.4084 117.29C57.2237 117.621 57.4014 116.464 56.4084 117.29V117.29Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.406 119.712L44.7515 119.632C44.6016 119.511 44.4981 119.342 44.4584 119.154C44.1218 119.335 44.1549 119.509 44.406 119.712Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.5892 118.509C49.7563 118.465 49.6743 118.266 49.6818 118.123C50.1178 118.344 50.283 118.394 50.7589 118.055C50.4383 117.859 49.9358 117.953 49.4692 117.991L49.5892 118.509Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.7456 113.997C62.6434 114.538 62.9255 114.879 63.5046 114.913C63.2197 114.749 62.9607 114.078 63.6895 114.141L63.5691 113.623C63.2208 113.971 63.3322 114.062 62.7456 113.997Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.6385 117.537C51.5874 117.952 51.1318 116.504 50.6385 117.537V117.537Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.6858 116.133C57.156 116.604 57.2771 115.628 57.0035 115.148C56.6313 115.31 57.2493 116.089 56.6858 116.133Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.9471 117.698C50.4376 117.405 49.6415 117.283 49.6138 117.047C49.1236 117.339 49.9197 117.462 49.9471 117.698Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.1949 117.609C47.259 117.908 47.6141 116.507 48.0587 117.408C48.4996 117.123 48.1178 116.66 47.9906 116.331C47.7221 117.201 47.7132 116.545 46.8213 116.785C47.6081 117.012 47.061 116.798 47.1949 117.609V117.609Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.3382 116.231C52.1113 115.551 52.1288 115.833 51.752 115.275C51.2797 115.539 51.9845 115.809 51.9525 116.139C51.8866 116.398 51.4716 116.161 51.1286 116.512C51.3352 117.079 51.9728 116.419 52.3397 116.231H52.3382Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.0698 116.244C52.9558 116.031 52.7022 116.043 52.6036 115.806C52.1897 115.976 52.7489 116.478 53.0698 116.244Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.7165 112.659C68.316 112.552 67.5659 112.079 68.2469 111.808C68.1347 111.513 67.8583 111.483 67.4757 111.622C67.5196 111.789 67.7183 111.707 67.8615 111.715C67.864 112.062 67.4401 112.142 67.7165 112.659Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.4399 114.701C53.0898 114.945 52.3995 115.304 52.6285 114.343C51.8371 114.244 52.8893 115.294 52.0978 115.195C52.3094 115.85 53.5692 115.449 53.4399 114.701Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.0904 116.773C46.0997 117.124 46.936 116.844 46.5688 116.479L46.2233 116.56C46.2888 116.699 46.1933 116.738 46.0904 116.773Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.0788 112.695C62.3007 112.813 62.2808 113.32 62.7178 113.093C62.4959 112.974 62.5162 112.467 62.0788 112.695Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.7259 114.352C56.0625 114.172 56.0294 113.996 55.7783 113.793L55.4328 113.874C55.5826 113.995 55.6862 114.164 55.7259 114.352Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.5829 113.324C58.377 113.102 57.9688 113.203 57.639 113.179C57.5963 113.801 58.2388 113.323 58.5829 113.324Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.3182 111.346C66.4439 111.769 66.9148 111.26 67.0092 111.185C66.7755 110.694 66.6783 111.436 66.3182 111.346Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.2164 113.328C56.2118 113.019 56.0059 113.033 55.789 113.062C55.6907 112.656 55.9671 112.484 55.7209 111.985C55.5539 112.029 55.6362 112.228 55.6283 112.371C55.5881 112.74 55.2746 112.939 54.8846 113.09C55.1952 113.383 55.7395 113.297 56.2146 113.328H56.2164Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.5588 112.834C57.7929 113.325 57.8897 112.583 58.2498 112.673C57.9592 112.131 57.8285 112.612 57.5588 112.834Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.6805 113.785C53.6754 114.227 53.5924 113.012 52.6805 113.785V113.785Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.2204 111.336C63.2888 111.034 63.7087 110.951 63.5766 110.525C63.245 110.493 62.9768 111.198 62.7128 110.726C62.1739 111.162 63.2272 110.973 63.219 111.336H63.2204Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.193 110.433C63.1369 110.329 63.0455 110.25 62.9355 110.209C62.8256 110.167 62.7044 110.167 62.5942 110.207C62.5989 110.594 62.9173 110.479 63.193 110.433Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.3126 111.402C54.2004 111.108 53.924 111.077 53.5411 111.217C53.6533 111.511 53.93 111.542 54.3126 111.402Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.7914 138.885C63.7166 138.689 63.4427 138.813 63.2329 138.832C62.9857 139.774 63.1538 139.188 63.7914 138.885Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.9939 140.181C59.2475 139.781 59.4235 140.062 59.8576 139.981C59.9545 139.328 58.4607 140.039 59.006 139.45C58.5611 139.177 58.813 139.741 58.9939 140.181Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.6135 138.53C60.0767 138.527 60.6819 140.177 60.6135 138.53V138.53Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.2413 140.092C56.4052 139.014 55.561 139.42 56.2413 140.092V140.092Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.364 138.639C60.4421 138.802 60.0361 137.958 59.364 138.639V138.639Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.4931 138.012C60.5482 138.08 60.6183 138.135 60.6979 138.171C60.7775 138.208 60.8645 138.225 60.9521 138.222C61.0396 138.22 61.1253 138.197 61.2025 138.155C61.2797 138.114 61.3463 138.055 61.3971 137.984C61.1823 138.034 60.7948 137.671 60.4931 138.012Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.582 137.213C61.2229 137.637 61.8737 137.165 62.1002 137.092C62.0089 136.97 61.944 136.83 61.9094 136.681C61.8749 136.533 61.8716 136.379 61.8997 136.229C61.7415 136.475 61.3344 136.566 60.9024 136.642C61.0979 137.234 62.0532 136.334 61.582 137.213Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.2053 135.975C62.3189 136.189 62.5725 136.177 62.6712 136.413C62.9109 136.316 62.6117 135.884 62.8963 135.815C62.7513 135.379 62.6541 136.121 62.2053 135.975Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.8053 136.632C57.801 135.639 56.7043 136.921 57.8053 136.632V136.632Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.5629 135.164C63.0971 135.72 62.924 134.617 63.5602 134.75C63.5164 134.583 63.318 134.666 63.1748 134.658C63.2562 134.483 63.2747 134.286 63.2271 134.1C63.095 134.165 63.0954 134.313 62.9219 134.353C62.7527 134.388 62.7388 134.172 62.669 134.047C62.572 134.147 62.5036 134.272 62.471 134.407C62.4385 134.543 62.4429 134.685 62.4838 134.818C63.0498 134.237 63.2361 135.039 62.5639 135.164L62.5629 135.164Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.8725 132.92C68.778 132.856 69.4975 133.743 69.8725 132.92V132.92Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.6166 137.443L49.9621 137.362C49.8962 137.223 49.9917 137.184 50.0946 137.149C49.2814 136.839 49.6672 137.051 49.7612 136.498L49.243 136.618L49.3634 137.136L49.0175 137.216C49.0311 137.259 49.0602 137.295 49.0991 137.317C49.138 137.339 49.1838 137.346 49.2274 137.336C49.271 137.326 49.3092 137.3 49.3344 137.263C49.3595 137.226 49.3699 137.18 49.3634 137.136C49.5325 137.101 49.5464 137.317 49.6166 137.442V137.443Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.2738 132.695L69.792 132.574C69.7525 132.163 69.2481 132.498 69.1534 132.176C68.9144 132.311 69.2727 132.381 69.2738 132.695Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.7815 131.333C72.7565 131.093 71.8226 131.191 72.3156 130.895C72.2718 130.728 72.073 130.81 71.9298 130.803C71.9957 130.942 71.9003 130.981 71.7973 131.016C72.1033 131.157 72.3359 131.416 72.7815 131.333Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.0655 133.408C63.1869 132.223 62.2035 133.095 63.0655 133.408V133.408Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.2075 139.697C35.6047 139.555 34.9023 139.281 34.8741 139.046C34.3836 139.339 35.1797 139.461 35.2075 139.697Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.7064 131.834C68.0307 132.474 68.9742 131.421 66.7064 131.834V131.834Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.8504 135.699C51.2184 135.512 50.5783 135.478 50.9028 135.141C51.2668 135.11 51.3502 135.529 51.7142 135.497C52.0027 135.171 50.7692 135.29 50.7824 134.621C50.7403 134.635 50.7049 134.664 50.6831 134.703C50.6614 134.742 50.6549 134.787 50.665 134.83C50.675 134.874 50.7008 134.912 50.7374 134.937C50.7739 134.962 50.8186 134.973 50.8626 134.967C50.6984 135.249 50.4223 135.428 50.8504 135.699Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.2294 134.965C53.4036 135.381 53.6847 134.684 53.4546 134.366C52.9331 134.336 53.0628 134.713 52.6311 134.739C52.8982 135.207 52.9349 134.873 53.3623 134.752C53.4282 134.891 53.3327 134.93 53.2298 134.965L53.2294 134.965Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.0837 138.765C35.9313 138.529 35.8643 138.602 35.5776 138.154C35.1961 138.212 35.6417 138.785 35.6054 139.058C35.8754 138.98 36.2821 138.987 36.2565 138.725C36.4502 138.461 36.2565 138.654 36.0837 138.765Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.6131 135.076C49.3082 135.17 49.1995 134.949 48.8818 135.064C49.3363 135.355 49.6743 135.557 49.9586 134.996C49.9446 134.954 49.9154 134.919 49.8767 134.897C49.8379 134.875 49.7925 134.869 49.7493 134.879C49.706 134.889 49.6681 134.914 49.6429 134.951C49.6177 134.988 49.607 135.032 49.6131 135.076Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.0525 135.043C44.9424 135.084 44.8208 135.085 44.7106 135.043C44.6004 135.002 44.5091 134.922 44.4537 134.818C44.3433 134.332 45.0208 135.12 44.7191 134.39C44.4042 134.44 44.4039 134.686 44.068 134.724C44.7002 135.093 43.9437 136.301 44.9474 136.158C44.302 135.614 45.0236 134.683 45.3036 135.347C45.5265 135.14 45.4243 134.732 45.4485 134.402C45.3399 134.473 45.248 134.568 45.1793 134.678C45.1106 134.788 45.0667 134.912 45.0507 135.041L45.0525 135.043Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.3163 136.589C42.925 136.673 42.3184 135.999 42.9271 136.083C42.7875 135.729 42.0994 136.236 42.3163 136.589Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.3672 133.193C55.5556 133.115 55.4231 132.998 55.327 133.021C55.2522 132.827 55.2938 132.704 55.4196 132.635C55.3412 132.446 55.224 132.579 55.2468 132.675C55.1072 132.741 55.0687 132.646 55.0331 132.543C54.8447 132.621 54.9775 132.739 55.0733 132.715C55.109 132.885 54.8931 132.899 54.7681 132.969C54.8657 133.208 55.2985 132.908 55.3672 133.193Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.3192 129.356C70.8891 129.857 71.3471 128.551 70.8097 128.331C70.6138 128.445 71.0882 129.235 70.3192 129.356Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.6739 135.777C42.7422 135.474 43.1622 135.391 43.03 134.965C42.8135 135.175 42.5439 135.351 42.6739 135.777Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.2888 133.28C50.3671 133.468 50.4843 133.336 50.4615 133.24C50.8362 133.963 52.3115 132.935 51.6832 132.228C51.5717 132.38 51.2722 132.607 51.165 132.348C50.7482 132.522 51.4457 132.803 51.7637 132.573C51.7637 132.771 51.4474 132.77 51.4984 133C50.9114 133.287 50.5723 132.805 50.2873 133.282L50.2888 133.28Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.5112 129.412C68.9849 129.839 68.658 128.53 69.4277 128.653C68.8752 128.176 68.7003 129.173 68.5112 129.412Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.2651 129.933C66.8866 129.976 66.4075 129.333 66.41 128.989C66.1682 129.061 65.927 129.132 65.8515 128.937C65.5448 129.311 66.6462 129.241 66.2651 129.934V129.933Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.021 136.13C38.5218 136.146 38.2892 135.705 38.6319 135.624C38.4941 135.517 37.8362 135.473 38.021 136.13Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.0531 132.638C53.4249 132.001 52.3977 132.745 52.2819 132.453C51.8296 133.039 53.1072 132.453 53.0531 132.638Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.7407 132.064C54.5661 131.982 54.3689 131.964 54.1822 132.011C54.4593 132.586 54.833 132.07 55.046 131.811C54.9288 131.583 54.7386 131.867 54.7407 132.064Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.361 135.654C33.8547 136.038 36.4684 136.673 35.361 135.654V135.654Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.8323 128.841C68.0891 128.717 67.6104 128.572 67.9249 128.455C67.7992 128.031 67.3279 128.54 67.2339 128.615C67.3308 128.855 67.7636 128.556 67.8327 128.841H67.8323Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.9425 128.118C71.3158 127.806 70.3081 127.736 70.2233 127.375C69.9006 127.607 70.7519 127.927 70.9425 128.118Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.979 127.878C72.5001 127.429 71.5224 126.903 72.4698 126.853C72.9824 126.524 71.9601 126.766 71.7382 126.841C72.151 126.153 71.1587 126.981 71.6178 126.322C71.3258 125.832 71.0536 126.536 70.9671 126.656C71.0558 126.879 71.7596 126.811 71.0472 127.001C71.6634 127.194 72.1315 126.918 71.979 127.878Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.8495 136.602C32.5272 136.329 32.078 136.259 31.9174 135.726C31.6161 136.073 32.3473 136.757 32.8495 136.602Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.6951 133.902C43.5006 133.976 43.3788 133.935 43.3093 133.809C42.7266 134.305 44.0865 134.207 43.8279 133.688C43.6741 133.444 43.6449 133.719 43.6951 133.902Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.8302 128.86C63.5705 129.065 64.7 129.027 64.9874 129.137C64.5714 128.762 64.9144 128.582 65.4252 128.671L65.1844 127.634C64.4275 128.674 64.7356 128.223 63.8302 128.86Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.535 130.786C55.2561 130.918 55.1788 130.727 55.1076 130.521C54.9868 130.671 54.8177 130.774 54.6292 130.813C54.7824 130.963 55.0681 130.9 55.0951 131.252L55.7861 131.091C55.784 130.937 55.6793 130.944 55.5724 130.958C55.6134 130.787 55.6526 130.614 55.8378 130.531C55.7594 130.342 55.6422 130.475 55.665 130.571C55.5254 130.637 55.4869 130.542 55.4513 130.439C55.223 130.576 55.509 130.588 55.535 130.786Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.8339 129.273C63.3508 129.522 62.5084 128.772 62.4607 128.449C62.2209 128.546 62.5201 128.979 62.2352 129.048C62.3139 129.236 62.4307 129.104 62.4079 129.007C62.58 129.048 62.7524 129.087 62.8354 129.273L62.8339 129.273Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.4712 134.932C38.5922 134.782 38.7612 134.679 38.9496 134.639C38.7359 133.967 38.3946 134.972 38.3109 134.241C37.8201 134.475 38.5603 134.572 38.4716 134.932H38.4712Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.0533 130.683C51.4734 130.267 50.979 130.79 50.418 130.699C50.7212 131.375 51.1083 130.444 51.535 130.803C51.535 131.05 51.1358 131.047 50.8839 131.137C51.4303 132.277 51.4139 131.805 52.0533 130.683Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.9488 129.397C60.0913 129.526 60.2295 129.657 60.029 129.743C60.5098 130.22 60.3007 129.039 60.5597 128.891C60.3613 128.499 60.3317 129.417 59.9488 129.397Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.1555 133.944C41.268 133.796 41.1177 132.769 41.5533 133.306C42.0313 133.092 41.2256 133.098 41.2602 132.828C40.993 133.055 41.0849 133.507 40.9425 133.812C40.8252 133.807 40.7136 133.76 40.6281 133.679C40.5425 133.599 40.4888 133.49 40.4766 133.374C40.2985 133.46 40.4392 133.744 40.2112 133.801C40.4174 134.023 40.8246 133.92 41.1555 133.944Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.7027 129.919L58.221 129.799C57.7936 129.775 57.7864 129.072 57.3305 129.095C57.3419 128.807 57.8395 128.821 57.5154 128.323C56.9031 129.034 57.4687 128.986 57.7038 129.919L57.7027 129.919Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.3406 125.526C70.4884 125.843 71.0422 125.508 71.0195 126.096C71.5633 125.342 72.0641 126.175 72.3897 126.507C72.7836 126.086 71.7382 125.99 71.8957 125.165C71.6442 125.772 71.0227 125.472 70.3406 125.526V125.526Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.8446 126.156C67.4444 126.154 66.1265 126.075 66.1133 126.144C65.5566 126.546 66.4994 126.966 65.6229 127.168L65.7835 127.859C66.0642 127.09 66.5205 127.342 66.965 126.674C66.6722 126.184 66.55 126.98 66.3139 127.008C66.2862 126.917 66.2782 126.821 66.2906 126.727C66.303 126.632 66.3354 126.542 66.3857 126.461C66.436 126.381 66.5029 126.312 66.5821 126.259C66.6612 126.206 66.7507 126.171 66.8446 126.156V126.156Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.8919 127.137C69.0804 127.059 68.9475 126.941 68.8517 126.964C68.8325 126.755 69.1327 126.745 69.3297 126.671C68.9343 126.441 69.4184 126.119 68.9564 125.847C68.9208 125.678 69.137 125.664 69.2617 125.594C69.1359 125.17 68.665 125.679 68.5707 125.755C68.6852 125.86 68.7773 125.987 68.8415 126.129C68.9057 126.27 68.9406 126.423 68.9443 126.579C68.6394 126.673 68.5308 126.452 68.213 126.567C68.1899 127.157 68.8374 126.671 68.8919 127.137V127.137Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.7812 130.283C53.5821 131.114 54.3927 129.777 53.701 129.938C53.415 130.004 53.8147 130.143 53.7812 130.283Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.108 127.703C64.1436 127.872 63.9274 127.886 63.8024 127.955C63.8601 128.337 64.4332 127.891 64.7064 127.928C64.6669 127.517 64.1625 127.852 64.0678 127.53C63.8793 127.608 64.0122 127.725 64.108 127.703Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.7487 133.775C39.2391 133.483 38.4431 133.36 38.4153 133.124C38.8153 132.957 38.8644 133.353 39.3196 133.096C39.1533 132.747 39.4899 132.71 39.7578 132.63C39.0917 132.111 38.8623 132.948 38.0837 132.473C38.2368 132.089 38.8969 132.494 39.253 132.02C38.535 131.559 38.302 131.993 37.7905 131.995C37.8719 131.82 37.8903 131.623 37.8429 131.437C37.7264 131.948 37.2167 131.985 37.0995 132.156C36.9091 132.052 36.7486 131.901 36.6337 131.718C36.7491 132.279 36.0841 132.091 36.0107 132.955C35.8974 132.687 36.945 132.721 36.8744 132.754C37.07 132.661 37.3856 131.679 37.8717 132.341C37.4935 132.93 38.3209 133.586 37.4614 133.711C37.7795 134.524 38.2742 132.863 38.7512 133.776L38.7487 133.775Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.6144 125.91C72.8086 125.478 72.5578 125.245 72.2006 124.913C71.9373 124.977 72.4769 125.707 72.6144 125.91Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.6578 134.594C33.8213 134.954 34.3449 134.089 33.8829 133.995C33.6432 134.092 33.9424 134.525 33.6578 134.594Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.27 128.827C59.5905 128.806 59.125 128.154 58.8041 128.388C58.798 128.794 59.1912 128.558 59.27 128.827Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.9319 127.329C65.2243 127.819 65.3468 127.024 65.583 126.996C65.4398 126.599 65.1673 127.301 64.9319 127.329Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.3863 131.787C43.2192 131.831 43.3015 132.03 43.2937 132.173C42.8467 131.729 42.3651 132.102 42.0442 132.28C42.4605 132.155 43.9683 132.555 43.3863 131.787Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.6089 125.514C69.3069 125.246 69.62 126.065 69.7696 126.205C70.0738 126.173 70.1485 125.807 70.2878 126.085C70.5614 125.487 69.8031 125.933 69.6089 125.514Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.7933 129.552C53.8895 129.879 54.3247 129.215 54.8301 129.311C54.5961 128.739 54.1388 129.365 53.7933 129.552Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.8885 127.194C57.6579 126.879 57.2803 127.8 57.5674 127.764C58.1701 127.75 57.7629 127.343 57.6198 127.206C58.2053 127.057 58.3813 127.564 58.6844 127.869C58.242 127.987 58.6744 128.653 57.9407 128.588C57.5563 128.149 57.2046 127.683 56.8885 127.193V127.194ZM57.9008 128.416L58.2463 128.336C58.1804 128.197 58.2758 128.158 58.3788 128.122C58.2666 127.828 57.9902 127.798 57.6073 127.937C57.7572 128.058 57.8607 128.227 57.9004 128.416L57.9008 128.416Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.6387 126.851C65.3155 127.31 64.7915 125.956 64.4382 125.987C64.2601 125.459 65.0394 126.31 64.9162 125.694C65.4886 125.418 63.8402 126.005 64.4503 125.256C63.8804 124.721 64.3053 126.039 63.9196 126.107C64.2597 126.192 64.8856 126.388 64.253 126.758C64.451 127.037 64.5735 126.71 64.7712 126.638C64.8371 126.778 64.7417 126.816 64.6387 126.851V126.851Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.5931 133.93C32.5496 134.502 33.2471 133.253 33.8041 133.649C33.4661 133.441 33.5409 132.735 33.6973 132.399C34.1101 132.405 33.5502 132.717 33.9904 132.877C34.3982 132.787 34.4299 132.462 34.9877 132.464C34.1151 132.416 34.1454 131.935 33.1395 132.347C33.9897 133.088 32.9692 133.547 32.5165 133.584C32.6017 133.808 33.3051 133.739 32.5931 133.93Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.2358 132.337C40.9414 132.203 40.8833 130.748 40.0876 130.915C40.0922 131.224 40.2981 131.209 40.515 131.18C40.5542 131.637 40.4677 132.335 39.9843 132.032C39.6876 132.257 40.1934 132.091 40.2358 132.337Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.0738 131.213C45.2409 131.17 45.159 130.971 45.1664 130.828C45.3142 130.828 45.3801 130.961 45.5522 130.92C45.7969 130.767 45.5212 130.737 45.3385 130.787C45.2637 130.593 45.3053 130.471 45.4311 130.402C45.0054 129.914 45.0628 130.943 45.0749 131.213L45.0738 131.213Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.4115 127.469C60.2623 127.234 60.0554 127.093 59.9054 126.858C60.2431 126.197 60.689 127.182 61.1164 126.577C60.9643 126.465 60.7374 126.166 60.996 126.058C60.435 125.834 58.7407 126.929 60.413 127.468L60.4115 127.469Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.2811 133.355C34.5158 133.205 34.6572 132.999 34.8919 132.849C34.9243 132.604 34.0168 132.974 34.2811 133.355Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.9906 128.049C54.0112 128.231 54.8173 128.226 54.2837 128.528C54.932 129.155 54.3004 127.767 54.6399 127.716C53.9817 127.382 53.6426 127.457 53.0972 127.346C53.0427 126.574 53.7028 126.246 53.774 125.55C53.5293 125.841 53.1774 126.065 53.2835 126.575C52.9345 126.582 52.9915 125.937 52.4721 126.219C52.4953 126.539 52.7176 126.535 52.6859 126.351C53.4477 126.611 52.7254 126.879 52.9669 127.562C53.2874 127.328 53.847 127.83 53.4328 128C53.6739 128.374 53.7476 127.425 54.4301 127.587C54.3259 127.776 54.1745 127.936 53.9906 128.049Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.9747 128.368C55.2397 128.8 55.2696 127.883 55.5856 127.862C55.5834 127.707 55.4787 127.714 55.3719 127.729L55.0264 127.809C55.0976 128.051 55.1688 128.292 54.974 128.367L54.9747 128.368Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.879 128.339C56.3966 128.268 56.3599 127.498 56.7428 128.139C57.3725 127.414 56.0571 127.838 55.8912 127.608C55.6653 127.819 55.998 127.855 55.879 128.339Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.4105 132.73C36.2244 132.794 35.5508 131.554 36.2465 131.626C36.244 131.471 36.1396 131.478 36.0328 131.493C35.9971 131.324 36.213 131.31 36.338 131.24C36.2312 131.018 35.8721 131.197 35.6068 131.228C35.6983 132.044 35.803 132.103 35.4094 132.73L35.4105 132.73Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.0437 124.635C71.2325 124.556 71.0996 124.439 71.0034 124.462C71.2339 123.476 71.4903 122.607 70.67 123.811C70.6737 123.966 70.7086 124.119 70.7727 124.261C70.8369 124.402 70.9289 124.529 71.0433 124.635H71.0437Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.6948 124.302C71.2595 124.849 72.1468 123.996 72.0805 124.394C72.5201 124.129 71.5152 123.786 72.4787 123.755C72.28 123.442 71.9106 123.401 71.4942 123.438C71.6346 123.737 71.9042 123.959 71.6948 124.302Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.3 133.452C32.2975 133.298 32.1931 133.304 32.0863 133.319C31.8569 133.332 31.7401 132.856 31.9659 132.801C31.3725 132.208 31.6432 133.968 32.2993 133.452H32.3Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.3611 126.055C63.0021 126.48 63.6528 126.007 63.8794 125.935C63.3333 125.086 63.78 125.768 63.3611 126.055Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.1397 132.761C32.2747 133 32.3449 132.641 32.658 132.641C32.2505 132.554 31.8077 131.899 31.5011 132.363C31.5645 132.613 32.6483 132.373 32.1397 132.761Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.1501 131.597C37.4289 130.986 37.7857 130.413 38.2115 129.894C37.3834 130.273 36.9934 131 37.1501 131.597Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.0216 127.414C51.8079 127.676 51.7153 128.011 51.2782 128.133C51.3644 128.311 51.649 128.169 51.7057 128.398C52.0223 128.251 51.6868 127.697 52.2756 127.719C52.2193 127.335 52.0063 127.203 51.6366 127.321C51.6804 127.488 51.8795 127.406 52.0223 127.414L52.0216 127.414Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.3107 124.641C66.139 124.6 65.9662 124.561 65.8833 124.376C65.4594 124.502 65.9687 124.973 66.0439 125.067C66.3865 124.985 66.154 124.544 66.6548 124.561C66.6408 124.519 66.6116 124.484 66.5729 124.462C66.5341 124.44 66.4887 124.434 66.4455 124.444C66.4022 124.454 66.3643 124.48 66.3391 124.516C66.3139 124.553 66.3032 124.597 66.3093 124.641H66.3107Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.8732 122.704C73.7183 122.979 73.869 122.991 73.9936 123.223C74.1717 123.136 74.0292 122.852 74.259 122.795C74.1728 122.617 73.8882 122.757 73.8315 122.53C73.6431 122.608 73.7756 122.725 73.8718 122.703L73.8732 122.704Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.4716 122.928C74.5977 123.352 75.0682 122.842 75.1629 122.767C75.0878 122.571 74.8139 122.696 74.6044 122.715C74.5385 122.575 74.634 122.537 74.7369 122.501C74.2718 122.116 74.6774 122.931 74.4716 122.928V122.928Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.52 132.026C34.7085 131.948 34.5756 131.83 34.4798 131.854C35.0141 130.974 34.8292 131.775 35.3838 131.826C35.3414 131.182 34.9888 131.036 34.7573 130.696C34.1923 130.976 33.953 130.543 33.7208 130.937C33.7959 131.607 34.2497 131.669 34.52 132.026Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.1542 129.606C44.2924 129.958 44.712 129.285 44.552 128.967C43.8756 128.841 44.5841 129.579 44.1542 129.606Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.9435 127.05C56.1394 126.975 56.0148 126.701 55.9959 126.491C55.4972 126.741 55.4185 126.311 54.9192 126.559C54.9416 126.866 54.7083 127.324 55.2525 127.21C54.491 126.615 55.7644 126.562 55.9435 127.05Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.1852 123.277C73.61 122.861 72.4958 122.176 73.5797 122.225C73.5858 121.819 73.1925 122.055 73.1138 121.787C72.8887 122.657 72.1753 122.306 72.1852 123.277Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.6278 126.062C58.9939 126.515 58.6669 125.63 58.242 125.969C58.1761 125.83 58.2716 125.791 58.3745 125.756C58.3307 125.589 58.132 125.671 57.9888 125.663C58.0547 125.803 57.9592 125.841 57.8563 125.877C57.9685 126.171 58.2449 126.202 58.6278 126.062V126.062Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.7693 124.704C59.7195 124.389 59.473 124.389 59.4359 124.053C59.4769 123.881 59.5161 123.709 59.7013 123.626C59.9574 123.63 59.7868 123.926 59.6087 124.011C59.9891 124.471 60.0361 123.506 60.1786 123.332C60.3827 123.479 60.8286 123.238 60.8172 123.73C61.063 123.489 60.8347 122.953 60.9219 122.613C60.8189 122.669 60.7396 122.761 60.6983 122.871C60.6569 122.98 60.6564 123.101 60.6968 123.212C60.5494 123.212 60.4831 123.078 60.3114 123.119C60.4852 122.735 60.5194 122.264 61.1876 122.187C61.0963 122.065 61.0314 121.925 60.9969 121.776C60.9624 121.628 60.959 121.473 60.9871 121.323C61.8573 121.989 61.6756 120.454 62.715 120.922C62.7506 121.091 62.5347 121.105 62.4094 121.175C62.4119 121.329 62.5162 121.322 62.6231 121.307L62.9686 121.227C63.033 120.492 62.3178 121.007 62.3823 120.271C62.2327 120.424 62.2957 120.71 61.9442 120.737C61.7857 120.294 62.2013 120.208 62.5141 120.058C62.0867 119.353 61.7269 120.188 61.5168 120.472C61.1431 120.507 61.6592 119.952 61.1834 119.821C60.8115 119.934 60.9137 120.342 61.0384 120.765L61.7294 120.604C61.771 120.714 61.7712 120.836 61.7297 120.946C61.6883 121.056 61.6082 121.148 61.5043 121.203C61.3138 121.1 61.1533 120.949 61.0384 120.765C60.6937 120.915 60.3717 121.112 60.082 121.352C60.2078 121.775 60.6787 121.266 60.773 121.191C60.5846 121.467 60.8567 122.031 60.668 122.308C60.3257 121.38 59.635 122.988 60.0047 123.373C59.6222 123.513 59.3458 123.482 59.2333 123.188C59.442 123.476 59.3045 123.999 59.2489 124.823L59.7693 124.704Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.7627 131.524C33.0947 131.431 32.2266 130.868 33.1605 130.885C32.9643 131.394 33.5794 131.493 32.9753 131.656C33.1659 132.246 33.4384 131.533 33.5741 131.881C33.6312 131.457 33.5313 131.026 33.2931 130.67C32.2188 131.142 32.4453 129.892 32.1479 129.661C31.9759 130.534 32.0318 129.776 31.1506 130.075C30.8261 130.412 31.4658 130.446 31.0982 130.633C31.2834 131.094 31.6436 130.516 31.3636 130.206C31.791 130.251 32.7591 130.793 32.1226 131.122C32.2177 131.442 32.7217 131.109 32.7613 131.52L32.7627 131.524Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.14 130.356C39.9181 130.238 39.938 129.731 39.5013 129.958C39.5665 130.09 39.715 130.09 39.7542 130.263C39.6064 130.263 39.5405 130.13 39.3685 130.171C38.9802 130.366 39.8208 130.517 40.14 130.356Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.693 120.414C65.3835 120.761 66.4186 120.3 66.0264 121.065C65.5673 120.938 65.7101 121.163 65.1224 121.094C65.2723 121.215 65.3759 121.384 65.4156 121.572C66.0724 121.09 66.6091 120.535 67.3162 121.131C67.184 121.701 66.5895 121.059 66.1051 121.412C66.2476 121.541 66.3858 121.672 66.1853 121.757C66.399 122.235 66.3933 121.43 66.6636 121.464C66.9938 121.403 66.7936 122.212 66.2658 122.103C66.5984 122.31 67.0871 122.891 67.423 122.381C67.2698 122.231 66.9842 122.294 66.9571 121.942C67.0348 122.041 67.9826 120.947 68.1682 121.661C67.943 120.844 66.6561 120.363 65.693 120.414Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.4419 116.183C66.6971 115.87 65.9794 116.776 65.5816 116.797C65.0362 116.766 65.9224 116.446 65.5937 116.066C65.095 116.387 65.1256 116.123 64.7698 116.439C64.6305 116.106 64.6797 115.891 64.9949 115.841C64.789 115.618 64.3805 115.72 64.0507 115.696C64.2181 116.096 63.8224 116.145 64.0785 116.6C64.1994 116.45 64.3683 116.346 64.5568 116.307C64.6872 116.734 64.2672 116.816 64.2006 117.118C64.3431 117.386 64.8799 116.669 64.944 116.399C65.469 116.564 65.251 116.98 65.8761 117.276C65.9117 116.805 66.913 116.937 66.7523 116.343C66.8696 116.348 66.9812 116.395 67.0667 116.476C67.1523 116.556 67.206 116.665 67.2182 116.782C67.0451 117.212 66.7669 116.756 66.3944 117.155C66.4946 117.252 66.6191 117.321 66.7548 117.353C66.8905 117.386 67.0325 117.381 67.1659 117.34C67.1659 117.488 67.0326 117.554 67.0733 117.726C66.3534 116.958 66.9148 118.421 67.0088 119.016C67.1869 118.929 67.0462 118.645 67.2741 118.588C68.0029 119.051 66.3324 119.553 67.6877 119.586C67.6877 119.733 67.5545 119.799 67.5951 119.971C67.342 119.815 67.1133 119.623 66.9162 119.401C66.8286 120.095 67.2941 120.567 67.9683 120.796C67.5277 120.473 67.9513 120.375 68.1411 120.755C68.4442 120.763 67.9762 120.114 67.8077 120.104C67.8234 119.83 68.0446 120.121 68.326 119.984C68.1835 119.854 68.0456 119.723 68.2458 119.638C68.1108 119.405 68.0984 119.691 67.9003 119.718C67.9762 118.978 69.2431 117.831 68.1496 117.657C67.9926 117.313 68.1618 117.172 68.1618 116.926C68.3252 117.044 68.3976 117.923 69.0935 117.802C68.8716 117.683 68.8919 117.177 68.4549 117.404C68.4428 117.175 68.9179 117.058 68.9732 117.283C69.3293 116.697 68.2152 116.456 67.6955 116.488C68.1176 117.17 67.4615 118.133 67.9242 118.256C67.9598 118.425 67.744 118.439 67.6189 118.509C67.4102 118.528 67.4002 118.228 67.3258 118.031C67.1937 118.096 67.194 118.245 67.0202 118.284C67.3579 117.638 67.5044 116.909 67.4426 116.182L67.4419 116.183Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.8011 123.617C66.2006 123.551 66.8528 123.086 67.2393 123.151C66.9059 123.054 66.7345 122.696 66.5201 122.408C66.4314 122.966 66.7374 123.45 65.724 123.685C65.7679 123.852 65.9666 123.771 66.1098 123.778C66.0285 123.953 66.01 124.15 66.0574 124.337C66.383 124.109 66.6894 123.855 66.9739 123.577C66.8955 123.389 66.7784 123.522 66.8011 123.618V123.617Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.3739 122.918C71.449 123.114 71.7229 122.989 71.9324 122.97C71.8611 122.728 71.7899 122.488 71.9847 122.412C71.5943 121.903 71.9153 123.038 71.3739 122.918Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.2667 132.153C28.7787 132.579 29.8085 132.522 30.0785 132.51C30.0763 132.355 29.9716 132.362 29.8647 132.377C29.8291 132.208 30.045 132.194 30.1703 132.124C29.9809 131.563 29.5221 132.754 29.266 132.152L29.2667 132.153Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.6354 130.178C34.9393 130.402 35.3457 130.461 35.3945 131.095C35.5613 130.905 35.7941 130.786 36.0456 130.761C35.8654 130.424 35.6894 130.457 35.4871 130.709C35.4455 130.599 35.4454 130.477 35.4868 130.367C35.5282 130.257 35.6084 130.166 35.7122 130.111C35.5142 129.832 35.3916 130.158 35.194 130.231C34.8784 129.643 36.067 129.875 35.3792 129.459C35.8814 129.207 35.7282 130.006 36.3234 129.604C36.5503 130.041 36.0438 130.021 35.9256 130.243C36.2183 130.733 36.3405 129.937 36.5767 129.91C36.5282 129.276 35.8661 129.627 35.8176 128.993C34.9147 129.071 35.3606 129.99 34.6362 130.179L34.6354 130.178Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.0878 128.961C38.4823 128.791 38.0192 128.834 37.9583 129.588C37.6794 129.72 37.6022 129.529 37.5309 129.323C37.3528 129.409 37.4953 129.693 37.2656 129.75C37.4935 130.115 38.3744 129.67 38.0492 129.204C38.5428 129.653 38.9941 129.802 40.1507 129.626C40.0253 129.158 40.3576 129.212 39.99 128.935C40.6347 128.807 40.483 129.085 40.4962 129.546C40.7099 129.187 41.1191 128.949 40.9464 128.349C40.5026 128.444 40.7654 128.527 40.8538 128.735C40.5489 128.828 40.4402 128.607 40.1225 128.722C40.1175 128.311 40.8819 128.147 40.2675 127.778C39.8287 128.194 40.1934 129.111 39.1277 129.136C39.6755 128.807 39.2118 128.662 39.6976 128.457C39.3414 127.807 39.1174 128.581 39.0867 128.963L39.0878 128.961Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.5672 128.649C43.3955 128.608 43.2228 128.569 43.1398 128.384C42.9008 128.519 43.2591 128.589 43.2602 128.903C43.5505 128.887 43.5195 128.67 43.7385 128.609C43.6619 128.421 43.5451 128.554 43.5672 128.649Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.9285 123.01C64.373 123.551 63.9121 123.461 63.9965 124.086C65.0455 123.588 63.6443 122.776 65.178 122.901C64.7663 122.625 64.347 122.729 63.9285 123.008V123.01Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.3234 121.505C74.3982 121.701 74.6725 121.576 74.8819 121.557C74.9685 121.073 74.0851 120.806 74.8541 120.653C74.8217 120.349 74.4556 120.274 74.7338 120.135C73.9605 119.865 74.9336 121.463 74.3234 121.505Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.6566 120.203C73.5081 120.513 75.086 119.487 75.3845 119.802C75.7521 119.64 75.3068 118.854 75.1437 118.765C74.645 118.751 75.4564 119.551 74.9585 119.537C74.5717 119.604 74.7149 118.821 74.545 118.54C73.9626 118.829 74.623 118.97 74.613 119.617C74.1304 119.65 73.5765 119.174 73.1907 119.765C73.3232 120.116 73.5943 119.409 73.922 119.777C73.9231 119.975 73.6057 119.974 73.6566 120.203Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.9676 118.392C75.4721 118.554 75.346 118.124 74.8506 118.287C75.3104 119.32 75.8525 118.814 76.4858 118.271C76.3971 118.047 75.6933 118.116 76.4057 117.925C76.3053 117.828 76.1809 117.76 76.0452 117.728C75.9095 117.695 75.7676 117.699 75.6342 117.74C75.6776 117.907 75.8767 117.825 76.0199 117.833C75.9386 118.008 75.9201 118.205 75.9676 118.392Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.6906 132.438C25.5509 132.504 25.5125 132.408 25.4769 132.305C25.063 132.475 25.6222 132.977 25.9427 132.743C25.6827 132.565 25.8124 132.487 25.8224 132.225C26.279 131.915 25.515 132.1 25.6906 132.438Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.7451 131.859C30.0656 131.836 30.0617 131.613 29.8776 131.645C29.9844 131.318 30.5679 131.286 30.8343 131.059C30.4685 130.653 29.2486 131.732 29.7451 131.859Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.8356 125.8C56.0896 125.663 55.857 125.222 56.4465 125.294L56.3663 124.948C56.2267 125.014 56.1882 124.919 56.1526 124.816C56.0101 125.122 55.7516 125.354 55.8349 125.8H55.8356Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.5479 131.41C28.5836 131.579 28.3677 131.593 28.2427 131.663C28.0137 131.675 27.8965 131.2 28.1223 131.145C27.4456 130.685 27.9695 132.039 28.3228 132.009C28.7588 131.935 28.7948 131.613 29.1064 131.463C29.0744 131.158 28.7082 131.083 28.9861 130.944C28.8518 130.718 28.2534 131.627 28.5479 131.41V131.41Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.3702 130.604C34.3787 130.276 34.4634 129.956 34.6176 129.667C34.7718 129.378 34.9913 129.13 35.2585 128.94C35.1057 128.553 34.9586 128.157 34.4068 128.41C35.3856 128.906 33.8922 128.908 34.2498 130.084C33.8223 130.214 33.6471 129.944 33.4384 129.728C33.0405 130.229 34.2127 130.208 34.3702 130.604Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.1371 125.585C47.9679 125.621 47.9536 125.404 47.8842 125.279C47.3096 125.808 46.8042 125.766 46.1438 126.412C46.9666 126.649 46.4359 127.627 47.4617 127.381C47.0845 127.274 47.0343 126.641 46.7027 126.464C46.6461 126.134 47.2462 126.212 47.1006 125.826C47.7773 126.215 48.0954 125.715 48.6154 125.291C48.6062 124.941 47.7698 125.22 48.1371 125.585V125.585Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.2856 127.007C48.1577 126.659 47.5155 127.136 47.3413 126.862C47.1408 127.065 47.9771 127.421 48.2856 127.007Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.9769 124.442C56.7546 124.549 56.9338 124.908 56.9647 125.173C57.5785 125.063 57.3975 124.457 57.841 124.241C57.6675 123.73 57.2554 125.019 56.9769 124.442Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.7842 121.549C72.2365 121.861 72.5738 120.691 71.9291 120.604C71.6702 120.71 72.1806 121.224 71.7842 121.549Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.5424 125.322C55.4025 124.939 55.4331 124.662 55.7277 124.55C55.3985 124.336 54.7816 123.961 54.4379 124.485C54.7125 124.756 55.3829 124.392 55.3284 125.189C54.502 125.189 54.6976 125.57 55.5424 125.322Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.7469 121.79C71.4593 121.888 70.9685 121.238 71.5306 121.243C70.8282 120.358 71.6705 120.215 71.8604 119.528C72.2664 119.43 72.4381 119.706 72.9371 119.46C72.5938 118.951 73.4657 119.198 73.122 118.688C72.5129 118.703 72.6383 119.175 72.3786 119.408C71.9647 119.36 71.8059 118.904 71.4882 118.704C71.1277 119.132 71.7881 119.274 71.5562 119.781C71.4529 119.972 71.3019 120.132 71.1181 120.247C70.8392 120.379 70.7619 120.188 70.6907 119.982C70.4092 120.253 70.235 120.617 70.2002 121.006C70.7897 121.077 70.5564 120.638 70.8114 120.5C70.8139 120.654 70.9183 120.648 71.0251 120.633C70.9217 120.823 70.7706 120.984 70.5867 121.099C70.6579 121.651 70.9838 120.544 71.1455 121.151C71.3101 121.549 70.3359 121.238 70.7469 121.79Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.052 132.04C25.2568 132.39 25.5506 131.579 25.6218 131.361C25.9681 131.359 26.1426 131.632 26.5661 131.506L26.4457 130.987C26.1554 131.004 26.186 131.22 25.9673 131.281C26.3032 130.679 27.323 130.131 26.6028 129.312C26.8906 129.403 27.2104 129.443 27.2817 129.882C27.6639 129.48 26.882 128.961 26.3912 129.178C26.3239 129.767 26.4667 129.573 26.632 130.215C26.6551 130.987 25.5805 130.218 25.7558 131.147C25.5581 131.147 25.5588 130.831 25.3284 130.882C25.0416 130.285 25.6682 132.107 24.9305 131.52C24.3325 131.713 25.6489 131.846 25.0509 132.039L25.052 132.04Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.1656 131.731C27.2838 131.509 27.7903 131.529 27.5634 131.092C27.4267 131.235 27.0195 131.642 27.0049 131.04C26.5138 131.274 27.256 131.37 27.1656 131.731Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.5364 127.332C44.572 127.501 44.3562 127.515 44.2308 127.585C44.3928 127.952 45.1789 127.507 45.2673 127.344C45.1174 127.223 45.0139 127.054 44.9741 126.866C44.8381 126.978 44.7002 127.089 44.7088 127.293C44.4623 127.131 44.255 127.329 44.536 127.333L44.5364 127.332Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.1067 129.058C36.763 129.136 36.7776 128.638 36.3352 128.873L36.4556 129.391C36.6857 128.996 37.008 129.48 37.2794 129.018C37.2011 128.83 37.0839 128.962 37.1067 129.058V129.058Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.2936 128.267C41.6342 128.134 41.5241 127.721 41.8635 127.588C41.8432 127.268 41.1911 127.734 41.4258 128.055C41.2971 128.038 41.1735 127.994 41.0636 127.925C40.9536 127.856 40.8599 127.764 40.7889 127.656C40.2792 128.045 41.196 128.075 41.2951 128.266L41.2936 128.267Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.8775 124.001C58.8332 124.007 58.7879 123.997 58.7508 123.972C58.7137 123.947 58.6875 123.909 58.6773 123.865C58.6671 123.821 58.6738 123.775 58.696 123.736C58.7182 123.697 58.7542 123.668 58.797 123.655C58.673 123.398 58.5281 123.877 58.4112 123.562C58.1893 123.669 58.3681 124.028 58.3991 124.294C58.777 124.283 58.829 124.069 59.0502 123.961C58.9719 123.772 58.8547 123.905 58.8775 124.001V124.001Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.8883 122.837C63.7914 122.597 63.3586 122.896 63.2895 122.611C62.9294 122.776 63.7942 123.298 63.8883 122.837Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.248 130.104C29.7992 130.55 29.7942 130.354 29.2913 130.691C29.6019 130.803 30.289 130.762 30.248 130.104Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.1131 124.643C56.2746 124.277 56.3686 123.885 56.3906 123.485L55.6996 123.646C56.1594 123.984 56.0319 123.957 56.1131 124.643Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.9809 122.451C64.2587 122.638 64.3488 122.415 64.845 122.251C64.7812 121.987 64.2416 121.792 64.4995 122.331C64.2583 122.322 64.1568 122.089 63.9007 122.106C63.656 122.259 63.9317 122.288 64.1144 122.238C64.1793 122.377 64.0834 122.417 63.9809 122.451Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.3771 121.38C69.8779 121.396 69.6453 120.956 69.9879 120.874C69.7607 120.423 69.1933 121.565 69.1766 120.516C69.0212 120.519 68.8681 120.554 68.7265 120.618C68.585 120.683 68.4578 120.775 68.3527 120.889C68.4432 121.101 68.9226 120.996 68.8709 120.769C69.1295 120.829 69.2788 121.063 69.3771 121.38Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.8288 130.666C28.5643 130.526 27.7643 130.402 27.7084 130.148C28.4564 129.8 29.1627 129.944 30.6056 129.293C30.7217 129.119 30.5985 128.794 30.8307 128.694C30.7726 128.312 30.1995 128.758 29.9267 128.722C30.0236 128.961 30.4563 128.662 30.5254 128.947C29.9858 129.467 29.2286 128.969 28.9176 129.867C28.6765 129.464 29.2781 129.271 28.1465 129.682C28.8097 129.215 27.7436 129.41 28.1586 128.951C27.5919 128.607 27.9378 130.087 27.3625 130.228C27.5157 130.378 27.8013 130.315 27.8284 130.666H27.8288Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.7994 129.329C33.0626 129.527 33.407 129.261 33.7967 128.916C33.7465 128.601 33.5003 128.601 33.4633 128.265C33.3618 129.021 33.2795 128.871 32.7994 129.329Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.04 122.719C62.1693 121.525 61.1271 122.046 62.04 122.719V122.719Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.6854 124.396C51.6414 124.402 51.5967 124.392 51.5602 124.367C51.5236 124.341 51.4978 124.303 51.4878 124.26C51.4777 124.217 51.4842 124.172 51.5059 124.133C51.5277 124.094 51.5631 124.065 51.6052 124.051C51.3089 123.643 50.8861 125.16 51.7659 124.742C51.6911 124.547 51.7327 124.425 51.8585 124.356C51.7801 124.168 51.6629 124.301 51.6857 124.396H51.6854Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.2213 123.939L55.1009 123.421C54.792 123.426 54.8059 123.631 54.8355 123.848C54.6663 123.884 54.6524 123.668 54.5823 123.543C54.1516 123.806 54.8255 124.226 55.2213 123.941V123.939Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.1218 123.498C57.3858 123.433 56.8461 122.703 56.7083 122.501C56.3275 122.492 56.4985 123.259 56.5758 122.714C56.9448 122.675 56.7991 123.462 57.1222 123.498H57.1218Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.5563 120.665C57.011 120.917 56.9124 121.446 56.9733 122.075C56.4639 122.419 56.7115 121.547 56.2018 121.89C56.4992 122.203 56.8365 122.452 57.1335 122.766C57.0032 122.186 57.3836 121.452 57.5563 120.665Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.0298 121.478C64.2459 120.507 63.765 121.279 65.0298 121.478V121.478Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.8808 124.866C48.9445 125.13 49.4842 125.324 49.2263 124.786C49.7912 124.506 50.0305 124.939 50.2631 124.545C49.9864 123.933 49.4033 124.758 48.8808 124.866Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.466 128.678C32.9447 128.797 33.1883 127.493 33.8604 127.626C33.4558 126.921 33.2791 126.786 33.4992 126.071C32.8111 126.05 33.3212 127.008 32.7156 126.618C32.2882 127.018 33.6307 126.55 33.4348 127.361C32.8692 127.649 32.9037 128.311 32.466 128.679V128.678Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.6001 126.042C44.5 125.857 43.6277 125.572 43.9091 126.203C44.1866 125.835 44.1335 126.167 44.6001 126.042Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.6745 125.56C47.1019 124.889 47.9992 124.514 48.0412 123.604C47.5411 124.555 46.8145 124.456 46.6745 125.56Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.1101 125.565C34.4995 125.422 34.4001 125.011 34.1223 124.834C34.284 125.047 34.7933 124.705 34.8937 125.018C35.3297 124.873 34.5874 124.776 34.7331 124.327C35.2124 124.328 35.6855 124.219 36.1155 124.007C36.2472 124.286 36.0563 124.363 35.8501 124.434C35.957 124.656 36.316 124.477 36.5814 124.446C35.9758 123.954 36.7395 123.834 37.1922 123.94C37.1762 124.214 36.9553 123.923 36.6736 124.061C36.7299 124.445 36.9429 124.577 37.3126 124.458C37.4093 124.225 37.4137 123.964 37.3247 123.727C36.757 123.488 36.5439 123.582 35.9025 123.875C35.6674 123.345 36.4695 123.494 35.9146 123.144C35.7906 124.162 34.3028 123.61 34.6405 124.715C33.9616 124.656 33.8426 125.103 33.2984 125.209C33.5655 125.828 33.843 124.947 34.1101 125.565Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.5201 124.195C34.2291 123.95 34.005 123.598 33.4957 123.704C33.5518 123.808 33.6432 123.887 33.7532 123.929C33.8631 123.97 33.9842 123.97 34.0944 123.93C34.0132 124.104 33.9947 124.301 34.0421 124.488L34.3876 124.408C34.322 124.268 34.4175 124.229 34.5201 124.195Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.0355 125.614C37.5177 125.656 36.8791 126.449 37.4494 126.612C38.0513 126.465 36.8485 124.702 37.0882 125.056C37.0439 125.063 36.9988 125.053 36.9618 125.027C36.9249 125.002 36.8987 124.964 36.8886 124.92C36.8785 124.877 36.8852 124.831 36.9073 124.792C36.9295 124.753 36.9654 124.724 37.008 124.71C36.2465 124.409 36.7331 125.209 37.0358 125.615C36.4987 125.766 36.3395 125.309 36.1454 124.911C35.6207 125.367 34.6138 125.714 34.1122 125.566C33.9627 125.719 34.0257 126.004 33.6741 126.032C34.3153 127.116 34.8528 125.585 35.47 126.708C35.5118 126.646 35.5361 126.574 35.5406 126.5C35.5451 126.425 35.5295 126.351 35.4955 126.284C35.4614 126.218 35.4102 126.162 35.3471 126.122C35.284 126.082 35.2113 126.06 35.1366 126.057C34.8909 125.461 36.1678 125.813 35.8401 125.167C36.2878 125.08 36.2437 125.784 36.6917 125.697C36.8381 126.018 35.9633 126.133 36.1332 125.645C35.9153 125.854 35.6456 126.031 35.7771 126.456C36.4303 126.179 36.4966 126.082 36.7616 126.774C36.9838 126.667 36.8043 126.308 36.7737 126.043C36.7737 125.845 37.09 125.846 37.039 125.615L37.0355 125.614Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.1332 125.623C39.694 125.95 40.6429 126.315 40.374 126.659C41.1358 126.928 40.6286 125.773 40.1332 125.623Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.4879 123.946C50.4066 124.12 50.3881 124.318 50.4355 124.504C50.5562 124.354 50.7251 124.251 50.9135 124.211C50.9196 123.806 50.5267 124.042 50.4476 123.773C50.2592 123.851 50.392 123.969 50.4879 123.946Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.2702 122.967C54.9526 122.844 55.4499 123.65 56.2702 122.967V122.967Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.9193 130.3C24.0575 130.653 24.4771 129.979 24.3172 129.661C23.6408 129.535 24.3492 130.272 23.9193 130.3Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.0927 127.855C32.0863 127.311 32.5005 127.934 32.7841 127.694C32.634 127.573 32.5305 127.404 32.4909 127.216C31.6895 127.589 32.0678 127.819 32.0806 128.586C32.3089 128.5 32.7278 127.57 32.0927 127.855Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.3672 125.832C42.8031 125.687 42.0605 125.59 42.2065 125.141C42.1381 125.444 41.7186 125.527 41.8503 125.953C42.1542 125.92 42.2293 125.554 42.3686 125.832H42.3672Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.1687 122.545C53.8905 122.743 54.2168 122.865 54.2891 123.063L54.6349 122.983C54.4946 122.512 54.7625 122.328 55.073 122.517C55.3936 122.216 54.2631 122.255 53.9158 122.239C53.4207 122.54 54.4454 122.295 54.5145 122.465C54.5211 122.509 54.5107 122.554 54.4855 122.591C54.4603 122.628 54.4222 122.654 54.3786 122.664C54.335 122.674 54.2892 122.668 54.2503 122.646C54.2114 122.623 54.1823 122.588 54.1687 122.545Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.0784 128.605C27.869 128.388 27.7857 127.968 27.267 128.247C27.417 128.368 27.5206 128.537 27.5602 128.725C27.0298 128.961 27.1791 128.158 26.8289 128.713C27.1637 129.112 27.6724 128.866 28.0784 128.605Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.0717 127.777C30.1646 128.11 30.7267 127.243 30.7103 128.176C31.3988 128.211 31.1021 127.632 31.6667 127.589C31.6407 127.157 31.2638 127.287 31.2934 126.765C31.8373 126.547 31.8594 127.54 32.2376 126.91C31.739 126.708 31.8013 126.61 32.503 126.483C32.3231 125.981 31.6011 126.349 31.7037 125.394C30.9742 125.478 31.9402 125.797 31.5185 126.166C31.4786 125.838 31.0177 126.009 30.7994 125.422C30.0556 126.226 29.6535 125.824 29.6596 126.78C29.8537 126.705 29.9759 126.747 30.0453 126.872C30.2672 126.765 30.0881 126.406 30.0574 126.141C30.232 126.222 30.4293 126.241 30.6159 126.193C30.5411 125.999 30.5824 125.877 30.7085 125.808C30.9062 125.808 30.9055 126.124 31.136 126.073C31.1096 126.451 30.2743 126.324 30.6056 126.925C31.106 126.941 30.8738 126.5 31.2164 126.419C31.2556 126.837 31.0943 127.131 31.3233 127.668C30.7476 127.386 30.1463 127.159 29.5274 126.992C29.1923 127.17 29.9157 127.606 30.3388 127.35C30.2979 127.521 30.2587 127.694 30.0735 127.777L30.0717 127.777Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.8299 126.29C40.2903 125.933 38.8887 125.538 39.6659 125.185C39.3731 124.642 39.3247 125.174 38.7619 125.213C38.7509 125.705 39.1968 125.464 39.4005 125.611C39.5633 126.056 38.3964 125.674 38.8299 126.29Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.8752 124.472C45.8774 124.626 45.9821 124.619 46.089 124.604L46.4348 124.524C45.8827 124.229 46.786 123.954 46.2343 123.66C45.6142 123.927 46.4943 124.204 45.8752 124.472Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.2272 119.976C65.058 120.012 65.0438 119.796 64.974 119.671C64.5017 120 65.1756 120.419 65.6126 120.069C65.5734 119.65 65.7348 119.356 65.5057 118.819C65.4006 118.933 65.2735 119.026 65.1319 119.09C64.9904 119.154 64.8373 119.189 64.6819 119.193C64.8115 119.538 65.4566 119.056 65.4933 119.549C65.4527 119.72 65.4131 119.893 65.2279 119.976H65.2272Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.6352 120.578C63.6251 120.356 62.7855 119.901 63.2179 119.168C63.0648 118.923 63.0352 119.199 63.0854 119.382C62.6096 119.795 62.2306 118.903 62.1814 119.409C61.8673 119.569 62.6658 119.439 62.9928 119.767C63.1495 120.21 62.3538 120.059 62.6366 120.579L62.6352 120.578Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.7089 120.096C64.6651 119.929 64.4664 120.011 64.3232 120.004C64.2455 119.66 64.7435 119.675 64.5084 119.232C64.4144 119.695 63.5492 119.17 63.9096 119.007C63.9072 118.853 63.8028 118.86 63.6959 118.875L63.3501 118.955C63.8612 119.24 63.9773 120.162 64.7079 120.094L64.7089 120.096Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.2663 123.005C48.277 123.384 48.4911 123.435 48.5997 123.656C48.676 123.28 49.7816 123.101 49.9016 122.99C50.2165 123.437 50.0369 122.664 49.8214 122.644C49.3901 123.252 48.9566 123.069 48.2663 123.005Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.696 121.28C55.6387 121.803 55.1767 121.137 55.0449 121.613C55.1947 121.734 55.2983 121.903 55.338 122.091C55.4353 121.758 55.7929 121.586 56.0814 121.372C55.9389 121.243 55.8007 121.111 56.0012 121.026C55.3729 121.019 56.3325 119.66 54.8971 120.19C55.2647 120.467 54.9327 120.414 55.0577 120.882C54.7656 121.38 55.3893 120.577 55.2828 120.283C55.8691 120.39 55.1404 121.126 55.6964 121.28L55.696 121.28Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.1524 128.556C25.1862 129.055 26.0628 128.202 26.0966 128.701C26.6064 128.377 25.816 128.246 25.4979 128.476C25.6013 128.285 25.7522 128.124 25.936 128.009C26.7823 127.903 25.3052 128.012 24.9918 127.865C25.104 128.001 25.2151 128.139 25.4192 128.13C25.3786 128.301 25.3394 128.474 25.1538 128.557L25.1524 128.556Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.403 128.448C26.7624 128.895 26.9273 128.003 27.4003 128.034C27.0798 127.788 27.151 127.678 27.6657 127.607C27.9107 127.454 27.635 127.424 27.452 127.475C27.083 127.514 27.2286 126.727 26.9056 126.691C26.7847 126.841 26.6157 126.944 26.4272 126.984C27.3177 127.072 27.2326 128.231 26.4026 128.447L26.403 128.448Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.1305 128.047C28.1871 128.154 29.3625 127.143 28.7538 126.81C28.6665 126.999 28.9102 127.505 28.0101 127.528C28.0428 127.833 28.409 127.908 28.1305 128.047V128.047Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.8522 124.414C39.5266 124.508 40.1393 125.026 40.2255 125.238C40.0858 125.303 40.0474 125.208 40.0117 125.105C40.0085 125.867 40.6885 124.749 39.8511 124.414H39.8522Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.1663 124.968C42.7184 124.897 41.6114 124.571 42.2187 124.41C42.1403 124.221 42.0231 124.354 42.0459 124.45C41.9063 124.516 41.8678 124.42 41.8322 124.318C41.3421 124.61 42.1378 124.733 42.1656 124.969L42.1663 124.968Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.0658 124.527C43.2391 123.953 42.8679 124.877 44.0658 124.527V124.527Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.4827 123.551C47.6177 123.79 47.6879 123.432 48.001 123.431C47.6886 122.234 47.5807 122.996 47.4827 123.551Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.9783 122.922C51.1147 122.809 51.2522 122.698 51.2436 122.494C51.4381 122.419 51.5599 122.461 51.6294 122.586C52.0372 121.821 50.7852 122.253 50.9783 122.92V122.922Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.1724 128.653C22.2858 129.182 23.0124 129.635 23.1724 128.653V128.653Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.5669 121.906C54.6445 120.563 53.7576 121.463 54.5669 121.906V121.906Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.8926 114.535C76.8737 114.326 77.1736 114.316 77.3709 114.242C76.9667 114.099 76.7679 113.628 76.3063 113.578C76.1859 113.404 76.7654 114.417 76.6675 115.133C76.1581 115.477 76.4057 114.605 75.896 114.949C76.0085 115.085 76.1197 115.222 76.3234 115.214C76.3234 115.361 76.1902 115.427 76.2308 115.599C76.1135 115.594 76.0018 115.547 75.9163 115.467C75.8308 115.387 75.777 115.278 75.7649 115.161C75.4205 115.71 75.3549 116.043 75.7001 116.451C76.4406 115.516 76.4206 116.526 77.3353 116.436C77.2701 116.303 77.1216 116.304 77.0821 116.13C77.0465 115.961 77.2623 115.947 77.3873 115.877C77.1529 115.637 76.8342 115.587 76.6561 115.865C76.2739 115.233 77.143 115.38 76.7608 114.748C77.1305 114.629 77.3434 114.762 77.3994 115.146C77.8678 115.474 77.2751 114.321 76.8926 114.535Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.3658 123.447C46.5542 123.368 46.4213 123.251 46.3255 123.274C46.9428 122.808 46.2664 122.865 46.816 122.249C46.7091 122.028 46.3501 122.207 46.0847 122.237C46.2272 121.98 46.1528 121.848 45.8318 121.932C46.588 122.47 45.9946 122.947 46.3661 123.447L46.3658 123.447Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.0425 124.036C43.3349 123.726 43.2495 123.182 43.2801 122.707C42.7102 122.832 42.074 123.063 41.9501 122.469C41.7833 122.659 41.5505 122.778 41.299 122.803C41.3702 122.999 41.9707 122.943 42.1894 123.506C42.2888 123.174 42.5638 122.951 43.1458 122.92C43.1301 123.304 42.832 123.513 43.0411 124.037L43.0425 124.036Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.6508 128.358C23.5083 128.229 23.3701 128.098 23.5706 128.013C23.4175 127.863 23.1318 127.926 23.1047 127.575C22.8123 127.686 23.2579 128.567 23.6511 128.358H23.6508Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.0347 120.372C57.8406 119.533 57.3337 120.099 57.0103 119.881C56.7546 120.08 57.5197 120.626 58.0347 120.372Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.553 120.252C58.9522 120.105 58.2523 119.829 58.0871 119.813C58.0133 119.377 58.6605 119.627 58.7781 119.653C59.0185 119.571 58.1067 119.135 58.9633 118.882C58.2456 118.302 58.7709 119.736 57.8342 119.508C57.9079 120.022 58.2972 120.029 58.5533 120.252H58.553Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.3274 118.446C66.44 117.842 65.3964 118.54 64.6922 118.461C64.8315 119.068 65.9827 118.174 66.3274 118.446Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.369 116.213C74.4349 116.353 74.3394 116.391 74.2365 116.427C74.6682 116.967 74.6757 115.868 74.1564 116.081C73.8468 115.626 74.0317 116.39 74.3701 116.214L74.369 116.213Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.9008 125.846C33.0358 126.085 33.106 125.727 33.4191 125.726C32.9421 125.005 33.0721 125.132 32.9008 125.846Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.1828 122.246C48.906 121.727 48.3711 121.793 48.5563 121.117C47.9657 121.094 48.4519 121.742 47.9864 121.796C48.5182 121.654 48.5762 122.038 49.1828 122.246Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.771 121.23C52.5355 120.7 53.3377 120.849 52.7831 120.499C52.6819 120.967 52.231 121.404 51.7858 120.913C51.4378 121.047 52.1509 121.32 51.5607 121.511C52.0048 122 52.5188 120.906 52.9829 121.363C53.2276 121.21 52.9519 121.18 52.7692 121.231L52.771 121.23Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.4247 116.069C73.2157 116.087 73.2057 115.787 73.1316 115.591C72.7416 115.124 73.1533 116.374 73.1996 116.667C73.2556 116.259 73.7624 116.131 73.6901 115.643C74.0281 115.733 74.6162 115.421 74.6742 115.961C74.7715 115.627 75.1291 115.456 75.4176 115.242C74.94 114.817 74.6205 115.862 74.779 114.844C74.4741 114.938 74.3654 114.717 74.0477 114.831C74.7736 115.508 74.0655 115.219 73.4369 115.337C73.5309 115.642 73.3101 115.751 73.4247 116.069Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.3734 119.463C60.1783 119.41 59.4014 118.745 59.6422 119.45C59.9471 119.358 60.0557 119.579 60.3734 119.463Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.9887 122.209C47.1237 122.448 47.1939 122.09 47.507 122.089L47.3866 121.571C46.8772 121.914 47.1248 121.042 46.6151 121.385C46.635 121.831 47.2298 121.782 46.9887 122.209Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.131 117.995C64.8574 117.526 64.4834 118.093 64.3595 117.81C63.9844 118.03 64.9906 118.518 65.131 117.995Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.4579 123.513C37.8255 123.789 37.4935 123.736 37.6185 124.204C37.8679 124.355 38.2746 124.258 38.6953 124.136C38.6205 123.941 38.6618 123.819 38.7879 123.75C38.3302 123.952 38.0235 124.048 37.4579 123.513Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.2101 123.602C39.335 124.347 41.7061 122.485 40.3027 123.216C40.099 123.322 40.3259 123.503 40.2101 123.602Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.4116 119.656C56.3063 119.686 56.1941 119.677 56.0951 119.63C55.996 119.584 55.9168 119.504 55.8717 119.405C55.8266 119.305 55.8185 119.193 55.849 119.088C55.8795 118.983 55.9465 118.892 56.0379 118.833C56.2467 118.814 56.257 119.114 56.3311 119.311C56.5758 119.02 56.9273 118.795 56.8215 118.286C56.7184 118.342 56.639 118.434 56.5976 118.544C56.5563 118.654 56.5559 118.775 56.5964 118.885C55.4566 118.246 55.7316 119.321 55.1742 119.033C55.103 119.612 55.7797 119.577 56.1462 120.082C56.4889 120 56.2563 119.56 56.7571 119.576C56.7431 119.534 56.7139 119.499 56.6752 119.477C56.6365 119.455 56.591 119.449 56.5478 119.459C56.5045 119.469 56.4666 119.495 56.4414 119.531C56.4162 119.568 56.4056 119.612 56.4116 119.656Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.7963 116.911C69.7774 116.704 69.6866 116.613 69.5431 116.606C69.5075 116.437 69.7237 116.423 69.8487 116.353C69.8433 115.326 68.8606 115.726 69.1416 114.878C69.4747 114.964 70.2665 114.78 69.4875 114.798C69.4804 114.448 70.1254 114.506 69.8437 113.986C70.1286 114.559 70.7445 114.596 71.4266 114.529C71.2485 114.891 71.3596 114.96 71.854 114.794C71.8491 114.911 71.8021 115.023 71.7217 115.108C71.6412 115.194 71.5327 115.248 71.4159 115.26C71.5673 115.808 71.9858 115.929 72.613 115.71C72.322 115.165 72.2212 115.78 71.8419 115.525C71.9598 115.247 72.1436 115.533 72.2796 115.059C72.8111 114.947 73.3272 115.484 73.7022 114.911C73.2556 114.68 72.4627 115.003 72.0282 114.754C72.3074 113.657 71.5224 115.031 71.3094 114.01C70.7359 114.195 70.3295 114.599 70.1525 113.733C69.9982 113.804 69.8265 113.828 69.6586 113.802C69.4908 113.776 69.3342 113.702 69.2083 113.588C68.9945 113.702 69.0074 113.955 68.7701 114.054C68.9202 114.175 69.0238 114.344 69.0633 114.532C69.1842 114.382 69.3534 114.279 69.542 114.239C69.3283 114.501 69.2353 114.836 68.7983 114.958C69.0216 115.14 69.2816 116.241 68.3481 116.155C68.388 116.566 68.8916 116.231 68.9867 116.553C69.1449 116.352 68.8859 116.169 69.1716 115.782C70.1269 115.84 68.7798 116.953 69.7985 116.911L69.7963 116.911Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.4072 116.406C70.6091 116.477 70.6782 116.762 71.0059 116.631C71.0896 116.022 70.4161 116.629 70.4998 116.02C70.0702 116.11 70.4777 117.309 70.4072 116.406Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.5901 125.705C30.1668 125.186 29.6927 123.852 29.8676 124.547C29.7963 124.749 29.5114 124.818 29.6425 125.146C29.1438 125.395 29.0651 124.968 28.5657 125.214C28.924 125.577 29.5189 125.19 29.2849 125.958C29.4138 125.815 29.5452 125.677 29.6303 125.878C29.8188 125.799 29.6859 125.682 29.5901 125.705V125.705Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.1502 118.091C63.5819 117.826 62.6655 117.796 62.6441 117.48C62.7299 117.081 63.7041 116.475 62.6163 116.576C63.0081 116.706 62.7114 117.182 62.4838 116.79C62.1704 116.89 62.5137 117.4 62.2986 117.561C62.045 117.414 61.8712 117.141 61.3544 117.416C61.5036 117.651 61.7105 117.793 61.8605 118.027C62.3727 117.584 62.7705 117.738 63.1502 118.092V118.091Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.8943 122.614C42.8919 122.459 42.7875 122.467 42.6806 122.481C42.2098 122.273 42.8926 121.539 42.7052 121.019L41.8415 121.219C41.9163 121.415 42.1902 121.29 42.4 121.271C42.5389 121.818 41.9822 122.85 42.8936 122.614L42.8943 122.614Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.0153 120.728C51.3936 120.717 51.4453 120.503 51.6664 120.394C51.6525 120.352 51.6233 120.317 51.5846 120.295C51.5458 120.273 51.5004 120.267 51.4572 120.277C51.4139 120.287 51.376 120.313 51.3508 120.349C51.3256 120.386 51.3149 120.43 51.3209 120.474C51.1493 120.433 50.9765 120.395 50.8935 120.209C50.6552 120.344 51.0143 120.415 51.0153 120.728Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.4991 126.523C24.7638 126.954 24.794 126.038 25.11 126.017C24.8924 125.614 24.643 126.394 24.4991 126.523Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.704 122.989C39.8653 123.597 40.1898 122.491 40.2625 123.042C40.4904 122.924 40.2069 122.734 40.0092 122.736C40.0906 122.561 40.109 122.364 40.0616 122.178C40.2471 122.246 40.7925 122.432 40.5396 121.884C40.7302 121.988 40.8908 122.138 41.0058 122.322C41.3873 122.264 40.9417 121.691 40.978 121.418C40.5812 121.86 39.7944 122.06 39.6245 122.643C39.7132 122.867 40.417 122.799 39.7047 122.989H39.704Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.8666 121.71C42.9827 122.235 43.5729 121.999 44.0238 121.987C43.9235 121.89 43.799 121.822 43.6634 121.789C43.5277 121.757 43.3857 121.761 43.2523 121.802C43.1864 121.663 43.2819 121.624 43.3848 121.588C43.2498 121.351 43.1793 121.709 42.8666 121.71Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.2628 120.638C48.1969 120.499 48.2923 120.46 48.3953 120.425C48.0569 120.118 48.0726 120.691 48.3429 120.983C48.5618 120.913 48.7486 120.768 48.8701 120.573C48.9916 120.378 49.0398 120.146 49.0061 119.919C48.6624 119.996 48.677 119.498 48.2346 119.734C48.2236 120.226 48.6695 119.983 48.8733 120.131C48.9028 120.446 48.6681 120.595 48.2628 120.638Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.3023 123.666C31.1975 124.236 30.6358 124.152 30.2654 123.907C29.8975 124.361 31.2759 124.008 31.1972 124.783C31.5641 124.274 31.6064 123.988 32.3263 124.157C32.6771 123.808 31.4472 124.007 31.3023 123.666Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.1116 118.351C58.2281 118.178 58.1045 117.852 58.3368 117.753C58.2196 117.525 58.029 117.808 58.0312 118.005C57.8598 117.965 57.6867 117.926 57.6037 117.74C57.0338 118.767 56.938 118.622 58.1099 118.351H58.1116Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.1329 116.023C67.9933 116.089 67.9548 115.994 67.9192 115.89C67.5192 116.567 69.252 115.819 68.1846 115.463C67.9887 115.538 68.1133 115.812 68.1322 116.021L68.1329 116.023Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.0471 125.334C28.1681 125.184 28.337 125.081 28.5255 125.041C28.1657 124.749 27.4483 125.03 27.2877 124.418C26.8204 124.685 27.1538 124.722 27.2756 125.149C27.469 124.818 28.0029 124.777 28.0467 125.334L28.0471 125.334Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.1342 124.554C25.126 124.795 24.8931 124.896 24.9091 125.152C24.668 125.144 24.5668 124.911 24.3104 124.927",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.6072 125.819C24.4454 125.389 25.1712 125.982 25.5481 125.55C25.2183 125.452 24.9127 125.126 25.1748 124.727C25.6022 124.597 25.7775 124.866 25.9862 125.085C26.3068 125.064 25.8412 124.412 25.5203 124.646C25.6147 124.262 25.6475 123.839 26.0108 123.622",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.9493 125.326C24.8998 125.833 24.3531 125.21 23.9125 125.566L24.9493 125.326Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.5846 125.309C26.8244 125.213 26.5252 124.78 26.8098 124.711C26.7537 124.608 26.6623 124.528 26.5524 124.487C26.4424 124.445 26.3212 124.445 26.211 124.486C26.1451 124.346 26.2406 124.307 26.3435 124.272C25.6685 124.036 26.5188 124.951 26.5843 125.308L26.5846 125.309Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.5921 123.732C32.7419 123.764 32.8971 123.763 33.0465 123.729C33.1958 123.694 33.3356 123.627 33.4558 123.531C32.6426 123.152 33.3272 122.77 33.3076 122.109C32.8588 121.963 32.7616 122.705 32.6166 122.27C32.5475 122.593 33.1042 123.09 32.5921 123.732Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.2083 121.216C44.6165 120.919 43.476 121.154 43.2641 121.071C42.7836 120.788 43.7097 121.573 44.2083 121.216Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.3189 120.493C47.5073 120.415 47.3745 120.298 47.2786 120.32C47.3228 120 47.6509 120.12 47.6644 120.413C47.8425 120.326 47.7 120.042 47.9297 119.987C46.8555 119.904 47.1572 119.032 46.7447 118.805C46.5488 118.88 46.6735 119.154 46.6924 119.364C46.5646 119.58 46.432 119.792 46.2945 120.002C46.4202 120.426 46.8915 119.917 46.9855 119.842C47.0603 120.036 47.0186 120.158 46.8929 120.227C46.9791 120.406 47.2637 120.263 47.3203 120.492L47.3189 120.493Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.4402 116.203C63.2977 115.383 62.8218 116.582 62.6284 115.846C62.4671 115.401 63.6339 115.783 63.1983 115.167C62.3435 115.225 62.2608 115.766 62.4026 116.445C62.7406 115.802 63.1648 116.745 63.4395 116.204L63.4402 116.203Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.7664 116.026C66.5091 116.479 66.762 115.373 66.9881 115.014C66.8011 114.628 66.1461 115.098 66.6825 115.267C66.5653 115.262 66.4537 115.215 66.3681 115.135C66.2826 115.054 66.2288 114.946 66.2166 114.829C66.1525 114.437 66.7039 114.952 67.0804 114.629C67.2054 115.051 67.3073 115.459 66.9354 115.573C67.0968 116.18 67.4212 115.074 67.4939 115.625C67.8205 115.529 67.1566 115.094 67.2531 114.589C66.5696 114.558 65.864 114.097 65.485 114.817C65.625 115.553 65.7497 114.752 66.0033 114.697C66.4955 115.545 65.1484 115.249 65.3803 115.934C65.5662 115.705 65.978 115.617 66.1639 115.388C66.3327 115.352 66.347 115.568 66.4172 115.694C66.4186 115.94 66.0182 115.936 65.7664 116.026Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.4138 123.378C29.1339 123.178 28.6437 124.078 28.2968 123.273C28.3246 124.163 27.6108 123.711 27.6735 124.51C28.3089 124.526 28.6836 123.932 29.4138 123.378Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.2813 123.591L29.4017 124.109C29.8124 124.069 29.4776 123.565 29.7996 123.47C29.6646 123.231 29.5944 123.59 29.2813 123.591Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.8608 123.72C32.0278 123.676 31.9455 123.477 31.9534 123.334C32.1226 123.299 32.1365 123.515 32.2066 123.64L32.5521 123.56C32.4862 123.42 32.5817 123.382 32.6846 123.346C32.5845 123.033 32.0748 123.376 31.9131 123.161C31.9281 122.947 32.1155 122.652 32.2187 122.908",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.5712 113.604C67.4822 113.943 67.1196 114.111 66.6149 114.191C66.3132 113.463 66.9906 114.25 66.8802 113.763C66.8044 113.568 66.5636 113.639 66.3217 113.711C66.342 113.921 66.4642 114.194 66.2694 114.269C66.214 114.165 66.1226 114.085 66.0124 114.044C65.9022 114.002 65.7807 114.003 65.6706 114.044C65.635 113.06 64.0995 113.194 65.1363 112.529C64.8186 112.644 64.7089 112.422 64.4051 112.517C64.2715 112.926 63.8687 112.953 63.2357 112.971C63.385 112.882 63.2884 112.466 63.1153 112.452C62.8464 112.531 63.0822 112.924 62.6772 112.918C62.1893 112.079 62.1761 112.162 61.7052 111.87C61.6343 111.715 61.6103 111.544 61.636 111.376C61.6618 111.208 61.7363 111.051 61.8502 110.925C62.2398 111.327 62.5583 111.845 63.1681 111.894C63.1283 111.705 63.0248 111.536 62.8749 111.415C63.3023 111.286 63.4776 111.555 63.6863 111.772C63.5609 111.843 63.3465 111.856 63.3807 112.025C63.5538 111.984 63.6186 112.117 63.7664 112.117C64.2188 111.577 63.8306 112.563 64.7107 112.262C64.5607 111.95 64.1444 112.064 64.1647 111.479L64.5102 111.399C64.617 111.384 64.7207 111.377 64.7239 111.531C64.5988 111.602 64.3841 111.615 64.4183 111.784C64.5914 111.744 64.6566 111.877 64.804 111.877C64.7185 111.43 65.3832 111.45 65.5474 111.158C65.8045 111.762 64.7737 111.563 64.8439 112.049C65.0411 112.271 65.2699 112.463 65.5228 112.619C65.3661 112.091 66.6608 111.924 67.3433 111.831C66.9515 112.045 68.0496 112.885 67.2788 113.121C67.2895 112.577 66.5725 113.075 66.5475 113.109C66.9337 112.964 66.8553 113.564 67.1862 113.507C67.9032 113.074 68.4948 113.27 68.7534 112.414C68.8603 113.023 68.4328 113.298 68.1301 113.652C68.4054 113.605 68.7238 113.49 68.7285 113.877C68.461 113.957 68.1229 113.993 68.2907 114.343C68.5493 113.907 68.779 114.355 68.9294 114.741C68.4442 114.613 68.5472 115.55 68.2786 115.074C68.9714 114.474 67.4515 114.148 67.5719 113.6L67.5712 113.604ZM66.2412 113.367C66.721 112.313 65.1876 112.909 66.2412 113.367V113.367Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.1644 113.435C64.3156 113.089 64.1864 114.242 63.5972 114.527C64.0567 114.804 64.4955 113.815 64.8189 113.515C65.1395 113.559 65.0191 113.887 64.7263 113.9C64.8959 114.314 65.5484 113.848 65.1644 113.435Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.402 121.704C37.3973 121.395 37.1915 121.409 36.9746 121.439C37.0557 121.264 37.0742 121.067 37.0269 120.88C36.5721 121.922 35.8747 120.709 35.2991 121.282C35.3642 121.76 35.5326 122.218 35.7927 122.624C35.9708 122.537 35.8284 122.253 36.0581 122.197C35.921 121.942 35.4804 122.175 35.552 121.586C35.9598 121.274 36.1906 122.313 36.0702 121.465C36.5863 121.427 36.7527 121.951 37.4002 121.703L37.402 121.704Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.6021 117.325C58.7357 117.135 57.9995 116.607 58.7068 116.208C59.3234 116.086 58.4725 116.865 59 116.687C59.7181 116.575 58.9152 116.454 59.0121 115.956C58.818 116.03 58.6962 115.989 58.6267 115.863C58.4881 115.998 58.4764 116.404 58.3211 116.116C58.0985 116.322 58.2003 116.731 58.1761 117.06C58.3478 117.101 58.5206 117.141 58.6035 117.326L58.6021 117.325Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.2488 113.742C72.8481 113.962 74.0705 113.9 73.7272 113.449C73.4365 113.465 73.4675 113.681 73.2488 113.742Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.5491 120.741C41.8614 121.357 42.7045 120.014 42.6661 120.846C43.0493 120.434 42.067 120.015 43.1968 119.994C42.4434 119.301 42.3943 120.898 41.5491 120.741Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.2305 119.321C48.713 119.011 49.4139 118.939 49.2027 118.417C48.9516 118.509 48.527 119.555 49.2305 119.321Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.6355 122.365C30.2929 122.447 30.5251 122.888 30.0247 122.871C29.8943 122.444 30.3139 122.362 30.3808 122.06C30.0332 121.711 30.0813 122.847 29.2517 122.686C29.6081 123.049 30.046 123.322 30.529 123.482C30.01 123.285 30.6676 122.811 30.7018 123.442L31.0473 123.362C30.9814 123.222 31.0768 123.184 31.1801 123.148C30.8845 122.703 30.4453 123.092 30.6337 122.364L30.6355 122.365Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.2106 119.244C47.6024 119.679 47.9044 119.303 48.2474 119.003C48.028 118.735 47.4638 118.552 48.2998 118.445C48.2499 118.13 48.0035 118.129 47.9664 117.793C47.9238 117.807 47.8878 117.836 47.8657 117.875C47.8436 117.914 47.8369 117.96 47.847 118.003C47.8571 118.047 47.8833 118.085 47.9202 118.11C47.9572 118.136 48.0023 118.146 48.0466 118.139C47.825 118.543 47.3873 118.812 47.2106 119.244V119.244Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.6484 124.02C27.0584 124.296 26.3781 123.506 26.6206 123.116C26.3001 123.211 26.6334 123.715 26.2228 123.755C26.3093 123.933 26.5936 123.79 26.6502 124.02H26.6484Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.2487 119.436C43.2534 119.744 43.4592 119.73 43.6762 119.701C43.751 119.895 43.7096 120.017 43.5835 120.086C43.586 120.241 43.6904 120.234 43.7973 120.219L44.1428 120.139C44.0242 119.713 43.6947 119.679 43.9422 119.275C43.6648 119.006 43.8849 119.706 43.2512 119.436H43.2487Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.2982 118.012C53.6216 117.476 52.5213 117.269 53.363 116.722C53.2483 116.238 52.9872 117.243 52.9356 116.457C52.6994 116.484 52.5772 117.281 52.2845 116.79C51.7748 117.114 52.5655 117.245 52.8832 117.016C52.8722 117.184 52.3742 117.745 52.2321 117.349C51.6622 117.768 52.6951 117.514 52.5655 118C52.7617 117.925 52.6367 117.651 52.6178 117.442C52.984 117.406 53.0698 117.823 53.2967 118.012L53.2982 118.012Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.026 117.611C54.3735 117.539 54.7054 117 54.1744 117.08C54.1896 117.174 54.2247 117.263 54.2774 117.342C54.3301 117.421 54.399 117.488 54.4797 117.539C54.5604 117.589 54.6508 117.621 54.7451 117.634C54.8393 117.646 54.9351 117.638 55.026 117.611Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.6109 116.182C59.676 116.314 59.8246 116.313 59.8638 116.487L60.2093 116.407C59.9029 116.212 59.9496 115.89 60.4344 115.808C59.9606 114.898 59.6646 114.612 59.6472 113.988C58.9996 114.422 59.478 115.228 60.1412 115.33C59.997 115.634 60.1715 116.136 59.6109 116.182Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.8972 115.833C62.0493 116.153 62.289 114.52 62.6003 114.942C62.9152 115.389 62.7356 114.616 62.5201 114.596C61.926 114.807 62.1558 114.957 61.8972 115.833Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.7985 115.391C64.0884 115.704 64.2615 114.707 64.7146 114.632C64.2815 114.184 64.2993 115.246 63.5452 115.085C63.2603 115.293 63.692 115.247 63.931 115.178C63.9969 115.318 63.9014 115.356 63.7985 115.392V115.391Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.7884 119.391C46.0573 119.867 45.954 118.93 46.4395 119.058C45.7556 118.824 46.3326 118.789 46.6646 118.46C46.157 117.648 47.4436 117.51 46.6892 116.997C46.5921 117.097 46.5238 117.222 46.4913 117.358C46.4588 117.493 46.4633 117.635 46.5043 117.769C46.0769 117.662 45.5048 117.791 45.3072 117.318C44.8349 117.582 45.5398 117.85 45.5077 118.182C45.9668 117.598 45.5893 118.728 46.1987 118.021C46.3679 117.986 46.3818 118.201 46.4516 118.327C46.3152 118.576 45.9554 118.569 45.4147 118.568C45.5646 118.688 45.6682 118.857 45.7079 119.046C45.403 119.14 45.2943 118.919 44.9766 119.034L45.097 119.552C45.2641 119.508 45.1818 119.309 45.1896 119.166C45.2449 119.203 45.3071 119.229 45.3726 119.241C45.438 119.253 45.5052 119.251 45.57 119.236C45.6348 119.221 45.6958 119.193 45.7492 119.153C45.8027 119.113 45.8474 119.063 45.8806 119.006C45.9554 119.2 45.9137 119.322 45.788 119.391H45.7884Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.6068 118.624C44.2766 118.339 44.6315 118.56 44.6714 119.287C44.8851 119.174 44.8723 118.92 45.1095 118.821C44.8185 118.577 44.5945 118.225 44.0851 118.331",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.9882 123.113C29.3087 123.092 28.8432 122.44 28.5223 122.674C28.5159 123.08 28.9091 122.844 28.9882 123.113Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.868 120.19C36.9973 120.923 36.2981 120.215 36.2981 120.869C36.213 120.668 36.0816 120.807 35.9526 120.949C35.9526 120.635 35.5932 120.565 35.8322 120.43C36.0705 120.616 36.9777 119.97 36.8812 119.458C36.6625 119.519 36.6931 119.735 36.4029 119.751M37.5202 119.856L37.1747 119.936L37.5202 119.856Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.0071 123.209C26.7439 123.717 27.5952 122.937 28.0439 122.968C27.7565 122.522 27.3212 123.186 27.0071 123.209Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.6652 121.298C34.0154 121.131 34.0517 121.468 34.1311 121.736C34.3092 121.65 34.1685 121.365 34.3965 121.308C34.3404 121.205 34.249 121.126 34.1391 121.084C34.0292 121.043 33.908 121.042 33.7977 121.083",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.6449 113.122C69.8611 113.887 70.7466 112.176 69.6449 113.122V113.122Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.5712 121.702C29.5645 121.29 28.3356 121.667 28.7599 121.344C28.6249 121.105 28.5547 121.464 28.2416 121.465C28.3766 122.186 28.809 122.066 28.0161 122.063C27.8972 122.808 28.7762 121.95 28.8279 122.42C29.0498 122.313 28.8706 121.954 28.84 121.688C29.0982 121.748 29.2475 121.983 29.3461 122.299C29.6047 121.902 29.4092 121.951 29.9972 121.966C29.9396 121.933 29.8893 121.888 29.8497 121.835C29.81 121.781 29.7818 121.72 29.7667 121.655C29.7517 121.59 29.7501 121.523 29.7621 121.458C29.7741 121.392 29.7995 121.33 29.8366 121.275C30.1319 121.592 30.6035 121.626 30.7684 122.151",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.1037 112.734C72.5966 112.597 72.2326 111.927 72.8071 111.843C72.732 111.647 72.4581 111.772 72.2486 111.791C72.6504 112.384 71.8508 112.232 72.1037 112.734Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.7941 123.076C27.0106 122.494 27.6368 122.729 27.9235 122.449C27.7248 122.135 27.3554 122.095 26.939 122.131C27.5 123.192 25.3597 121.934 26.7941 123.076Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.1656 114.319C51.3263 113.849 52.1986 113.296 51.5357 112.776C51.177 112.802 51.4851 114.304 51.1378 113.415C50.9576 113.71 50.9633 114.354 51.2059 114.491C50.5854 114.538 50.4436 113.818 49.7957 113.908C49.8239 114.144 50.5263 114.416 50.1291 114.56C50.3272 114.838 50.4497 114.511 50.6474 114.439C50.8148 114.839 50.4191 114.888 50.6752 115.343C50.3443 114.978 50.3047 115.316 50.0764 115.118C49.7035 115.431 50.7111 115.5 50.7956 115.861C50.7339 116.097 49.8695 115.627 49.2002 116.049C49.3036 115.859 49.4545 115.699 49.6383 115.584C48.1644 115.359 49.0054 117.65 48.3119 117.713C48.4378 117.827 48.5944 117.901 48.7623 117.927C48.9301 117.953 49.1018 117.929 49.2561 117.858C48.7076 117.278 49.1824 116.955 49.4933 116.528C49.6962 116.642 49.8724 116.799 50.0102 116.987C50.1481 117.174 50.2445 117.389 50.293 117.617C50.5327 117.52 50.2335 117.087 50.5181 117.018C50.1904 116.833 49.8157 116.722 49.6276 116.315C49.4623 116.606 48.8365 116.61 48.6713 116.901C48.6403 116.537 49.0602 116.454 49.0274 116.089C49.6118 116.214 50.1643 116.458 50.6506 116.805C50.9598 116.407 51.4552 116.124 51.4463 115.528C51.1699 115.895 51.223 115.563 50.7553 115.688C51.1471 115.19 51.4997 113.891 52.4151 114.21C52.7827 114.048 52.3375 113.262 52.1744 113.173C52.5626 112.45 53.2963 112.814 53.7416 112.081C53.7562 111.582 52.9555 112.393 52.9701 111.896C52.6915 112.094 53.0181 112.216 53.0905 112.414",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.5208 112.191C69.8441 112.225 71.334 112.102 71.3322 112.547C71.4292 112.447 71.4975 112.322 71.53 112.186C71.5625 112.051 71.558 111.909 71.5171 111.775C70.7894 112.078 71.5765 111.4 71.0896 111.51C70.6159 111.209 71.7379 112.261 70.5197 112.189L70.5208 112.191Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.4069 114.903C60.7236 114.755 60.388 114.202 60.9768 114.224C60.902 114.028 60.6281 114.153 60.4183 114.172C60.5123 114.477 60.2915 114.586 60.4062 114.903H60.4069Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.1493 119.446C36.1468 119.291 36.0424 119.298 35.9356 119.313L35.5901 119.393C35.6556 119.525 35.8038 119.525 35.8433 119.699",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.3893 115.241C57.5802 115.014 57.6201 114.695 57.9592 114.562C57.9567 114.407 57.8524 114.414 57.7455 114.429L57.4 114.509C57.494 114.814 57.2732 114.923 57.3879 115.241H57.3893Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.6511 122.067C25.9107 121.629 26.0892 122.159 26.4222 122.252C26.9964 121.771 27.0772 121.753 27.8046 121.931",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.723 121.585C27.0178 121.605 26.7855 121.615 26.3809 122.079L27.723 121.585Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.9623 112.138C70.3659 111.918 69.5349 111.752 69.589 111.314C69.262 111.285 68.6223 111.759 68.5123 111.382C68.1611 111.392 68.441 112.228 68.8054 111.861C68.841 112.03 68.6252 112.044 68.4998 112.114C69.0309 112.357 69.4027 111.284 69.9627 112.138L69.9623 112.138Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.6537 111.977C71.2517 111.785 69.9356 111.652 70.5333 111.459C70.5308 111.305 70.4264 111.312 70.3196 111.327L69.9741 111.407C69.9513 111.997 70.5992 111.511 70.6537 111.977Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.6405 115.565C54.3172 115.929 54.0244 114.431 55.2479 114.645C55.1055 114.516 54.9672 114.384 55.1678 114.299C55.1518 113.844 54.4223 114.981 54.3963 114.114C54.096 114.568 54.1576 115.247 53.6405 115.565Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.7905 115.015C57.5717 114.445 56.0326 114.673 56.5095 113.804C56.0985 113.844 56.4333 114.348 56.1116 114.443C56.2591 114.76 56.8133 114.424 56.7905 115.013V115.015Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.1816 113.55C59.3269 113.986 59.4238 113.244 59.8726 113.389C59.723 113.076 59.6372 112.66 59.1937 112.819C59.244 113.104 59.6568 113.504 59.2739 113.165C59.0855 113.243 59.2183 113.36 59.3141 113.338C59.38 113.477 59.2846 113.516 59.1816 113.551V113.55Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.0105 114.022C53.5118 114.34 53.5727 114.209 53.1065 114.05C52.6759 114.15 54.2905 114.889 54.0105 114.022Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.5051 110.555C70.3063 110.242 69.937 110.202 69.521 110.237C69.8269 110.38 70.0592 110.638 70.5051 110.555Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.6036 113.42C57.4833 113.867 56.9978 112.439 57.4798 112.488C57.1033 112.381 56.6962 112.322 56.7207 111.572C55.9831 111.765 57.1838 112.241 56.3645 112.383C55.9371 111.987 56.4504 112.846 56.923 112.436C56.8842 113.064 57.1781 113.054 56.6036 113.42Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.7721 110.562C65.2998 110.826 66.0043 111.094 65.9726 111.425C66.2437 111.151 65.8793 110.481 66.6761 110.535C65.994 111.227 66.9945 110.606 67.3147 110.933C67.9936 110.491 66.441 110.502 66.9813 110.282C66.5372 109.687 66.1265 111.101 65.7703 110.563L65.7721 110.562Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.4825 115.306C49.088 115.113 49.3687 114.819 49.6519 114.853C49.7848 114.802 50.0437 114.16 49.7042 114.294C49.5397 114.068 49.4994 114.361 49.7042 114.294C49.4695 114.59 48.3903 114.469 48.4825 115.306Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.3282 113.038C53.9432 112.941 53.5194 113.145 52.7333 113.226C52.656 112.794 52.4533 112.982 52.5605 113.267C53.2949 113.195 53.8531 113.405 54.1836 113.982C54.2477 113.256 53.6761 113.492 54.3282 113.038Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.0586 112.617C60.705 112.265 60.0155 111.907 59.6853 111.793C59.4969 111.872 59.6297 111.989 59.7255 111.966C59.7209 112.222 59.4249 112.052 59.3398 111.874C59.1218 112.082 58.8522 112.259 58.9836 112.685C59.2668 112.278 60.3549 111.752 60.0586 112.617Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.3046 109.691C69.7771 108.974 69.2321 110.16 70.3046 109.691V109.691Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.7768 111.408C60.1184 111.571 60.8617 111.09 60.9341 111.685C61.8441 111.185 61.157 110.586 61.6899 110.235C61.3857 110.267 61.3105 110.634 61.1713 110.356C60.8578 110.456 61.2012 110.965 60.9864 111.127",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.3096 110.537C64.388 110.726 64.5052 110.593 64.4824 110.497C64.5328 110.572 64.6015 110.633 64.6819 110.674C64.7623 110.715 64.8518 110.735 64.9421 110.733C65.0324 110.73 65.1206 110.704 65.1982 110.658C65.2759 110.612 65.3407 110.547 65.3864 110.469C65.4027 109.968 64.9622 110.201 64.8802 109.858C64.6893 110.084 64.6494 110.404 64.3103 110.537L64.3096 110.537Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.3248 112.624C55.2814 112.061 54.922 112.005 54.7385 111.667C54.4347 111.699 54.3596 112.066 54.2203 111.787C54.189 112.014 54.0879 112.226 53.9309 112.393C53.7738 112.56 53.5688 112.674 53.3441 112.719C53.9243 112.786 54.6652 111.927 55.3248 112.623V112.624Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.5425 113.603C49.5578 114.269 49.7755 112.99 50.1124 112.924C50.3126 112.388 49.274 112.767 49.8193 112.446",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.0578 115.455C47.6202 115.461 47.1291 114.81 47.8414 114.909L47.0578 115.455Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6975 62.394C49.6975 62.394 58.1494 78.4842 49.6975 83.1736C41.2456 87.8629 35.0437 71.2335 46.2386 63.1346",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.6544 65.6436C45.4604 65.6436 43.6818 63.865 43.6818 61.6709C43.6818 59.4769 45.4604 57.6982 47.6544 57.6982C49.8483 57.6982 51.6269 59.4769 51.6269 61.6709C51.6269 63.865 49.8483 65.6436 47.6544 65.6436Z",
    fill: "#CAD4E3",
    stroke: "#CAD4E3",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.8735 36.4226C56.4346 36.5272 56.0019 36.6562 55.5773 36.8091C55.1202 36.9119 54.6513 36.9531 54.1832 36.9316C53.8954 36.9167 53.972 36.9291 53.7305 36.9042C53.4143 36.8539 53.1048 36.7679 52.808 36.6477C52.4879 36.5164 52.1867 36.3432 51.9122 36.1327C51.6309 35.923 51.38 35.6754 51.1667 35.3968C51.068 35.2734 50.9803 35.1417 50.9045 35.0032C50.8118 34.8506 50.7332 34.6899 50.6698 34.523C50.502 34.1546 50.3823 33.7661 50.3136 33.3671C50.2923 33.1534 50.2819 32.9614 50.2745 32.7826C50.2762 32.6092 50.278 32.4403 50.2801 32.2711C50.2392 31.8583 50.2046 31.3162 50.159 30.971C50.1551 30.8998 50.1516 30.8385 50.1487 30.7865L50.1459 30.7363L50.1017 30.7081L49.6622 30.4292C49.4339 30.296 49.3623 30.2785 49.1436 30.1525L49.1835 30.2276V30.202C49.202 29.9655 49.229 29.8515 49.2547 29.6577C49.3444 28.8333 49.4871 28.0156 49.6821 27.2095C49.94 26.0235 50.3118 24.8651 50.7923 23.7505C50.8735 23.5595 50.9644 23.3729 51.0648 23.1913C51.5078 22.1742 52.1397 21.2504 52.927 20.4688C53.0799 20.2974 53.2467 20.1388 53.4256 19.9947C53.6447 19.7874 53.8744 19.5916 54.1138 19.4081C54.2769 19.2977 54.4254 19.2168 54.4988 19.1609C54.6662 19.0636 54.9262 18.9579 55.1399 18.8642C55.7775 18.5907 56.4504 18.4084 57.1389 18.3228C56.8219 18.3439 56.5066 18.3844 56.1946 18.4439C56.0575 18.4795 55.9389 18.5076 55.832 18.5304L55.5492 18.6113C55.3816 18.6459 55.218 18.6979 55.0612 18.7666C54.9139 18.8245 54.7501 18.8245 54.6028 18.7666C54.4139 18.8769 54.2133 18.966 54.0048 19.0323C53.878 19.1515 53.713 19.222 53.5392 19.2311C53.3587 19.3244 53.4392 19.3856 53.2333 19.5011C52.8992 19.6272 52.5095 20.0888 52.2413 20.0396C52.1712 20.1932 52.0666 20.3285 51.9357 20.435C51.7856 20.5808 51.6112 20.6993 51.4203 20.7852C51.2732 20.9565 51.1517 21.1413 51.0167 21.3227C50.8451 21.6151 50.6495 21.4089 50.4679 21.5941C50.1377 22.2413 49.8267 22.8073 49.5639 23.3733C49.2846 23.9258 49.0852 24.5153 48.9719 25.124C48.6403 25.7295 48.6317 26.1894 48.3521 26.7525C48.2015 27.258 48.2517 28.0067 48.0365 28.3658C48.1282 28.9625 48.0978 29.5717 47.9471 30.1564L47.8538 30.6907L48.5071 31.2104L48.8508 31.4839C49.0698 31.5431 49.2762 31.6417 49.4599 31.7749L48.9017 30.8488C48.9035 31.0779 48.8939 31.3208 48.9188 31.5787C48.9544 31.9277 49.0278 32.3238 49.0891 32.7157L49.1938 33.3725C49.2209 33.594 49.2821 33.8042 49.3035 34.0023C49.39 34.2576 49.5044 34.591 49.6458 34.674C49.8288 35.3262 50.2061 35.9072 50.7275 36.3396C51.2442 36.7747 51.8429 37.1018 52.4881 37.3014C52.595 37.2255 52.8906 37.3306 53.0413 37.2932C53.4057 37.3038 53.4356 37.4356 53.7241 37.4292C53.7743 37.3359 53.9161 37.2949 54.0856 37.2607C54.2559 37.2137 54.4561 37.1895 54.6249 37.1421C54.8561 37.1206 55.085 37.0786 55.3088 37.0168C55.5 36.968 55.6764 36.9334 55.8744 36.8693C55.9739 36.8332 56.0651 36.7772 56.1422 36.7047C56.2918 36.6691 56.6256 36.517 56.8717 36.4198L56.8735 36.4226Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.7759 28.0502C52.7299 27.7075 52.9287 27.3979 53.22 27.3588C53.5113 27.3197 53.7847 27.5659 53.8307 27.9087C53.8767 28.2514 53.6779 28.561 53.3866 28.6001C53.0953 28.6392 52.8219 28.393 52.7759 28.0502Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.9192 49.5289C24.7706 23.4701 49.7231 9.08647 62.694 13.2023C75.8133 17.3652 73.5384 25.7982 70.3658 31.1636C69.9667 31.8335 69.4342 32.4143 68.8014 32.8699C68.1686 33.3255 67.449 33.6463 66.6871 33.8123C65.9252 33.9784 65.1373 33.9862 64.3723 33.8352C63.6073 33.6842 62.8815 33.3777 62.2398 32.9347C62.2398 32.9347 65.3953 32.6372 63.6193 30.4488C61.6154 27.9789 59.9556 31.6791 59.9556 31.6791L58.7207 31.1494L59.3697 29.5262C56.0926 27.8953 53.3103 25.4191 51.3099 22.3534C51.3099 22.3534 48.9171 24.9854 48.3336 28.3087C47.7502 31.632 48.1912 30.1748 48.1912 30.1748L49.5254 31.3068L50.3767 35.7907C50.3767 35.7907 50.3607 36.2156 50.3001 36.9337C49.9388 40.7257 50.641 44.5435 52.3279 47.9587C53.9165 51.0823 54.376 55.5411 50.6036 61.3304C47.0656 66.7607 41.0724 58.7049 37.9195 53.3569L37.777 53.3637C37.2025 52.3044 36.6935 51.2643 36.233 50.2395C36.0905 49.9414 35.9836 49.6988 35.916 49.5292L35.9192 49.5289Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.679 67.4224C62.2768 67.5 62.5664 69.0997 62.6679 70.2851C62.6679 71.1461 62.7673 72.2229 62.8482 73.2605C62.9016 73.8731 63.0263 73.6879 63.0882 74.1998C63.2236 75.767 63.3956 76.6397 63.5602 78.435C63.8471 79.8784 64.0412 81.3387 64.1411 82.8069C64.279 83.8363 64.4617 84.3354 64.6006 85.3651C64.6746 86.1403 64.7001 86.9192 64.6768 87.6975L64.7901 88.1314L65.7101 87.2972C64.9365 87.1853 64.0531 87.0186 63.4334 86.988C62.7659 86.8565 62.5564 86.7077 62.0168 86.5709C61.4569 86.4466 61.2948 86.5288 60.7346 86.4049C60.2487 86.2806 60.0318 86.1459 59.6389 86.0184C58.0421 85.6084 56.1747 85.176 54.5864 84.6681C52.4269 84.1933 49.711 83.4064 47.1525 82.8076C46.7262 82.7047 46.3061 82.5777 45.8941 82.4272C43.5819 82.054 41.3063 81.481 39.0931 80.7146C38.609 80.6481 38.1321 80.537 37.6684 80.383C36.805 80.2224 36.473 80.3367 35.7343 80.2405C35.4211 80.1565 35.0989 80.111 34.7747 80.1052C34.3986 79.9338 33.8287 79.77 33.3667 79.6022C32.0257 79.4376 30.3516 78.8677 29.0747 78.7363C29.054 79.0074 30.3926 79.2286 30.9439 79.4786C32.1012 79.728 32.5849 79.9548 33.3122 80.1169C33.6029 80.1905 33.8675 80.3433 34.0766 80.5583C34.5059 80.6369 34.9283 80.7498 35.3396 80.8959C35.6714 80.9319 35.9921 81.0363 36.2814 81.2026C36.6618 81.3095 36.6347 81.2026 37.0785 81.3451C37.7058 81.578 38.879 81.7907 39.1159 82.0383C39.4397 82.065 39.7599 82.1247 40.0715 82.2164C40.4467 82.3152 40.8131 82.4446 41.1672 82.6032L42.4345 82.8981C43.0806 83.0306 42.9029 83.1934 43.3627 83.333C46.0804 83.8648 48.2236 84.511 50.657 84.9854C51.9343 85.374 52.8087 85.5197 53.9695 85.8873C54.9718 86.1495 56.4033 86.3953 57.1346 86.6674C58.583 86.9072 60.0117 87.2541 61.4088 87.705C62.2733 87.8446 63.1858 88.1481 64.2583 88.4106L65.3714 88.6721L66.3559 88.9033L66.1931 87.9269C65.9929 86.7272 65.7632 85.4228 65.6588 84.3867C65.6104 83.9562 65.527 83.5305 65.4095 83.1136C65.2353 80.8742 64.7402 78.4852 64.41 76.1724C64.2928 75.8714 64.1991 75.5617 64.1297 75.2463C64.0637 74.8126 64.0215 74.3756 64.0033 73.9372C63.771 73.8272 63.6086 72.9313 63.4263 72.2546C63.272 71.3935 63.1738 70.5234 63.1324 69.6497C63.1209 69.429 63.041 69.2173 62.9037 69.0441C62.8661 68.5003 62.7927 67.9594 62.684 67.4252L62.679 67.4224Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.8092 86.4076C25.6959 86.5728 26.4147 87.3216 27.464 88.2477C28.5087 89.1813 29.8932 90.2812 31.0572 91.2173C32.6818 92.62 34.8506 94.2646 36.982 95.7823C38.245 96.6771 37.9871 96.3124 39.0639 97.0372C42.3525 99.2346 44.2941 100.358 48.2638 102.562C50.3051 103.577 51.8613 104.304 53.3929 104.996C54.9245 105.688 56.4258 106.359 58.409 107.153C59.6425 107.608 60.586 107.901 61.5349 108.173C62.4838 108.446 63.4369 108.704 64.7124 109.031C66.9507 109.642 68.7633 110.064 70.4645 110.382C72.6778 110.569 75.6188 110.535 77.4525 110.141L78.5662 109.974L79.441 109.824C79.7149 109.785 79.9728 109.714 80.2542 109.654C80.5668 109.59 80.875 109.505 81.1771 109.402C82.5808 108.913 82.8658 108.654 84.1601 107.949C85.0425 107.478 85.883 106.933 86.6727 106.32C87.503 105.584 88.2558 104.766 88.9191 103.877C89.5887 102.943 90.1702 101.95 90.6559 100.909C91.5759 98.8593 92.2318 96.7013 92.6078 94.4865C93.0348 91.3951 93.1502 88.2686 92.9522 85.1541C92.9059 84.3242 92.8347 83.4882 92.7641 82.6482C92.6669 81.8126 92.596 80.9648 92.4742 80.1317L92.1234 77.6305L91.9453 76.3877L91.7316 75.1585C91.557 74.0649 91.3212 72.6216 91.2183 71.8853C90.8692 70.483 90.5654 69.0066 90.1661 67.5266C89.9727 66.7853 89.8032 66.0334 89.598 65.2889L88.98 63.0613C88.1231 60.1141 87.1859 57.2695 86.2224 54.8776C85.9222 54.2952 85.6611 53.7997 85.4164 53.2719C85.2889 53.0101 85.1749 52.7376 85.0278 52.4526L84.5462 51.5422C84.1234 50.7937 83.6433 50.0792 83.1101 49.405C82.9039 49.12 82.6827 48.8589 82.439 48.5757C82.1954 48.2926 81.9464 47.9805 81.6576 47.6097C81.3228 47.2001 81.0058 46.8261 80.7315 46.5084C80.51 46.2521 80.2673 46.015 80.0059 45.7995C79.8446 45.5976 79.6597 45.376 79.461 45.142L78.7842 44.4567L78.4281 44.1026C78.3037 43.9893 78.1734 43.8825 78.0473 43.7724C77.7919 43.5562 77.5461 43.3346 77.3032 43.1359C75.74 42.0547 74.0046 41.2466 72.1709 40.7461C70.2543 40.2646 68.2436 40.2546 66.6597 40.8035C66.7698 40.9018 67.6274 40.7002 68.6842 40.6792C69.6911 40.6411 70.6979 40.754 71.6712 41.0144C72.807 41.2526 73.9018 41.6564 74.9203 42.2126C75.3267 42.4374 75.6886 42.6721 76.0569 42.8933L77.1404 43.6552C77.4873 43.9285 77.8102 44.2308 78.1057 44.5589C78.2948 44.7997 78.412 44.9863 78.5784 45.2097C79.0161 45.589 79.4489 46.0852 79.8549 46.5091C80.172 46.8567 80.4637 47.2265 80.7279 47.6158C81.0665 48.0088 81.3765 48.4254 81.6558 48.8625C81.8267 49.1073 81.9772 49.3658 82.1057 49.6354C82.6082 50.4743 82.6314 50.3101 83.2016 51.3124C83.9625 52.7775 85.3138 55.4151 85.3826 56.171C85.7509 56.887 86.0668 57.6287 86.3279 58.3904C86.5323 58.9603 86.6976 59.4523 86.8401 59.8982C86.9765 60.3463 87.0698 60.7556 87.1681 61.1449L87.6696 62.684C87.8296 63.1998 87.9674 63.7231 88.1177 64.2421C88.5758 65.8197 88.3165 65.5443 88.5654 66.7134L89.1905 69.1597L89.6931 71.5363L89.9353 72.6939L90.1394 73.8423L90.5312 76.1027C90.7784 77.5988 90.9665 79.0813 91.1934 80.5656C91.297 81.3079 91.3761 82.0505 91.4737 82.7996L91.6959 85.0711C91.7497 86.7249 91.7925 88.0988 91.7512 89.4313C91.7423 89.7647 91.733 90.0956 91.7241 90.4287C91.7002 90.7599 91.676 91.0926 91.6528 91.4307C91.6172 92.1074 91.5075 92.7978 91.4106 93.539C91.2236 94.9356 90.9448 96.3184 90.5761 97.6784C90.242 98.8723 89.7735 100.024 89.1795 101.112C89.0338 101.437 88.849 101.762 88.6687 102.11C88.4789 102.451 88.2467 102.784 88.0226 103.139C87.769 103.47 87.5172 103.822 87.2272 104.153C86.9339 104.493 86.6216 104.816 86.2919 105.121C85.6136 105.759 84.8668 106.321 84.065 106.795C83.257 107.267 82.4064 107.661 81.5244 107.973C80.4876 108.383 79.4095 108.678 78.3091 108.856C77.059 109.042 75.7973 109.138 74.5335 109.143C72.5683 109.149 70.6059 108.993 68.6664 108.676C66.7661 108.369 64.8897 107.929 63.0515 107.358C61.9328 107.042 60.5226 106.556 59.9659 106.432C54.5066 104.384 49.2244 101.893 44.1726 98.9814C43.8546 98.9048 42.6172 98.1585 42.0448 97.8771C40.5819 97.0354 40.4263 96.7868 39.3022 96.073C38.8872 96.058 36.9613 94.8395 35.491 93.8966C33.1505 92.2175 31.9024 91.3509 30.2715 89.9197C29.8662 89.5751 29.4207 89.2808 28.9447 89.0434C28.3609 88.4959 26.8628 87.3191 25.8102 86.4108L25.8092 86.4076Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.1068 86.5773C25.2624 86.2026 24.4361 85.8649 23.9132 85.4518C23.5745 85.1027 23.1089 84.7308 22.684 84.3415C22.4293 84.1178 22.4176 84.2895 22.1935 84.1128C21.5524 83.5215 21.1399 83.2512 20.4422 82.537C19.7762 82.0689 19.1861 81.5013 18.6926 80.854C18.2969 80.4447 18.0212 80.314 17.645 79.8858C17.3863 79.5434 17.1797 79.1645 17.0317 78.7616C16.6566 78.4685 16.2748 78.0072 15.9674 77.7525C15.8401 77.5417 15.7514 77.3099 15.7053 77.0679C15.6676 76.9788 15.6183 76.8949 15.5589 76.8186C15.5017 76.7503 15.4668 76.6661 15.4588 76.5774C15.4784 76.4196 15.5988 76.3801 15.6882 76.3124C15.9704 76.0736 16.3199 75.9285 16.6883 75.8971C17.1394 75.8302 17.5976 75.8278 18.0493 75.89C19.2966 75.9137 20.5375 76.0727 21.7504 76.3644L22.445 75.4426C22.4642 75.48 22.4489 75.4504 22.4486 75.4465C22.4482 75.4426 22.4425 75.423 22.4375 75.4109C22.4321 75.3856 22.4284 75.36 22.4265 75.3343C22.4443 75.2538 22.4852 75.1266 22.5971 75.0964C22.71 74.8833 22.8873 74.7113 23.1036 74.6048C23.2354 74.5331 23.3727 74.472 23.5143 74.4221L23.7337 74.3466C23.791 74.3359 23.838 74.3252 23.8915 74.3174C24.1357 74.3341 24.3734 74.4032 24.5885 74.52C24.8036 74.6367 24.9911 74.7985 25.1381 74.9941C25.3622 75.1012 25.5562 75.2623 25.7027 75.4629C26.0589 75.7478 26.3043 75.7404 26.6288 75.9943C26.7406 76.1367 26.8791 76.2559 27.0366 76.3452C27.1132 76.5682 27.288 76.8439 27.3988 77.0932C27.9577 77.6054 28.3441 78.518 28.8285 79.0448C29.059 78.8977 28.5917 78.2861 28.508 77.9488C28.1286 77.4038 28.0489 77.1035 27.7956 76.7677C27.6988 76.6074 27.6692 76.4153 27.7133 76.2334C27.5437 76.0495 27.3962 75.8462 27.2742 75.6278C27.1187 75.5069 27.0075 75.3379 26.9579 75.1473C26.8129 74.9692 26.7627 75.0554 26.5981 74.8392C26.3883 74.4987 25.7967 74.1022 25.75 73.8543C25.5561 73.7807 25.37 73.6879 25.1944 73.5775C24.9137 73.4297 24.7096 73.3008 24.4856 73.1985C24.1557 73.129 23.814 73.1381 23.4883 73.2249C23.079 73.3766 23.1182 73.1505 22.8087 73.2395C22.306 73.4551 21.8587 73.7815 21.5 74.1945C21.2933 74.4455 21.1564 74.7467 21.1032 75.0675C21.0799 75.2329 21.0799 75.4008 21.1032 75.5662C21.1142 75.6481 21.1314 75.7291 21.1549 75.8084C21.1823 75.9039 21.2194 75.9962 21.2657 76.0841L22.0446 75.0511C21.4474 74.9235 20.8411 74.8425 20.2313 74.8089C19.4769 74.6415 18.9622 74.6625 18.2495 74.5624C17.5841 74.5734 16.9199 74.6242 16.2606 74.7145C15.7862 74.8782 15.343 75.1211 14.9498 75.433C14.6892 75.6717 14.5095 75.9857 14.4355 76.3313C14.4012 76.5008 14.3893 76.6741 14.3998 76.8467C14.4128 76.9915 14.4349 77.1354 14.4661 77.2774C14.695 77.8535 14.9794 78.4059 15.3152 78.9269C15.8139 79.6496 16.5886 80.4116 17.0887 81.0267C17.2498 81.2177 17.4392 81.3829 17.6504 81.5165C18.4486 82.5349 19.5877 83.3555 20.6217 84.188C20.7364 84.1584 20.9868 84.3725 21.1392 84.4109C21.474 84.6036 21.4487 84.7372 21.6995 84.9096C21.8908 84.786 22.3264 85.0628 22.699 85.2142C23.1248 85.4707 23.5298 85.7605 23.91 86.0808C23.9642 86.1202 24.0271 86.1459 24.0934 86.1558C24.1597 86.1657 24.2274 86.1596 24.2907 86.1378C24.5411 86.3222 24.8171 86.469 25.11 86.5734L25.1068 86.5773Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.526 63.1392C31.7176 63.1196 31.7244 62.3388 31.828 61.7607C31.9349 61.3528 32.0253 60.8328 32.1329 60.3359C32.1931 60.0413 32.1055 60.1104 32.15 59.8618C32.3117 59.1088 32.3598 58.6757 32.5596 57.8151C32.648 57.0991 32.7891 56.3906 32.9817 55.6954C33.0886 55.1967 33.0832 54.9363 33.1894 54.438C33.2853 54.0682 33.4055 53.7052 33.5491 53.3512C33.5804 52.9238 33.6759 52.3738 33.6823 52.0105C33.7365 51.681 33.8073 51.5763 33.8665 51.3095C33.9174 51.0316 33.8754 50.9533 33.9377 50.6851C33.9997 50.4503 34.0666 50.347 34.13 50.159C34.3601 49.3563 34.7042 48.5908 35.1519 47.8861C35.2868 47.6427 35.4381 47.4088 35.605 47.1861C35.694 47.0704 35.7806 46.9489 35.8768 46.8321L36.1859 46.4923C36.6213 46.0401 37.1049 45.6371 37.6281 45.2904C37.8027 45.1793 37.9862 45.0828 38.1767 45.0019C38.655 44.6869 39.1766 44.4431 39.725 44.2781C40.2472 44.1259 40.7848 44.0327 41.3278 44.0003C41.5542 43.9419 41.7868 43.9113 42.0206 43.9091C42.4356 43.8464 42.573 43.7495 42.9307 43.6954C43.0882 43.6954 43.2453 43.6782 43.399 43.6441C43.5964 43.6843 43.8831 43.705 44.1182 43.7463C44.8262 43.7615 45.5321 43.8273 46.2307 43.9433C46.2453 43.8008 45.5793 43.7235 45.2986 43.6345C44.7201 43.5736 44.4669 43.5055 44.0997 43.4888C43.9518 43.4781 43.8092 43.429 43.6861 43.3463C43.4694 43.3521 43.2525 43.346 43.0364 43.3282C42.8722 43.3513 42.7051 43.3442 42.5435 43.3071C42.3462 43.3103 42.3747 43.3538 42.1431 43.3591C41.7852 43.3899 41.4259 43.4018 41.0667 43.3948C40.9116 43.4451 40.7529 43.4838 40.592 43.5105C40.353 43.5611 40.1749 43.5682 40.0117 43.5889C39.8016 43.6516 39.5889 43.7068 39.3834 43.7855C39.0732 43.9088 39.0985 43.7816 38.8677 43.8646C38.2641 44.1264 37.686 44.4432 37.1405 44.811C36.6232 45.1546 36.1558 45.5679 35.7514 46.0392C35.5355 46.248 35.3382 46.4752 35.1616 46.7181L34.9122 47.0494C34.8353 47.1665 34.7544 47.2862 34.6629 47.413C34.3909 47.8946 34.1437 48.3898 33.9224 48.8966C33.828 49.1816 33.7443 49.5349 33.6161 49.8964L33.2916 51.021C33.2364 51.4484 33.0999 51.9015 32.9867 52.4322C32.841 53.1389 32.691 54.0515 32.5308 54.7119C32.4823 54.9196 32.4511 55.1309 32.4374 55.3438C32.1525 56.4124 32.0004 57.6049 31.812 58.7412C31.8218 58.9002 31.8202 59.0597 31.8074 59.2185C31.7757 59.4326 31.7322 59.6447 31.677 59.854C31.7717 59.9391 31.7251 60.3854 31.7194 60.7302C31.6353 61.2909 31.6342 61.5897 31.5299 62.009C31.5089 62.1164 31.5236 62.2277 31.5716 62.326C31.5277 62.5942 31.5128 62.8664 31.527 63.1378L31.526 63.1392Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.5391 99.1391C39.1551 99.2851 40.1207 102.594 40.7198 105.045L40.9396 106.078L41.2413 105.682C39.6509 105.598 37.793 105.548 35.9947 105.49C34.6917 105.454 35.0426 105.603 33.9484 105.591C30.6166 105.497 28.7303 105.54 24.9102 105.442C21.0758 105.513 19.1325 105.495 15.5514 105.38C14.9698 105.377 14.465 105.38 13.9995 105.391L14.5861 105.851C14.2478 104.584 13.9471 103.6 13.5689 102.022C13.15 100.125 12.8768 98.597 12.6485 97.1811C12.1021 95.4207 11.4809 93.0894 10.9744 91.6265C10.5972 90.2349 10.5669 89.7191 10.2866 88.5711C9.98138 87.3931 9.79616 87.1381 9.49091 85.9605C9.2398 84.9275 9.19244 84.4071 9.01149 83.5508C8.18728 80.1505 7.18426 76.2081 6.44696 72.7534C5.69897 69.8771 4.89185 66.4757 4.05018 62.9843L3.44466 63.7576C5.50591 63.7675 7.60562 63.7739 9.64906 63.7604C10.5808 63.7818 11.8122 63.7626 12.4355 63.826C17.2867 63.6037 23.0249 63.665 27.3194 63.8473C28.4104 63.77 29.1833 63.8135 30.4257 63.8252C30.7819 63.8153 31.095 63.8 31.3671 63.7814L30.7324 63.2614C31.044 64.4169 31.3076 65.0285 31.625 66.2591C31.7534 66.9304 31.9207 67.5935 32.1261 68.2453C32.2219 69.1055 32.4485 70.3433 32.6024 71.3702C33.3236 74.1283 33.9138 77.8246 34.6219 80.4333C34.8659 80.2862 34.1945 77.4908 34.052 76.2331C33.5202 73.7792 33.4031 72.6675 33.0739 71.1209C32.9506 70.5251 32.9117 69.9149 32.9585 69.3082C32.7601 68.3322 32.4759 67.1065 32.4346 66.584C32.2522 65.9073 32.137 65.2142 32.0905 64.5148C31.948 63.7604 31.8768 63.8024 31.7372 63.0591L31.6809 62.7616L31.3657 62.7549L31.1488 62.7502C29.7375 62.6754 27.2122 62.752 26.5974 62.5689C26.2035 62.6213 25.3917 62.6259 24.5383 62.6266C23.5054 62.6188 22.767 62.5707 22.0842 62.5159L19.323 62.5354C17.9247 62.5629 18.2071 62.3616 17.1888 62.3374C12.1242 62.4582 7.89698 62.393 3.44324 62.4539L2.56169 62.466L2.78287 63.2966L3.32927 65.3487C3.9387 68.1128 4.45588 69.9162 4.99834 72.4424C5.51196 74.5796 6.35186 77.5396 6.65924 79.1582C7.39833 81.5547 8.20473 85.0404 8.91461 88.2152C9.42823 89.9962 9.84282 91.9909 10.406 94.2606C11.1539 97.2801 12.1919 101.13 12.8316 103.988C13.0161 104.7 13.2205 105.563 13.3879 106.147L13.5304 106.643L13.9988 106.625C14.2146 106.617 14.3938 106.605 14.5195 106.587C19.275 106.74 24.4443 106.598 29.4017 106.608C29.6681 106.514 30.8955 106.528 31.4348 106.465C32.8663 106.419 33.0907 106.537 34.2226 106.531C34.5257 106.317 36.4566 106.287 37.9337 106.205L41.2402 106.212H41.5209L41.4496 105.939C41.258 105.221 41.0899 104.539 40.9307 103.744C40.8336 103.302 40.6686 102.878 40.4416 102.486C40.3309 101.816 39.8482 100.275 39.5391 99.1391Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.2223 63.1881C13.6048 63.0403 12.9163 60.9537 12.5195 59.3964L12.1342 57.5178L11.6825 55.4658C11.5026 54.6568 11.404 54.9126 11.2501 54.2337C11.0456 53.1929 10.8626 52.3843 10.6706 51.538C10.4683 50.6938 10.3244 49.7987 10.1167 48.6047C9.64979 46.684 9.35583 44.7254 9.23837 42.7523C9.12795 41.371 8.9349 40.6864 8.9178 39.3004C8.92492 38.2795 9.04921 37.2628 9.28823 36.2702C9.30177 35.7964 9.34867 35.3241 9.42857 34.8568C9.46632 34.6252 9.51637 34.3957 9.57852 34.1694C9.60666 34.0604 9.64513 33.9678 9.6754 33.867C9.68933 33.8232 9.70587 33.7802 9.72491 33.7384L9.74877 33.6785C9.75661 33.6586 9.75092 33.6664 9.75092 33.6568L9.85777 33.1357C9.75869 32.8849 9.62398 32.6496 9.45778 32.4372C8.94986 31.6236 8.84229 31.3198 8.44158 30.6794C8.02021 30.0382 7.81113 29.9467 7.43892 29.2991C7.31921 29.0887 7.23758 28.8589 7.19778 28.6202C7.18104 28.5489 7.22413 28.4624 7.19991 28.5892C7.18506 28.6263 7.16291 28.6601 7.13477 28.6884C7.10662 28.7168 7.07306 28.7393 7.03607 28.7545C7.0033 28.7741 6.99404 28.7659 7.02895 28.7769C7.2475 28.8263 7.45845 28.9048 7.65619 29.0102C7.89661 29.1267 8.1431 29.2638 8.39064 29.4084C8.88574 29.6998 9.38546 30.0243 9.87914 30.3613C10.3689 30.6862 10.8421 31.0356 11.2968 31.4081C11.5179 31.5837 11.7278 31.7732 11.9251 31.9752C12.1278 32.1635 12.3204 32.3624 12.5021 32.5711C14.6071 34.5861 16.673 37.8072 18.4928 40.8214C18.7777 41.3379 19.1784 42.0082 19.3227 42.3805C20.211 43.7357 21.0213 45.1404 21.7497 46.5879C22.4884 48.0501 23.1349 49.5087 23.6428 50.7789C23.9724 51.3496 24.2599 51.9435 24.503 52.556C25.0487 53.6064 25.3842 53.8903 25.874 54.7673C26.0468 55.168 26.2546 55.5528 26.4948 55.9171C26.6473 56.4514 26.9483 57.193 27.1613 57.8202C28.0293 59.4206 28.804 61.68 29.5933 63.2117C29.8255 63.0574 29.0458 61.3933 28.8385 60.6093C28.192 59.1432 28.0083 58.45 27.5937 57.5296C27.4362 57.1661 27.3567 56.7737 27.3604 56.3776C27.0993 55.847 26.8671 55.3026 26.6647 54.747C26.4414 54.3566 26.2774 53.9351 26.1782 53.4964C25.9666 53.0041 25.911 53.1045 25.672 52.5229C25.3636 51.6712 24.6035 50.2432 24.5956 49.8118C24.3591 49.4405 24.1496 49.0527 23.9688 48.6513C23.7416 48.1774 23.5415 47.691 23.3693 47.1945L22.5469 45.6272C22.107 44.8461 22.372 44.9116 22.0867 44.3228C21.1428 42.6911 20.2947 41.2118 19.4388 39.792C18.5976 38.3644 17.6747 36.9866 16.6748 35.6654C15.7842 34.3559 14.8042 33.1096 13.7416 31.9353C13.4749 31.647 13.1926 31.3735 12.896 31.116L12.4212 30.7025C12.2592 30.5668 12.0804 30.4443 11.9133 30.3164C11.5728 30.0539 11.2512 29.8366 10.958 29.6339C10.6649 29.4312 10.401 29.2421 10.1901 29.0754L9.01004 28.4236C8.54186 28.151 8.05142 27.9187 7.54399 27.729C7.34938 27.6616 7.14439 27.6291 6.93848 27.6331C6.85235 27.6373 6.76712 27.6525 6.68487 27.6784C6.63124 27.6974 6.57899 27.7201 6.52851 27.7464C6.47178 27.7799 6.41855 27.8191 6.36965 27.8633C6.20871 28.019 6.11263 28.2298 6.10072 28.4535C6.09349 28.6685 6.12734 28.883 6.20045 29.0854C6.2506 29.2337 6.30826 29.3793 6.37321 29.5217C6.61898 30.056 6.89253 30.5233 7.15682 30.9821C7.43678 31.3728 7.71092 31.7833 7.97925 32.2139C8.11282 32.4276 8.24568 32.6509 8.36892 32.8739C8.48276 33.0663 8.57816 33.2691 8.65386 33.4794L8.7796 32.8661C8.71289 32.9536 8.65334 33.0464 8.60151 33.1435C8.55679 33.2197 8.51728 33.2989 8.48326 33.3804C8.41012 33.5324 8.34809 33.6896 8.29767 33.8506C7.62092 35.9486 7.72956 38.5549 7.77195 40.4517C7.7993 41.0455 7.86761 41.6368 7.9764 42.2212C8.11888 45.3006 8.89002 48.5516 9.57924 51.6523C9.75144 52.0546 9.90045 52.4665 10.0255 52.8858C10.2873 53.7656 10.2065 53.9334 10.3835 54.6373C10.6328 54.7737 10.9954 55.9552 11.3224 56.8439C11.5158 57.5994 11.6832 58.1704 11.8253 58.6979C11.9845 59.2187 12.1153 59.7477 12.2171 60.2826C12.2807 60.5695 12.4113 60.8372 12.5983 61.0638C12.6552 61.4976 13.0082 62.4676 13.2234 63.1878L13.2223 63.1881Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.1049 83.2688C41.3079 83.2442 41.2249 82.5543 41.2192 82.0449C41.2516 81.677 41.2434 81.2143 41.2427 80.769C41.2395 80.5058 41.1715 80.5824 41.159 80.3622C41.1512 79.6894 41.0988 79.3122 41.0853 78.541C40.9973 77.9177 40.9562 77.2887 40.9624 76.6592C40.9328 76.2161 40.8602 75.9988 40.831 75.555C40.8251 75.2198 40.8407 74.8845 40.8776 74.5512C40.8029 74.1613 40.7078 73.7757 40.5927 73.3957C40.5389 73.1076 40.5645 72.9993 40.5303 72.761C40.4865 72.517 40.4124 72.4693 40.3636 72.2267C40.328 72.013 40.3441 71.904 40.3234 71.728C40.1895 71.0277 39.9747 70.2284 39.8176 69.5231C39.4946 68.4631 39.0962 67.4274 38.6255 66.4242C38.5389 66.2541 38.4635 66.0786 38.3996 65.8988C37.892 65.0774 37.6553 64.1172 37.7229 63.154C37.6851 62.9555 37.6775 62.7524 37.7004 62.5516C37.6823 62.1897 37.5961 62.0611 37.5786 61.7473C37.5959 61.611 37.5935 61.473 37.5715 61.3373C37.6345 61.1724 37.6784 60.9263 37.7411 60.7286C37.8208 60.1184 37.9429 59.5145 38.1065 58.9212C37.9701 58.8888 37.8433 59.4595 37.7321 59.6917C37.6253 60.1865 37.5337 60.397 37.4828 60.7136C37.4584 60.8427 37.3965 60.9616 37.3047 61.0556C37.2896 61.2442 37.2627 61.4317 37.2242 61.617C37.23 61.7627 37.2063 61.908 37.1548 62.0444C37.1394 62.2161 37.1882 62.1958 37.163 62.397C37.1603 62.7118 37.1365 63.0261 37.0917 63.3378C37.1571 63.6461 37.1847 63.9613 37.174 64.2763L37.3108 64.8402C37.3988 65.1202 37.2958 65.0895 37.3485 65.3011C37.4571 65.5819 37.5805 65.8567 37.7182 66.1243C37.8411 66.379 37.9629 66.5948 38.0719 66.8292C38.2931 67.2887 38.488 67.7432 38.706 68.2184C38.8712 68.7555 39.0265 69.0953 39.1409 69.5969C39.2949 70.0282 39.418 70.4699 39.5092 70.9187C39.711 71.5054 39.8398 72.1147 39.8928 72.7328C39.977 73.1375 40.0355 73.5471 40.0676 73.9592C40.1478 74.5705 40.2457 75.3637 40.2657 75.9568C40.2736 76.142 40.2991 76.326 40.3419 76.5064C40.3419 77.4681 40.4993 78.5011 40.5756 79.496C40.6269 79.5455 40.6397 79.7927 40.6799 79.8985C40.6963 80.0855 40.7007 80.2733 40.6931 80.4609C40.8046 80.5129 40.8516 80.8998 40.9164 81.1929C40.9606 81.5646 40.9764 81.9391 40.9638 82.3132C40.9618 82.4091 40.994 82.5027 41.0546 82.5771C41.0526 82.8103 41.0685 83.0434 41.1024 83.2742L41.1049 83.2688Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.3291 43.3841C53.624 43.6691 54.1643 43.0557 54.6374 42.687C55.0687 42.4258 55.4816 42.1354 55.8733 41.8179C56.1173 41.6266 55.9531 41.5793 56.1454 41.4058C56.684 40.9851 56.9707 40.671 57.5057 40.2182L57.6817 40.0693L57.6493 39.7456L57.6158 39.4122C57.3968 38.7048 57.2692 37.9723 57.2361 37.2326C57.146 36.7193 56.9868 36.4846 56.8963 35.9724C56.8707 35.7169 56.866 35.4599 56.8824 35.2037L56.3324 35.9998C56.4803 36.014 56.6174 36.0354 56.7538 36.0575C57.1967 35.9082 57.6317 35.7364 58.0571 35.5428C58.3019 35.5033 58.5496 35.4842 58.7976 35.4858C59.079 35.4252 59.1278 35.2967 59.4092 35.2365C59.606 35.225 59.8035 35.2304 59.9994 35.2525C60.8601 35.0939 61.729 34.9831 62.602 34.9205C63.6862 34.6826 65.1021 34.5615 66.3968 34.315C66.6147 34.2766 66.8362 34.2627 67.0572 34.2736C67.3308 34.1739 67.6099 34.0898 67.8931 34.0218L67.2609 33.6603C67.6407 34.4633 67.9206 35.3099 68.0944 36.1811C68.23 36.3873 68.3266 36.6167 68.3793 36.8579C68.5873 37.2497 68.8189 37.3174 69.0326 37.6326C69.0883 37.7899 69.1802 37.9319 69.3008 38.0472C69.329 38.299 69.3729 38.5489 69.4322 38.7952C69.8283 39.363 70.0092 40.2407 70.4082 40.7696C70.65 40.6514 70.3013 40.0572 70.2974 39.7402C70.0481 39.2009 70.0481 38.9181 69.897 38.5765C69.8736 38.4952 69.8681 38.4098 69.8807 38.3261C69.8934 38.2424 69.924 38.1625 69.9704 38.0917C69.866 37.898 69.7932 37.6889 69.7546 37.4723C69.7042 37.4027 69.6682 37.3238 69.6487 37.2401C69.6292 37.1564 69.6265 37.0697 69.641 36.985C69.58 36.7962 69.501 36.8547 69.4433 36.6288C69.3923 36.2908 69.1049 35.7622 69.2231 35.5602C69.1183 35.4328 69.0401 35.2856 68.9931 35.1275C68.927 34.9408 68.891 34.7448 68.8862 34.5469L68.6319 33.9456C68.4869 33.6474 68.6985 33.6368 68.634 33.4038L68.5183 33.1723L68.2105 32.5571L67.6737 32.6896C66.4321 32.996 65.3756 33.0786 64.2487 33.3821C63.5776 33.4216 63.1516 33.5627 62.5372 33.5844C62.0065 33.7111 61.4678 33.8012 60.9247 33.854C60.2231 34.0867 59.491 34.2144 58.752 34.233C58.2744 34.3471 57.7892 34.4269 57.3002 34.4721C56.9369 34.5337 56.5259 34.6241 56.1187 34.7054L55.442 34.84L55.5923 35.4673C55.6886 35.8439 55.7625 36.226 55.8135 36.6114C55.8431 36.8284 55.9074 37.0392 56.004 37.2358C56.1053 38.1614 56.2806 39.0774 56.5284 39.975L56.6993 39.4107C56.5308 39.5888 56.3616 39.7619 56.1893 39.9304C56.211 40.0416 55.9951 40.2357 55.9488 40.37C55.7415 40.6414 55.6208 40.5951 55.4352 40.7878C55.5353 40.9901 55.2329 41.3331 55.0434 41.6373C54.7505 41.9666 54.4162 42.2567 54.0489 42.5004C54.002 42.5384 53.9656 42.5879 53.9432 42.644C53.9208 42.7001 53.9132 42.7611 53.9211 42.821C53.7572 42.8826 53.5268 43.1914 53.327 43.3856L53.3291 43.3841Z",
    fill: "#2F426C"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecipientsGrayscale);
export default __webpack_public_path__ + "static/media/recipients-grayscale.e413b1183cc3be5cfe241b34081d6dde.svg";
export { ForwardRef as ReactComponent };